// src/components/customer-notification/customer-notification.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toArray(arr) {
    return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment NotificationActionFragment on NotificationAction {\n    __typename\n    ... on NotificationAnalytics {\n      description\n      referrerId\n      schema {\n        __typename\n        name\n        messageContent {\n          __typename\n          name\n          value\n        }\n      }\n    }\n    ... on NotificationAnalyticsEgClickstream {\n      __typename\n      description\n      event {\n        __typename\n        eventName\n        eventType\n        eventCategory\n        eventVersion\n        actionLocation\n      }\n      schema {\n        name\n        messageContent {\n          name\n          value\n        }\n      }\n    }\n    ... on NotificationCookie {\n      name\n      value\n      expires\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  mutation SendTextToDownloadAppMutation($context: ContextInput!, $placementId: String!, $customerInput: NotificationUserInput!) {\n    sendTextToDownloadApp(context: $context, placementId: $placementId, customerInput: $customerInput) {\n      messageType\n      messageBody\n      invalidFields\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  fragment TitleParts on NotificationPhrase {\n    accessibilityLabel\n    completeText\n    egdsItems {\n      ... on NotificationEGDSTextNode {\n        text\n        theme\n        weight\n      }\n      ... on NotificationEGDSLinkNode {\n        action {\n          accessibility\n          analytics {\n            linkName\n            referrerId\n          }\n          resource {\n            value\n          }\n          target\n        }\n      }\n    }\n  }\n\n  fragment NotificationActionFragment on NotificationAction {\n    __typename\n    ... on NotificationAnalytics {\n      description\n      referrerId\n      schema {\n        __typename\n        name\n        messageContent {\n          __typename\n          name\n          value\n        }\n      }\n    }\n    ... on NotificationAnalyticsEgClickstream {\n      __typename\n      description\n      event {\n        __typename\n        eventName\n        eventType\n        eventCategory\n        eventVersion\n        actionLocation\n      }\n      schema {\n        name\n        messageContent {\n          name\n          value\n        }\n      }\n    }\n    ... on NotificationCookie {\n      name\n      value\n      expires\n    }\n  }\n\n  query NotificationsQuery(\n    $context: ContextInput!\n    $notificationLocation: NotificationLocationOnPage!\n    $lineOfBusiness: LineOfBusinessDomain!\n    $pageLocation: PageLocation!\n    $optionalPageId: String\n    $optionalContext: NotificationOptionalContextInput\n  ) {\n    notification(context: $context) {\n      inlineNotification(\n        notificationLocation: $notificationLocation\n        lineOfBusiness: $lineOfBusiness\n        pageLocation: $pageLocation\n        optionalPageId: $optionalPageId\n        optionalContext: $optionalContext\n      ) {\n        type\n        notificationLocation\n        theme {\n          __typename\n          ... on NotificationCardTheme {\n            themeValue\n            cardBorder\n          }\n        }\n        switch {\n          enabled\n          checked\n          checkedLabel\n          checkedDescription\n          checkedAccessibilityLabel\n          uncheckedLabel\n          uncheckedDescription\n          uncheckedAccessibilityLabel\n          label\n          checkedAnalytics {\n            referrerId\n            linkName\n          }\n          uncheckedAnalytics {\n            referrerId\n            linkName\n          }\n        }\n        title {\n          accessibilityLabel\n          completeText\n          egdsItems {\n            ... on NotificationEGDSTextNode {\n              text\n              theme\n              weight\n            }\n            ... on NotificationEGDSLinkNode {\n              action {\n                accessibility\n                analytics {\n                  linkName\n                  referrerId\n                }\n                resource {\n                  value\n                }\n                target\n              }\n            }\n          }\n          items {\n            __typename\n            text\n            styles\n            ... on NotificationPhraseLinkNode {\n              id\n              type\n              uri {\n                __typename\n                value\n              }\n              target\n              actions {\n                ...NotificationActionFragment\n              }\n            }\n          }\n        }\n        body {\n          accessibilityLabel\n          egdsItems {\n            ... on NotificationEGDSTextNode {\n              text\n              theme\n              weight\n            }\n            ... on NotificationEGDSLinkNode {\n              action {\n                accessibility\n                analytics {\n                  linkName\n                  referrerId\n                }\n                resource {\n                  value\n                }\n                target\n              }\n            }\n          }\n          items {\n            __typename\n            text\n            styles\n            ... on NotificationPhraseLinkNode {\n              id\n              type\n              uri {\n                __typename\n                value\n              }\n              icon {\n                id\n                description\n                title\n              }\n              actions {\n                ...NotificationActionFragment\n              }\n            }\n          }\n        }\n        subBody {\n          ... on NotificationSimpleBody {\n            title {\n              ...TitleParts\n            }\n          }\n          ... on NotificationMultiBody {\n            title {\n              ...TitleParts\n            }\n            body {\n              ...TitleParts\n            }\n          }\n          ... on NotificationMessageCard {\n            title {\n              ...TitleParts\n            }\n            body {\n              ...TitleParts\n            }\n            graphicElement {\n              ... on Icon {\n                description\n                id\n                size\n                theme\n                title\n                token\n                withBackground\n              }\n              ... on Mark {\n                description\n                id\n                markSize: size\n                url {\n                  ... on HttpURI {\n                    relativePath\n                    value\n                  }\n                }\n              }\n              ... on Illustration {\n                description\n                id\n                link: url\n              }\n            }\n            links {\n              id\n              text\n              type\n              uri {\n                value\n              }\n              linkStyle\n              linkTheme\n              target\n              actions {\n                ... on NotificationAnalytics {\n                  description\n                  referrerId\n                  schema {\n                    name\n                    messageContent {\n                      name\n                      value\n                    }\n                  }\n                }\n                ... on NotificationCookie {\n                  name\n                  value\n                  expires\n                }\n              }\n            }\n            layout\n          }\n        }\n        legalText {\n          accessibilityLabel\n          items {\n            __typename\n            text\n            styles\n            ... on NotificationPhraseLinkNode {\n              id\n              type\n              uri {\n                __typename\n                value\n              }\n              target\n              actions {\n                ...NotificationActionFragment\n              }\n            }\n          }\n        }\n        containerLink {\n          uri {\n            __typename\n            value\n          }\n          target\n          actions {\n            ...NotificationActionFragment\n          }\n        }\n        icon {\n          description\n          id\n          title\n        }\n        logo {\n          description\n          url\n        }\n        links {\n          id\n          type\n          text\n          uri {\n            __typename\n            value\n          }\n          linkStyle\n          linkTheme\n          icon {\n            id\n            description\n            title\n          }\n          actions {\n            ...NotificationActionFragment\n          }\n        }\n        attributes {\n          name\n          value\n        }\n        dismiss {\n          icon {\n            id\n            description\n            title\n          }\n          actions {\n            ...NotificationActionFragment\n          }\n        }\n        revealActions {\n          ...NotificationActionFragment\n        }\n        backgroundImage {\n          url\n          description\n        }\n        customQrCode {\n          __typename\n          image {\n            url\n            description\n          }\n          title\n        }\n        form {\n          __typename\n          title\n          sections {\n            __typename\n            title\n            fields {\n              __typename\n              ... on NotificationTextInputField {\n                label\n                id\n                placeholder\n                icon {\n                  id\n                  description\n                  title\n                }\n              }\n              ... on NotificationSubmitButton {\n                label\n                id\n                actions {\n                  ...NotificationActionFragment\n                }\n                icon {\n                  id\n                  description\n                  title\n                }\n                buttonType\n              }\n              ... on NotificationSelectionField {\n                label\n                id\n                options {\n                  __typename\n                  id\n                  text\n                  shortLabel\n                  value\n                  selected\n                  icon {\n                    id\n                    description\n                    title\n                  }\n                }\n              }\n            }\n          }\n          feedbackMessages {\n            __typename\n            name\n            title\n            text\n            displayType\n            level\n          }\n          successFormAnalytics {\n            ...NotificationActionFragment\n          }\n          errorFormAnalytics {\n            ...NotificationActionFragment\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import React58 from "react";
import { useQuery } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
// ../internal/src/utils/is-numeric.ts
var isNumeric = function(val) {
    return !Number.isNaN(Number(val));
};
// ../internal/src/utils/set-value-by-keypath.ts
var stringToPath = function(path) {
    return path.split(".").map(function(part) {
        var indexPart = part.match(/^\[(\d+)\]$/);
        return indexPart ? indexPart[1] : part;
    });
};
var setValueByKeyPath = function(obj, path, value) {
    var parts = Array.isArray(path) ? path : stringToPath(path);
    var _parts = _toArray(parts), current = _parts[0], nextParts = _parts.slice(1);
    if (!Object.prototype.hasOwnProperty.call(obj, current)) {
        if (nextParts.length) {
            obj[current] = isNumeric(nextParts[0]) ? [] : {};
        } else {
            obj[current] = value;
        }
    }
    if (nextParts.length) {
        setValueByKeyPath(obj[current], nextParts, value);
    }
};
// ../internal/src/notification-action-executor/notification-action-fragment.ts
import { gql } from "@apollo/client";
var NotificationActionFragment = gql(_templateObject());
// ../internal/src/notification-action-executor/build-egclickstream-data.ts
var buildEgClickstreamData = function(param) {
    var event = param.event, schema = param.schema;
    var _event_actionLocation;
    var data = {
        event: {
            event_name: event.eventName,
            event_type: event.eventType,
            event_category: event.eventCategory,
            event_version: event.eventVersion,
            action_location: (_event_actionLocation = event.actionLocation) !== null && _event_actionLocation !== void 0 ? _event_actionLocation : ""
        }
    };
    schema === null || schema === void 0 ? void 0 : schema.forEach(function(param) {
        var schemaName = param.name, messageContent = param.messageContent;
        messageContent.forEach(function(param) {
            var name = param.name, value = param.value;
            setValueByKeyPath(data, "".concat(schemaName, ".").concat(name), value);
        });
    });
    return data;
};
// ../internal/src/notification-action-executor/get-uis-events.ts
var getUisEvents = function(action) {
    var _action_schema;
    var events = [];
    (_action_schema = action.schema) === null || _action_schema === void 0 ? void 0 : _action_schema.forEach(function(schema) {
        var result = {};
        schema.messageContent.forEach(function(param) {
            var name = param.name, value = param.value;
            var nameParts = name.split(".");
            if (nameParts.length === 1) {
                result[name.replace(/\s/g, "-")] = value;
            } else {
                var currentValue = result[nameParts[0]];
                if (!currentValue) {
                    result[nameParts[0]] = [
                        _defineProperty({}, nameParts[1], isNumeric(value) ? Number.parseInt(value, 10) : value)
                    ];
                } else {
                    var newValue = _objectSpreadProps(_objectSpread({}, currentValue[0]), _defineProperty({}, nameParts[1], isNumeric(value) ? Number.parseInt(value, 10) : value));
                    result[nameParts[0]] = [
                        newValue
                    ];
                }
            }
        });
        events.push({
            schemaName: schema.name,
            messageContent: result
        });
    });
    return events;
};
// ../internal/src/notification-action-executor/use-notification-action-executor.ts
import { useCallback, useMemo } from "react";
import { useClickTracker, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
var useNotificationActionExecutor = function() {
    var analyticsTracker = useClickTracker();
    var egClickstreamTracker = useEgClickstream();
    var actionExecutors = useMemo(function() {
        return {
            NotificationCookie: function NotificationCookie(action) {
                document.cookie = "".concat(action.name, "=").concat(action.value, "; path=/; expires=").concat(action.expires);
            },
            NotificationAnalyticsEgClickstream: function NotificationAnalyticsEgClickstream(action) {
                egClickstreamTracker(buildEgClickstreamData(action));
            },
            NotificationAnalytics: function NotificationAnalytics(action) {
                analyticsTracker(action.referrerId, action.description || "", void 0, getUisEvents(action));
            }
        };
    }, [
        analyticsTracker,
        egClickstreamTracker
    ]);
    return useCallback(function(actions) {
        actions === null || actions === void 0 ? void 0 : actions.forEach(function(action) {
            var _actionExecutors_action___typename;
            (_actionExecutors_action___typename = actionExecutors[action.__typename]) === null || _actionExecutors_action___typename === void 0 ? void 0 : _actionExecutors_action___typename.call(actionExecutors, action);
        });
    }, [
        actionExecutors
    ]);
};
// src/__generated__/globalTypes.ts
var NotificationLocationOnPage = /* @__PURE__ */ function(NotificationLocationOnPage4) {
    NotificationLocationOnPage4["AFTER_HEADER"] = "AFTER_HEADER";
    NotificationLocationOnPage4["AFTER_WIZARD"] = "AFTER_WIZARD";
    NotificationLocationOnPage4["ERROR"] = "ERROR";
    NotificationLocationOnPage4["FOOTER"] = "FOOTER";
    NotificationLocationOnPage4["IN_PAGE"] = "IN_PAGE";
    NotificationLocationOnPage4["IN_PAGE_AD"] = "IN_PAGE_AD";
    NotificationLocationOnPage4["LEGAL"] = "LEGAL";
    NotificationLocationOnPage4["POPUP"] = "POPUP";
    NotificationLocationOnPage4["PRE_HEADER"] = "PRE_HEADER";
    return NotificationLocationOnPage4;
}(NotificationLocationOnPage || {});
var TripScheduleChangeStatus = /* @__PURE__ */ function(TripScheduleChangeStatus2) {
    TripScheduleChangeStatus2["FLIGHT_SCHEDULE_CHANGE"] = "FLIGHT_SCHEDULE_CHANGE";
    TripScheduleChangeStatus2["NO_CHANGE"] = "NO_CHANGE";
    return TripScheduleChangeStatus2;
}(TripScheduleChangeStatus || {});
// src/components/app-hero-banner/app-hero-banner-wrapper.tsx
import React2 from "react";
// src/components/app-hero-banner/mad-hero.tsx
import React from "react";
import { UitkButtonSize, UitkOverlayButton, UitkPrimaryButton } from "uitk-react-button";
import { UitkIcon } from "uitk-react-icons";
import { UitkFigure } from "uitk-react-images";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
// src/components/customer-notification/helpers/create-deep-link-url.ts
var createDeepLinkUrl = function(linkUrl, referer) {
    if (!linkUrl) {
        return void 0;
    }
    var deepLinkUrl = new URL(linkUrl);
    return deepLinkUrl.searchParams.has("$canonical_url") || !referer ? "".concat(deepLinkUrl) : "".concat(deepLinkUrl, "&").concat(encodeURIComponent("$canonical_url"), "=").concat(encodeURIComponent(referer));
};
// src/components/app-hero-banner/mad-hero.tsx
var MADHero = function(param) {
    var title = param.title, revealActions = param.revealActions, logo = param.logo, tuneLink = param.tuneLink, dismiss = param.dismiss, referer = param.referer;
    var _tuneLink_uri;
    var _React_useState = _slicedToArray(React.useState(true), 2), display = _React_useState[0], setDisplay = _React_useState[1];
    var customerNotificationActionsExecutor = useNotificationActionExecutor();
    React.useEffect(function() {
        customerNotificationActionsExecutor(revealActions);
    }, []);
    var onClickDismiss = function() {
        setDisplay(false);
        customerNotificationActionsExecutor(dismiss.actions);
    };
    var onClickButton = function() {
        customerNotificationActionsExecutor(tuneLink === null || tuneLink === void 0 ? void 0 : tuneLink.actions);
    };
    if (!display) return null;
    var deepLinkUrl = createDeepLinkUrl(tuneLink === null || tuneLink === void 0 ? void 0 : (_tuneLink_uri = tuneLink.uri) === null || _tuneLink_uri === void 0 ? void 0 : _tuneLink_uri.value, referer);
    var src = "data:image/svg+xml,".concat(encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg"><linearGradient id="g" gradientTransform="rotate(45)"><stop offset="0%" stop-color="#212841"  /><stop offset="54.45%" stop-color="#184268" /><stop offset="100%" stop-color="#0576B6" /></linearGradient><rect width="100%" height="150%" fill="url(#g)" /></svg>'));
    return /* @__PURE__ */ React.createElement(UitkSpacing, {
        padding: "six"
    }, /* @__PURE__ */ React.createElement(UitkFigure, {
        src: src
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlex, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, {
        alignSelf: "end"
    }, /* @__PURE__ */ React.createElement(UitkOverlayButton, {
        onClick: onClickDismiss,
        "aria-label": dismiss.icon.description
    }, /* @__PURE__ */ React.createElement(UitkIcon, {
        name: "close"
    }))), /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, {
        alignSelf: "center"
    }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("img", {
        alt: logo.description,
        src: logo.url,
        width: "64",
        height: "64"
    }))), /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React.createElement(UitkSpacing, {
        margin: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React.createElement("div", null, title.items.map(function(param, index) {
        var text = param.text;
        return /* @__PURE__ */ React.createElement(UitkText, {
            key: "text-element-".concat(index),
            theme: "inverse",
            align: "center",
            size: 700,
            weight: "medium"
        }, text);
    })))), (tuneLink === null || tuneLink === void 0 ? void 0 : tuneLink.uri) && /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, {
        alignSelf: "center"
    }, /* @__PURE__ */ React.createElement(UitkSpacing, {
        margin: {
            blockstart: "six",
            blockend: "three"
        }
    }, /* @__PURE__ */ React.createElement(UitkPrimaryButton, {
        inverse: true,
        href: deepLinkUrl,
        size: UitkButtonSize.LARGE,
        onClick: onClickButton
    }, tuneLink.text))))));
};
// src/components/app-hero-banner/app-hero-banner-wrapper.tsx
var AppHeroBannerWrapper = function(props) {
    var _ref = props || {}, _ref_data = _ref.data, title = _ref_data.title, logo = _ref_data.logo, links = _ref_data.links, dismiss = _ref_data.dismiss, revealActions = _ref_data.revealActions, optionalContext = _ref.inputs.optionalContext;
    if (!title || !logo || !dismiss) {
        return null;
    }
    var tuneLink;
    var termsLink;
    links === null || links === void 0 ? void 0 : links.forEach(function(link) {
        if (link.type === "APP_DOWNLOAD_LINK" /* APP_DOWNLOAD_LINK */ ) {
            tuneLink = link;
        } else {
            termsLink = link;
        }
    });
    return /* @__PURE__ */ React2.createElement(MADHero, {
        title: title,
        logo: logo,
        tuneLink: tuneLink,
        revealActions: revealActions,
        dismiss: dismiss,
        referer: optionalContext === null || optionalContext === void 0 ? void 0 : optionalContext.referer
    });
};
// src/components/bottom-sheet/bottom-sheet-wrapper.tsx
import React4 from "react";
// src/components/bottom-sheet/bottom-sheet.tsx
import React3 from "react";
import { useApolloClient } from "@apollo/client";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkButtonSize as UitkButtonSize2, UitkOverlayButton as UitkOverlayButton2 } from "uitk-react-button";
import { UitkIcon as UitkIcon2, UitkIconSize } from "uitk-react-icons";
import { UitkFigure as UitkFigure2, UitkFigureAspectRatioType, UitkImage } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkLink } from "uitk-react-link";
import { UitkSheet, UitkSheetContent } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkText as UitkText2 } from "uitk-react-text";
import { UitkViewRow } from "uitk-react-view";
// src/components/customer-notification/helpers/cache-eviction.ts
var cacheEviction = function(apolloCache, type, notificationLocation) {
    var pageLocation = notificationLocation || "PRE_HEADER" /* PRE_HEADER */ ;
    var cacheId = apolloCache.identify({
        type: type,
        notificationLocation: pageLocation,
        __typename: "InlineNotification"
    });
    apolloCache.evict({
        id: cacheId
    });
    apolloCache.gc();
};
// src/components/helpers/common-button-sheet-dictionary.tsx
import { UitkPrimaryButton as UitkPrimaryButton2, UitkSecondaryButton } from "uitk-react-button";
var _obj;
var CTA_DICTIONARY = (_obj = {}, _defineProperty(_obj, "PRIMARY_BUTTON" /* PRIMARY_BUTTON */ , UitkPrimaryButton2), _defineProperty(_obj, "SECONDARY_BUTTON" /* SECONDARY_BUTTON */ , UitkSecondaryButton), _obj);
var getButtonComponent = function(buttonType) {
    return CTA_DICTIONARY["".concat(buttonType)] || UitkPrimaryButton2;
};
// src/components/bottom-sheet/bottom-sheet.tsx
var BottomSheet = function(param) {
    var type = param.type, notificationLocation = param.notificationLocation, body = param.body, title = param.title, logo = param.logo, dismiss = param.dismiss, qrCodeUrl = param.qrCodeUrl, qrCodeDesc = param.qrCodeDesc, qrCodeTitle = param.qrCodeTitle, bannerLink = param.bannerLink, revealActions = param.revealActions, referer = param.referer, termsAndConditions = param.termsAndConditions, dismissCallback = param.dismissCallback;
    var _body__items, _body__items_, _dismiss_icon, _dismiss_icon1, _title_items_, _title_items_1, _body__items1, _body__items_1;
    var _React3_useState = _slicedToArray(React3.useState(true), 2), display = _React3_useState[0], setDisplay = _React3_useState[1];
    var cache = useApolloClient().cache;
    var customerNotificationActionsExecutor = useNotificationActionExecutor();
    var triggerRef = React3.useRef(null);
    var memoizedImpressionLogger = React3.useCallback(function() {
        if (display) {
            customerNotificationActionsExecutor(revealActions);
        }
        return display;
    }, [
        display
    ]);
    var onClickDismiss = React3.useCallback(function() {
        dismissCallback === null || dismissCallback === void 0 ? void 0 : dismissCallback();
        customerNotificationActionsExecutor(dismiss === null || dismiss === void 0 ? void 0 : dismiss.actions);
        cacheEviction(cache, type, notificationLocation);
        setDisplay(false);
    }, []);
    var onClickButton = React3.useCallback(function() {
        customerNotificationActionsExecutor(bannerLink === null || bannerLink === void 0 ? void 0 : bannerLink.actions);
    }, []);
    var deepLinkUrl = React3.useMemo(function() {
        var _bannerLink_uri;
        return createDeepLinkUrl(bannerLink === null || bannerLink === void 0 ? void 0 : (_bannerLink_uri = bannerLink.uri) === null || _bannerLink_uri === void 0 ? void 0 : _bannerLink_uri.value, referer);
    }, []);
    var ButtonComponent = React3.useMemo(function() {
        return getButtonComponent(bannerLink === null || bannerLink === void 0 ? void 0 : bannerLink.type);
    }, []);
    var qrCodeEnabled = qrCodeUrl && qrCodeTitle;
    return /* @__PURE__ */ React3.createElement(React3.Fragment, null, display && memoizedImpressionLogger() && /* @__PURE__ */ React3.createElement(Viewport, null, /* @__PURE__ */ React3.createElement(ViewSmall, null, /* @__PURE__ */ React3.createElement(UitkSheet, {
        isVisible: display,
        type: "bottom",
        triggerRef: triggerRef
    }, /* @__PURE__ */ React3.createElement(UitkViewRow, {
        canvasTheme: "brand_promo_primary",
        layout: "fullwidth"
    }, /* @__PURE__ */ React3.createElement(UitkSpacing2, {
        margin: {
            blockstart: "three",
            blockend: "six",
            inline: "two"
        }
    }, /* @__PURE__ */ React3.createElement(UitkSheetContent, {
        padded: false,
        fullSheetContentMaxWidth: "extra-large"
    }, /* @__PURE__ */ React3.createElement(UitkLayoutFlex2, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem2, {
        alignSelf: "end"
    }, /* @__PURE__ */ React3.createElement(UitkSpacing2, {
        margin: {
            blockstart: "one",
            blockend: "four",
            inlineend: "one"
        }
    }, /* @__PURE__ */ React3.createElement(UitkOverlayButton2, {
        onClick: onClickDismiss,
        "aria-label": "close"
    }, /* @__PURE__ */ React3.createElement(UitkIcon2, {
        name: "close",
        size: UitkIconSize.MEDIUM,
        theme: "primary",
        title: "Close Sheet",
        id: "sheet-close-button"
    })))), /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem2, {
        alignSelf: "center"
    }, /* @__PURE__ */ React3.createElement("img", {
        alt: logo === null || logo === void 0 ? void 0 : logo.description,
        src: logo === null || logo === void 0 ? void 0 : logo.url,
        width: 56
    })), /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem2, {
        alignSelf: "center"
    }, /* @__PURE__ */ React3.createElement(UitkSpacing2, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React3.createElement(UitkText2, {
        theme: "inverse",
        align: "center",
        weight: "medium",
        size: 600
    }, (_body__items = body === null || body === void 0 ? void 0 : body[0].items) === null || _body__items === void 0 ? void 0 : (_body__items_ = _body__items[0]) === null || _body__items_ === void 0 ? void 0 : _body__items_.text))), (bannerLink === null || bannerLink === void 0 ? void 0 : bannerLink.uri) && deepLinkUrl && (bannerLink === null || bannerLink === void 0 ? void 0 : bannerLink.text) && /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem2, {
        alignSelf: "center"
    }, /* @__PURE__ */ React3.createElement(UitkSpacing2, {
        margin: {
            blockstart: "six",
            blockend: "four"
        }
    }, /* @__PURE__ */ React3.createElement(ButtonComponent, {
        href: deepLinkUrl,
        size: UitkButtonSize2.LARGE,
        onClick: onClickButton
    }, bannerLink.text))), (termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.text) && (termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.uri) && /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React3.createElement(UitkSpacing2, {
        margin: {
            blockstart: "two",
            blockend: "four",
            inline: "one"
        }
    }, /* @__PURE__ */ React3.createElement(UitkLink, {
        align: "center",
        size: "small",
        theme: "inverse",
        inline: true
    }, /* @__PURE__ */ React3.createElement("a", {
        href: termsAndConditions.uri.value,
        target: "_blank",
        rel: "noopener noreferrer"
    }, termsAndConditions.text)))))))))), /* @__PURE__ */ React3.createElement(ViewMedium, null, /* @__PURE__ */ React3.createElement(UitkSheet, {
        isVisible: display,
        type: "bottom",
        triggerRef: triggerRef
    }, /* @__PURE__ */ React3.createElement(UitkViewRow, {
        canvasTheme: "brand_promo_primary",
        layout: "fullwidth"
    }, /* @__PURE__ */ React3.createElement(UitkSpacing2, {
        margin: {
            inlinestart: "one",
            inlineend: "two",
            blockstart: "three",
            blockend: "six"
        }
    }, /* @__PURE__ */ React3.createElement(UitkSheetContent, {
        padded: false,
        fullSheetContentMaxWidth: "extra-large"
    }, /* @__PURE__ */ React3.createElement(UitkLayoutFlex2, {
        direction: "row-reverse"
    }, /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React3.createElement(UitkSpacing2, {
        margin: {
            inlineend: "one",
            blockstart: "one"
        }
    }, /* @__PURE__ */ React3.createElement(UitkOverlayButton2, {
        name: dismiss === null || dismiss === void 0 ? void 0 : (_dismiss_icon = dismiss.icon) === null || _dismiss_icon === void 0 ? void 0 : _dismiss_icon.id,
        onClick: onClickDismiss,
        "aria-label": "close"
    }, /* @__PURE__ */ React3.createElement(UitkIcon2, {
        name: "close",
        size: UitkIconSize.EXTRA_SMALL,
        theme: "primary",
        description: dismiss === null || dismiss === void 0 ? void 0 : (_dismiss_icon1 = dismiss.icon) === null || _dismiss_icon1 === void 0 ? void 0 : _dismiss_icon1.description,
        id: "sheet-close-button"
    }))))), /* @__PURE__ */ React3.createElement(UitkLayoutGrid, {
        columns: 10
    }, /* @__PURE__ */ React3.createElement(UitkLayoutGridItem, {
        colSpan: qrCodeEnabled ? 8 : 10
    }, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(UitkLayoutGrid, {
        columns: qrCodeEnabled ? 8 : 10
    }, /* @__PURE__ */ React3.createElement(UitkLayoutGridItem, {
        colSpan: 1,
        alignSelf: "center"
    }, /* @__PURE__ */ React3.createElement(UitkSpacing2, {
        padding: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React3.createElement("img", {
        src: logo === null || logo === void 0 ? void 0 : logo.url,
        alt: logo === null || logo === void 0 ? void 0 : logo.description,
        height: 45
    }))), ((_title_items_ = title === null || title === void 0 ? void 0 : title.items[0]) === null || _title_items_ === void 0 ? void 0 : _title_items_.text) && /* @__PURE__ */ React3.createElement(UitkLayoutGridItem, {
        colSpan: qrCodeEnabled ? 7 : 9,
        alignSelf: "center"
    }, /* @__PURE__ */ React3.createElement(UitkSpacing2, {
        padding: {
            block: "two"
        }
    }, /* @__PURE__ */ React3.createElement(UitkText2, {
        theme: "inverse",
        align: "left",
        size: 600,
        weight: "bold"
    }, (_title_items_1 = title === null || title === void 0 ? void 0 : title.items[0]) === null || _title_items_1 === void 0 ? void 0 : _title_items_1.text)))), /* @__PURE__ */ React3.createElement(UitkLayoutGrid, null, /* @__PURE__ */ React3.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React3.createElement(UitkSpacing2, {
        padding: {
            block: "three",
            inlineend: "four",
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React3.createElement(UitkText2, {
        theme: "inverse",
        weight: "medium",
        size: 500
    }, (_body__items1 = body === null || body === void 0 ? void 0 : body[0].items) === null || _body__items1 === void 0 ? void 0 : (_body__items_1 = _body__items1[0]) === null || _body__items_1 === void 0 ? void 0 : _body__items_1.text)))), (bannerLink === null || bannerLink === void 0 ? void 0 : bannerLink.text) && deepLinkUrl && (bannerLink === null || bannerLink === void 0 ? void 0 : bannerLink.linkTheme) !== "INVERSE" /* INVERSE */  && /* @__PURE__ */ React3.createElement(UitkLayoutGrid, {
        columns: 10
    }, /* @__PURE__ */ React3.createElement(UitkLayoutGridItem, {
        colSpan: 5
    }, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(UitkSpacing2, {
        margin: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React3.createElement(ButtonComponent, {
        href: deepLinkUrl,
        size: UitkButtonSize2.LARGE,
        onClick: onClickButton
    }, bannerLink.text))))), (termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.text) && (termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.uri) && /* @__PURE__ */ React3.createElement(UitkSpacing2, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(UitkSpacing2, {
        margin: {
            inlinestart: "one",
            blockend: "one"
        }
    }, /* @__PURE__ */ React3.createElement(UitkLink, {
        size: "small",
        theme: "inverse",
        inline: true
    }, /* @__PURE__ */ React3.createElement("a", {
        href: termsAndConditions.uri.value,
        target: "_blank",
        rel: "noopener noreferrer"
    }, termsAndConditions.text))))))), qrCodeEnabled && /* @__PURE__ */ React3.createElement(UitkLayoutGridItem, {
        colSpan: 2
    }, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement("div", {
        role: "definition",
        "aria-labelledby": "qrCodeTitle"
    }, /* @__PURE__ */ React3.createElement("input", {
        type: "hidden",
        id: "qrCodeTitle",
        "aria-label": qrCodeTitle
    })), /* @__PURE__ */ React3.createElement(UitkSpacing2, {
        padding: {
            inlinestart: "four",
            blockstart: "six"
        }
    }, /* @__PURE__ */ React3.createElement("div", null, /* @__PURE__ */ React3.createElement(UitkFigure2, {
        ratio: UitkFigureAspectRatioType.R1_1
    }, /* @__PURE__ */ React3.createElement(UitkImage, {
        src: qrCodeUrl,
        alt: qrCodeDesc
    })))), /* @__PURE__ */ React3.createElement(UitkSpacing2, {
        padding: {
            blockstart: "three",
            inlinestart: "four"
        }
    }, /* @__PURE__ */ React3.createElement(UitkText2, {
        theme: "inverse",
        align: "center",
        weight: "medium",
        size: 200,
        "aria-hidden": "true"
    }, qrCodeTitle))))))))))));
};
BottomSheet.displayName = "BottomSheet";
// src/components/bottom-sheet/bottom-sheet-wrapper.tsx
var MemoizedBottomSheet = React4.memo(BottomSheet);
var BottomSheetWrapper = function(param) {
    var data = param.data, inputs = param.inputs, dismissCallback = param.dismissCallback;
    var _legalText_items;
    var notificationLocation = data.notificationLocation, legalText = data.legalText, title = data.title, body = data.body, logo = data.logo, links = data.links, revealActions = data.revealActions, customQrCode = data.customQrCode, dismiss = data.dismiss;
    var optionalContext = inputs.optionalContext;
    var termsAndConditionLink = legalText === null || legalText === void 0 ? void 0 : (_legalText_items = legalText.items) === null || _legalText_items === void 0 ? void 0 : _legalText_items.find(function(link) {
        return link.__typename === "NotificationPhraseLinkNode";
    });
    var termsAndConditions = (termsAndConditionLink === null || termsAndConditionLink === void 0 ? void 0 : termsAndConditionLink.uri) && termsAndConditionLink.uri.value ? termsAndConditionLink : void 0;
    var memoizedSheetData = React4.useMemo(function() {
        var _customQrCode_image, _customQrCode_image1;
        return {
            type: "BOTTOM_SHEET" /* BOTTOM_SHEET */ ,
            notificationLocation: notificationLocation,
            body: body,
            title: title,
            logo: logo,
            dismiss: dismiss,
            qrCodeUrl: customQrCode === null || customQrCode === void 0 ? void 0 : (_customQrCode_image = customQrCode.image) === null || _customQrCode_image === void 0 ? void 0 : _customQrCode_image.url,
            qrCodeDesc: customQrCode === null || customQrCode === void 0 ? void 0 : (_customQrCode_image1 = customQrCode.image) === null || _customQrCode_image1 === void 0 ? void 0 : _customQrCode_image1.description,
            qrCodeTitle: customQrCode === null || customQrCode === void 0 ? void 0 : customQrCode.title,
            bannerLink: links === null || links === void 0 ? void 0 : links[0],
            revealActions: revealActions,
            referer: optionalContext === null || optionalContext === void 0 ? void 0 : optionalContext.referer,
            termsAndConditions: termsAndConditions,
            dismissCallback: dismissCallback
        };
    }, []);
    if (!logo || !dismiss) {
        return null;
    }
    return /* @__PURE__ */ React4.createElement(MemoizedBottomSheet, _objectSpread({}, memoizedSheetData));
};
// src/components/centered-sheet/centered-sheet-wrapper.tsx
import React6 from "react";
// src/components/centered-sheet/centered-sheet.tsx
import React5 from "react";
import { useApolloClient as useApolloClient2 } from "@apollo/client";
import { useDialog } from "@shared-ui/dialog-context";
import { ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkButtonSize as UitkButtonSize3 } from "uitk-react-button";
import { UitkFigure as UitkFigure3, UitkFigureAspectRatioType as UitkFigureAspectRatioType2, UitkImage as UitkImage2 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid2, UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkSheet as UitkSheet2, UitkSheetContent as UitkSheetContent2 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkText as UitkText3 } from "uitk-react-text";
import { UitkTransparentToolbar } from "uitk-react-toolbar";
import { UitkViewRow as UitkViewRow2 } from "uitk-react-view";
var CenteredSheet = function(param) {
    var type = param.type, notificationLocation = param.notificationLocation, body = param.body, title = param.title, logo = param.logo, dismiss = param.dismiss, qrCodeUrl = param.qrCodeUrl, qrCodeDesc = param.qrCodeDesc, qrCodeTitle = param.qrCodeTitle, bannerLink = param.bannerLink, revealActions = param.revealActions, referer = param.referer, termsAndConditions = param.termsAndConditions;
    var _dismiss_icon, _dismiss_icon1, _body__items, _body__items_, _dismiss_icon2, _dismiss_icon3, _title_items_, _body__items1, _body__items_1;
    var _useDialog = _slicedToArray(useDialog("customer-notification-centered-sheet-dialog"), 3), isDialogOpen = _useDialog[0], dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    var cache = useApolloClient2().cache;
    var customerNotificationActionsExecutor = useNotificationActionExecutor();
    var triggerRef = React5.useRef(null);
    var memoizedImpressionLogger = React5.useCallback(function() {
        if (isDialogOpen) {
            customerNotificationActionsExecutor(revealActions);
        }
        return isDialogOpen;
    }, [
        isDialogOpen
    ]);
    var onClickDismiss = React5.useCallback(function() {
        dialogActions.closeDialog();
        customerNotificationActionsExecutor(dismiss === null || dismiss === void 0 ? void 0 : dismiss.actions);
        cacheEviction(cache, type, notificationLocation);
    }, []);
    var onClickButton = React5.useCallback(function() {
        customerNotificationActionsExecutor(bannerLink === null || bannerLink === void 0 ? void 0 : bannerLink.actions);
    }, []);
    React5.useEffect(function() {
        dialogActions.openDialog();
    }, []);
    var deepLinkUrl = React5.useMemo(function() {
        var _bannerLink_uri;
        return createDeepLinkUrl(bannerLink === null || bannerLink === void 0 ? void 0 : (_bannerLink_uri = bannerLink.uri) === null || _bannerLink_uri === void 0 ? void 0 : _bannerLink_uri.value, referer);
    }, []);
    var ButtonComponent = React5.useMemo(function() {
        return getButtonComponent((bannerLink === null || bannerLink === void 0 ? void 0 : bannerLink.type) || "");
    }, []);
    var qrCodeEnabled = qrCodeUrl && qrCodeTitle;
    return /* @__PURE__ */ React5.createElement(React5.Fragment, null, isDialogOpen && memoizedImpressionLogger() && /* @__PURE__ */ React5.createElement(Viewport2, null, /* @__PURE__ */ React5.createElement(ViewSmall2, null, /* @__PURE__ */ React5.createElement(DialogComponent, null, /* @__PURE__ */ React5.createElement(UitkSpacing3, {
        margin: {
            inline: "six"
        }
    }, /* @__PURE__ */ React5.createElement(UitkSheet2, {
        isVisible: isDialogOpen,
        type: "centered",
        triggerRef: triggerRef,
        centeredSheetSize: "small"
    }, /* @__PURE__ */ React5.createElement(UitkSpacing3, {
        padding: {
            inlinestart: "one",
            blockstart: "one"
        }
    }, /* @__PURE__ */ React5.createElement(UitkTransparentToolbar, {
        overlay: true,
        navigationContent: {
            onClick: onClickDismiss,
            navIconLabel: dismiss === null || dismiss === void 0 ? void 0 : (_dismiss_icon = dismiss.icon) === null || _dismiss_icon === void 0 ? void 0 : _dismiss_icon.description,
            navButtonId: dismiss === null || dismiss === void 0 ? void 0 : (_dismiss_icon1 = dismiss.icon) === null || _dismiss_icon1 === void 0 ? void 0 : _dismiss_icon1.id
        }
    })), /* @__PURE__ */ React5.createElement(UitkSpacing3, {
        padding: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React5.createElement(UitkViewRow2, {
        canvasTheme: "brand_promo_primary",
        layout: "fullwidth"
    }, /* @__PURE__ */ React5.createElement(UitkSpacing3, {
        margin: {
            block: "six",
            inline: "two"
        }
    }, /* @__PURE__ */ React5.createElement(UitkSheetContent2, {
        padded: false,
        fullSheetContentMaxWidth: "extra-large"
    }, /* @__PURE__ */ React5.createElement(UitkLayoutFlex3, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React5.createElement(UitkLayoutFlexItem3, {
        alignSelf: "center"
    }, /* @__PURE__ */ React5.createElement("img", {
        alt: logo === null || logo === void 0 ? void 0 : logo.description,
        src: logo === null || logo === void 0 ? void 0 : logo.url,
        width: 56
    })), /* @__PURE__ */ React5.createElement(UitkLayoutFlexItem3, {
        alignSelf: "center"
    }, /* @__PURE__ */ React5.createElement(UitkSpacing3, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React5.createElement(UitkText3, {
        theme: "inverse",
        align: "center",
        weight: "medium",
        size: 600
    }, (_body__items = body === null || body === void 0 ? void 0 : body[0].items) === null || _body__items === void 0 ? void 0 : (_body__items_ = _body__items[0]) === null || _body__items_ === void 0 ? void 0 : _body__items_.text))), (bannerLink === null || bannerLink === void 0 ? void 0 : bannerLink.text) && deepLinkUrl && /* @__PURE__ */ React5.createElement(UitkLayoutFlexItem3, {
        alignSelf: "center"
    }, /* @__PURE__ */ React5.createElement(UitkSpacing3, {
        margin: {
            blockstart: "six",
            blockend: "four"
        }
    }, /* @__PURE__ */ React5.createElement(ButtonComponent, {
        href: deepLinkUrl,
        size: UitkButtonSize3.LARGE,
        onClick: onClickButton
    }, bannerLink.text))), (termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.text) && (termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.uri) && /* @__PURE__ */ React5.createElement(UitkLayoutFlexItem3, null, /* @__PURE__ */ React5.createElement(UitkSpacing3, {
        margin: {
            blockstart: "two",
            blockend: "four",
            inline: "one"
        }
    }, /* @__PURE__ */ React5.createElement(UitkLink2, {
        align: "center",
        size: "small",
        theme: "inverse",
        inline: true
    }, /* @__PURE__ */ React5.createElement("a", {
        href: termsAndConditions.uri.value,
        target: "_blank",
        rel: "noopener noreferrer"
    }, termsAndConditions.text))))))))))))), /* @__PURE__ */ React5.createElement(ViewMedium2, null, /* @__PURE__ */ React5.createElement(DialogComponent, null, /* @__PURE__ */ React5.createElement(UitkSheet2, {
        isVisible: isDialogOpen,
        type: "centered",
        triggerRef: triggerRef,
        centeredSheetSize: "medium"
    }, /* @__PURE__ */ React5.createElement(UitkSpacing3, {
        padding: {
            inlinestart: "one",
            blockstart: "one"
        }
    }, /* @__PURE__ */ React5.createElement(UitkTransparentToolbar, {
        overlay: true,
        navigationContent: {
            onClick: onClickDismiss,
            navIconLabel: dismiss === null || dismiss === void 0 ? void 0 : (_dismiss_icon2 = dismiss.icon) === null || _dismiss_icon2 === void 0 ? void 0 : _dismiss_icon2.description,
            navButtonId: dismiss === null || dismiss === void 0 ? void 0 : (_dismiss_icon3 = dismiss.icon) === null || _dismiss_icon3 === void 0 ? void 0 : _dismiss_icon3.id
        }
    })), /* @__PURE__ */ React5.createElement(UitkSpacing3, {
        padding: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React5.createElement(UitkViewRow2, {
        canvasTheme: "brand_promo_primary",
        layout: "fullwidth"
    }, /* @__PURE__ */ React5.createElement(UitkSheetContent2, null, /* @__PURE__ */ React5.createElement(UitkLayoutGrid2, {
        columns: 10
    }, /* @__PURE__ */ React5.createElement(UitkLayoutGridItem2, {
        colSpan: qrCodeEnabled ? 7 : 10
    }, /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement(UitkLayoutGrid2, {
        columns: qrCodeEnabled ? 6 : 9
    }, /* @__PURE__ */ React5.createElement(UitkLayoutGridItem2, {
        colSpan: 1
    }, /* @__PURE__ */ React5.createElement("img", {
        alt: logo === null || logo === void 0 ? void 0 : logo.description,
        src: logo === null || logo === void 0 ? void 0 : logo.url,
        width: 55
    })), ((_title_items_ = title === null || title === void 0 ? void 0 : title.items[0]) === null || _title_items_ === void 0 ? void 0 : _title_items_.text) && /* @__PURE__ */ React5.createElement(UitkLayoutGridItem2, {
        colSpan: qrCodeEnabled ? 5 : 8
    }, /* @__PURE__ */ React5.createElement(UitkSpacing3, {
        padding: {
            block: "four"
        }
    }, /* @__PURE__ */ React5.createElement(UitkText3, {
        theme: "inverse",
        align: "left",
        size: 600,
        weight: "bold"
    }, title === null || title === void 0 ? void 0 : title.items[0].text)))), /* @__PURE__ */ React5.createElement(UitkLayoutGrid2, null, /* @__PURE__ */ React5.createElement(UitkLayoutGridItem2, null, /* @__PURE__ */ React5.createElement(UitkSpacing3, {
        padding: {
            block: "six",
            inlineend: "four"
        }
    }, /* @__PURE__ */ React5.createElement(UitkText3, {
        theme: "inverse",
        weight: "medium",
        size: 500
    }, (_body__items1 = body === null || body === void 0 ? void 0 : body[0].items) === null || _body__items1 === void 0 ? void 0 : (_body__items_1 = _body__items1[0]) === null || _body__items_1 === void 0 ? void 0 : _body__items_1.text)))), (bannerLink === null || bannerLink === void 0 ? void 0 : bannerLink.text) && deepLinkUrl && (bannerLink === null || bannerLink === void 0 ? void 0 : bannerLink.linkTheme) !== "INVERSE" /* INVERSE */  && /* @__PURE__ */ React5.createElement(UitkLayoutGrid2, {
        columns: 10
    }, /* @__PURE__ */ React5.createElement(UitkLayoutGridItem2, {
        colSpan: 4
    }, /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement(ButtonComponent, {
        href: deepLinkUrl,
        size: UitkButtonSize3.LARGE,
        onClick: onClickButton,
        isFullWidth: false
    }, bannerLink === null || bannerLink === void 0 ? void 0 : bannerLink.text)))), (termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.text) && (termsAndConditions === null || termsAndConditions === void 0 ? void 0 : termsAndConditions.uri) && /* @__PURE__ */ React5.createElement(UitkSpacing3, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement(UitkLink2, {
        size: "small",
        theme: "inverse",
        inline: true
    }, /* @__PURE__ */ React5.createElement("a", {
        href: termsAndConditions.uri.value,
        target: "_blank",
        rel: "noopener noreferrer"
    }, termsAndConditions.text)))))), qrCodeEnabled && /* @__PURE__ */ React5.createElement(UitkLayoutGridItem2, {
        colSpan: 3
    }, /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement("div", {
        role: "definition",
        "aria-labelledby": "qrCodeTitle"
    }, /* @__PURE__ */ React5.createElement("input", {
        type: "hidden",
        id: "qrCodeTitle",
        "aria-label": qrCodeTitle
    })), /* @__PURE__ */ React5.createElement(UitkSpacing3, {
        padding: {
            inlinestart: "four"
        }
    }, /* @__PURE__ */ React5.createElement("div", null, /* @__PURE__ */ React5.createElement(UitkFigure3, {
        ratio: UitkFigureAspectRatioType2.R1_1
    }, /* @__PURE__ */ React5.createElement(UitkImage2, {
        src: qrCodeUrl,
        alt: qrCodeDesc
    })))), /* @__PURE__ */ React5.createElement(UitkSpacing3, {
        padding: {
            blockstart: "six",
            inlinestart: "four"
        }
    }, /* @__PURE__ */ React5.createElement(UitkText3, {
        theme: "inverse",
        align: "center",
        weight: "medium",
        size: 200,
        "aria-hidden": "true"
    }, qrCodeTitle)))))))))))));
};
CenteredSheet.displayName = "CenteredSheet";
// src/components/centered-sheet/centered-sheet-wrapper.tsx
var MemoizedCenteredSheet = React6.memo(CenteredSheet);
var CenteredSheetWrapper = function(props) {
    var _legalText_items;
    var _ref = props || {}, _ref_data = _ref.data, notificationLocation = _ref_data.notificationLocation, legalText = _ref_data.legalText, title = _ref_data.title, body = _ref_data.body, logo = _ref_data.logo, links = _ref_data.links, revealActions = _ref_data.revealActions, customQrCode = _ref_data.customQrCode, dismiss = _ref_data.dismiss, optionalContext = _ref.inputs.optionalContext;
    var termsAndConditionLink = legalText === null || legalText === void 0 ? void 0 : (_legalText_items = legalText.items) === null || _legalText_items === void 0 ? void 0 : _legalText_items.find(function(link) {
        return link.__typename === "NotificationPhraseLinkNode";
    });
    var termsAndConditions = (termsAndConditionLink === null || termsAndConditionLink === void 0 ? void 0 : termsAndConditionLink.uri) && termsAndConditionLink.uri.value ? termsAndConditionLink : void 0;
    var memoizedSheetData = React6.useMemo(function() {
        var _customQrCode_image, _customQrCode_image1;
        return {
            type: "CENTERED_SHEET" /* CENTERED_SHEET */ ,
            notificationLocation: notificationLocation,
            body: body,
            title: title,
            logo: logo,
            dismiss: dismiss,
            qrCodeUrl: customQrCode === null || customQrCode === void 0 ? void 0 : (_customQrCode_image = customQrCode.image) === null || _customQrCode_image === void 0 ? void 0 : _customQrCode_image.url,
            qrCodeDesc: customQrCode === null || customQrCode === void 0 ? void 0 : (_customQrCode_image1 = customQrCode.image) === null || _customQrCode_image1 === void 0 ? void 0 : _customQrCode_image1.description,
            qrCodeTitle: customQrCode === null || customQrCode === void 0 ? void 0 : customQrCode.title,
            bannerLink: links === null || links === void 0 ? void 0 : links[0],
            revealActions: revealActions,
            referer: optionalContext === null || optionalContext === void 0 ? void 0 : optionalContext.referer,
            termsAndConditions: termsAndConditions
        };
    }, []);
    if (!logo || !dismiss) {
        return null;
    }
    return /* @__PURE__ */ React6.createElement(MemoizedCenteredSheet, _objectSpread({}, memoizedSheetData));
};
// src/components/citi-cobrand-ad/citi-cobrand-ad-wrapper.tsx
import React9 from "react";
// src/components/citi-cobrand-ad-vertical/citi-cobrand-ad-vertical.tsx
import React7 from "react";
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";
import { UitkLink as UitkLink3 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkHeading, UitkText as UitkText4 } from "uitk-react-text";
var CitiCobrandVerticalAd = function(props) {
    var bodyText = props.bodyText, cardImage = props.cardImage, headingText = props.headingText, learnMoreLink = props.learnMoreLink, revealActions = props.revealActions;
    var customerNotificationActionsExecutor = useNotificationActionExecutor();
    React7.useEffect(function() {
        customerNotificationActionsExecutor(revealActions);
    }, []);
    var onClickLink = function(link) {
        return function() {
            customerNotificationActionsExecutor(link.actions);
        };
    };
    return /* @__PURE__ */ React7.createElement(UitkCard, null, /* @__PURE__ */ React7.createElement(UitkCardContentSection, {
        padded: false
    }, /* @__PURE__ */ React7.createElement(UitkSpacing4, {
        padding: "four"
    }, /* @__PURE__ */ React7.createElement("div", null, /* @__PURE__ */ React7.createElement("img", {
        src: cardImage.url,
        alt: cardImage.description
    }), /* @__PURE__ */ React7.createElement(UitkSpacing4, {
        padding: {
            block: "two"
        }
    }, /* @__PURE__ */ React7.createElement(UitkHeading, {
        tag: "h2",
        size: 5
    }, headingText)), /* @__PURE__ */ React7.createElement(UitkText4, {
        size: 300
    }, bodyText), /* @__PURE__ */ React7.createElement(UitkSpacing4, {
        padding: {
            blockstart: "two",
            inlineend: "six"
        }
    }, /* @__PURE__ */ React7.createElement(UitkLink3, {
        onClick: onClickLink(learnMoreLink),
        inline: true
    }, learnMoreLink.uri ? /* @__PURE__ */ React7.createElement("a", {
        href: learnMoreLink.uri.value,
        target: "_blank",
        rel: "noopener noreferrer"
    }, learnMoreLink.text) : /* @__PURE__ */ React7.createElement("button", {
        type: "button"
    }, learnMoreLink.text)))))));
};
CitiCobrandVerticalAd.displayName = "CitiCobrandVerticalAd";
// src/components/citi-cobrand-ad/citi-cobrand-ad.tsx
import React8 from "react";
import { UitkCard as UitkCard2, UitkCardContentSection as UitkCardContentSection2 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex4 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid3, UitkLayoutGridItem as UitkLayoutGridItem3 } from "uitk-react-layout-grid";
import { UitkLink as UitkLink4 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading2, UitkText as UitkText5 } from "uitk-react-text";
var CitiCobrandAd = function(props) {
    var bodyText = props.bodyText, cardImage = props.cardImage, headingText = props.headingText, learnMoreLink = props.learnMoreLink, revealActions = props.revealActions;
    var customerNotificationActionsExecutor = useNotificationActionExecutor();
    React8.useEffect(function() {
        customerNotificationActionsExecutor(revealActions);
    }, []);
    var onClickLink = function(link) {
        return function() {
            customerNotificationActionsExecutor(link.actions);
        };
    };
    return /* @__PURE__ */ React8.createElement(UitkCard2, null, /* @__PURE__ */ React8.createElement(UitkCardContentSection2, {
        padded: false
    }, /* @__PURE__ */ React8.createElement(UitkSpacing5, {
        padding: "four"
    }, /* @__PURE__ */ React8.createElement("div", null, /* @__PURE__ */ React8.createElement(UitkLayoutGrid3, {
        columns: 3
    }, /* @__PURE__ */ React8.createElement(UitkLayoutGridItem3, {
        colSpan: "all"
    }, /* @__PURE__ */ React8.createElement("div", null, /* @__PURE__ */ React8.createElement(UitkHeading2, {
        tag: "h2",
        size: 6
    }, headingText))), /* @__PURE__ */ React8.createElement(UitkSpacing5, {
        padding: {
            blockstart: "three",
            inlineend: "one"
        }
    }, /* @__PURE__ */ React8.createElement(UitkLayoutGridItem3, {
        colSpan: 2
    }, /* @__PURE__ */ React8.createElement("div", null, /* @__PURE__ */ React8.createElement(UitkText5, {
        align: "left",
        size: 300
    }, bodyText), /* @__PURE__ */ React8.createElement(UitkSpacing5, {
        padding: {
            blockstart: "two",
            inlineend: "six"
        }
    }, /* @__PURE__ */ React8.createElement(UitkLink4, {
        onClick: onClickLink(learnMoreLink),
        inline: true
    }, learnMoreLink.uri ? /* @__PURE__ */ React8.createElement("a", {
        href: learnMoreLink.uri.value,
        target: "_blank",
        rel: "noopener noreferrer"
    }, learnMoreLink.text) : /* @__PURE__ */ React8.createElement("button", {
        type: "button"
    }, learnMoreLink.text)))))), /* @__PURE__ */ React8.createElement(UitkSpacing5, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React8.createElement(UitkLayoutGridItem3, {
        colSpan: 1
    }, /* @__PURE__ */ React8.createElement(UitkLayoutFlex4, {
        alignItems: "end",
        direction: "column"
    }, /* @__PURE__ */ React8.createElement("img", {
        src: cardImage.url,
        alt: cardImage.description
    })))))))));
};
CitiCobrandAd.displayName = "CitiCobrandAd";
// src/components/citi-cobrand-ad/citi-cobrand-ad-wrapper.tsx
var CitiCobrandAdWrapper = function(param) {
    var data = param.data;
    var _body__items_, _body_, _title_items_;
    var _ref = data || {}, type = _ref.type, title = _ref.title, backgroundImage = _ref.backgroundImage, body = _ref.body, links = _ref.links, revealActions = _ref.revealActions;
    if (!backgroundImage || !body || !links || !revealActions || !title) {
        return null;
    }
    if (type && type === "CITI_COBRAND_VERTICAL" /* CITI_COBRAND_VERTICAL */ ) {
        var _body__items_1, _body_1, _title_items_1;
        return /* @__PURE__ */ React9.createElement(CitiCobrandVerticalAd, {
            bodyText: (_body__items_1 = (_body_1 = body[0]) === null || _body_1 === void 0 ? void 0 : _body_1.items[0]) === null || _body__items_1 === void 0 ? void 0 : _body__items_1.text,
            cardImage: backgroundImage,
            headingText: (_title_items_1 = title.items[0]) === null || _title_items_1 === void 0 ? void 0 : _title_items_1.text,
            learnMoreLink: links[0],
            revealActions: revealActions
        });
    }
    return /* @__PURE__ */ React9.createElement(CitiCobrandAd, {
        bodyText: (_body__items_ = (_body_ = body[0]) === null || _body_ === void 0 ? void 0 : _body_.items[0]) === null || _body__items_ === void 0 ? void 0 : _body__items_.text,
        cardImage: backgroundImage,
        headingText: (_title_items_ = title.items[0]) === null || _title_items_ === void 0 ? void 0 : _title_items_.text,
        learnMoreLink: links[0],
        revealActions: revealActions
    });
};
// src/components/cleanliness-banner/cleanliness-banner-wrapper.tsx
import React12 from "react";
// src/components/cleanliness-banner/cleanliness-banner.tsx
import React11 from "react";
import { UitkLayoutFlex as UitkLayoutFlex6, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid4 } from "uitk-react-layout-grid";
import { UitkHeading as UitkHeading4, UitkParagraph } from "uitk-react-text";
// src/components/cleanliness-banner/cleanliness-message.tsx
import React10 from "react";
import { UitkIcon as UitkIcon3 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkLayoutGridItem as UitkLayoutGridItem4 } from "uitk-react-layout-grid";
import { UitkHeading as UitkHeading3, UitkText as UitkText6 } from "uitk-react-text";
var CleanlinessMessage = function(param) {
    var iconName = param.iconName, title = param.title, subtitle = param.subtitle;
    return /* @__PURE__ */ React10.createElement(UitkLayoutGridItem4, null, /* @__PURE__ */ React10.createElement(UitkLayoutFlex5, {
        alignItems: "center",
        space: "four"
    }, /* @__PURE__ */ React10.createElement(UitkLayoutFlexItem4, {
        minWidth: "fifteen"
    }, /* @__PURE__ */ React10.createElement(UitkLayoutFlex5, null, /* @__PURE__ */ React10.createElement(UitkIcon3, {
        name: iconName,
        spotlight: "standard"
    }))), /* @__PURE__ */ React10.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React10.createElement(UitkLayoutFlex5, {
        direction: "column"
    }, /* @__PURE__ */ React10.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React10.createElement(UitkHeading3, {
        size: 7
    }, title)), /* @__PURE__ */ React10.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React10.createElement(UitkText6, null, subtitle))))));
};
var cleanliness_message_default = CleanlinessMessage;
// src/components/cleanliness-banner/cleanliness-banner.tsx
var CleanlinessBanner = function(param) {
    var title = param.title, subtitle = param.subtitle, messages = param.messages;
    return /* @__PURE__ */ React11.createElement(UitkLayoutFlex6, {
        space: "four",
        direction: "column"
    }, /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React11.createElement("div", null, /* @__PURE__ */ React11.createElement(UitkHeading4, {
        tag: "h2",
        size: 3
    }, title), /* @__PURE__ */ React11.createElement(UitkParagraph, null, subtitle))), /* @__PURE__ */ React11.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React11.createElement(UitkLayoutGrid4, {
        columns: {
            small: 1,
            medium: 2
        },
        space: "four"
    }, (messages || []).map(function(message) {
        return /* @__PURE__ */ React11.createElement(cleanliness_message_default, _objectSpread({
            key: message.iconName
        }, message));
    }))));
};
var cleanliness_banner_default = CleanlinessBanner;
// src/components/cleanliness-banner/helpers/index.ts
var getCleanlinessMessages = function(body) {
    var messages = [];
    body.forEach(function(element) {
        var _element_items, _element_items_, _element_items1, _element_items_1, _element_items__icon, _element_items2, _element_items_2;
        var message = {
            title: element === null || element === void 0 ? void 0 : (_element_items = element.items) === null || _element_items === void 0 ? void 0 : (_element_items_ = _element_items[0]) === null || _element_items_ === void 0 ? void 0 : _element_items_.text,
            iconName: element === null || element === void 0 ? void 0 : (_element_items1 = element.items) === null || _element_items1 === void 0 ? void 0 : (_element_items_1 = _element_items1[0]) === null || _element_items_1 === void 0 ? void 0 : (_element_items__icon = _element_items_1.icon) === null || _element_items__icon === void 0 ? void 0 : _element_items__icon.id,
            subtitle: element === null || element === void 0 ? void 0 : (_element_items2 = element.items) === null || _element_items2 === void 0 ? void 0 : (_element_items_2 = _element_items2[1]) === null || _element_items_2 === void 0 ? void 0 : _element_items_2.text
        };
        messages.push(message);
    });
    return messages;
};
// src/components/cleanliness-banner/cleanliness-banner-wrapper.tsx
var CleanlinessBannerWrapper = function(param) {
    var data = param.data;
    var _title_items, _title_items_, _title_items1, _title_items_1;
    var _ref = data || {}, title = _ref.title, body = _ref.body;
    if (!body || !title) {
        return null;
    }
    var titleText = (_title_items = title.items) === null || _title_items === void 0 ? void 0 : (_title_items_ = _title_items[0]) === null || _title_items_ === void 0 ? void 0 : _title_items_.text;
    var subtitle = (_title_items1 = title.items) === null || _title_items1 === void 0 ? void 0 : (_title_items_1 = _title_items1[1]) === null || _title_items_1 === void 0 ? void 0 : _title_items_1.text;
    var messages = getCleanlinessMessages(body);
    return /* @__PURE__ */ React12.createElement(cleanliness_banner_default, {
        title: titleText,
        subtitle: subtitle,
        messages: messages
    });
};
// src/components/configurable-banner/configurable-banner-wrapper.tsx
import React18 from "react";
// src/components/configurable-banner/configurable-banner.tsx
import React17 from "react";
import { useApolloClient as useApolloClient3 } from "@apollo/client";
import { ViewLarge, ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
import { UitkButtonSize as UitkButtonSize5, UitkOverlayButton as UitkOverlayButton3 } from "uitk-react-button";
import { UitkIcon as UitkIcon4, UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
import { UitkFigure as UitkFigure4, UitkImage as UitkImage3 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex8, UitkLayoutFlexItem as UitkLayoutFlexItem7 } from "uitk-react-layout-flex";
import { UitkMark } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
import { UitkText as UitkText9 } from "uitk-react-text";
// src/components/helpers/themes-dictionary.tsx
import { UitkCardBackgroundThemes } from "uitk-react-cards";
// src/components/customer-notification/helpers/get-identity.ts
var LineOfBusinessMapper = {
    H: "LODGING" /* LODGING */ ,
    P: "PACKAGES" /* PACKAGES */ ,
    F: "FLIGHT" /* FLIGHT */ ,
    C: "CAR" /* CAR */ ,
    CR: "CRUISES" /* CRUISES */ ,
    A: "ACTIVITIES" /* ACTIVITIES */ ,
    U: "UNCLASSIFIED" /* UNCLASSIFIED */ ,
    R: "RAILS" /* RAILS */ ,
    GT: "GROUNDTRANSFERS" /* GROUNDTRANSFERS */ 
};
var pageLocationMapper = {
    0: "SYSTEM" /* SYSTEM */ ,
    10: "ENTRY" /* ENTRY */ ,
    20: "SEARCH_RESULTS" /* SEARCH_RESULTS */ ,
    30: "DETAILS" /* DETAILS */ ,
    40: "CHECKOUT" /* CHECKOUT */ ,
    50: "CHECKOUT_ERROR" /* CHECKOUT_ERROR */ ,
    60: "PAYMENT_ERROR" /* PAYMENT_ERROR */ ,
    70: "CONFIRMATION" /* CONFIRMATION */ ,
    80: "POST_BOOKING" /* POST_BOOKING */ ,
    90: "USER" /* USER */ ,
    500: "FEATURES" /* FEATURES */ 
};
var getIdentity = function(xPageId) {
    var identifiers = xPageId.split(",").map(function(identifier) {
        return identifier.trim();
    });
    return {
        pageId: identifiers[0],
        lineOfBusiness: LineOfBusinessMapper[identifiers[1]] || "UNCLASSIFIED" /* UNCLASSIFIED */ ,
        pageLocation: pageLocationMapper[identifiers[2]] || "ENTRY" /* ENTRY */ 
    };
};
var _obj1;
var UitkTextWeightMap = Object.freeze((_obj1 = {}, _defineProperty(_obj1, "BOLD" /* BOLD */ , "bold"), _defineProperty(_obj1, "MEDIUM" /* MEDIUM */ , "medium"), _defineProperty(_obj1, "REGULAR" /* REGULAR */ , "regular"), _obj1));
var _obj2;
var UitkTextThemeMap = Object.freeze((_obj2 = {}, _defineProperty(_obj2, "NEGATIVE" /* NEGATIVE */ , "negative"), _defineProperty(_obj2, "POSITIVE" /* POSITIVE */ , "positive"), _defineProperty(_obj2, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _defineProperty(_obj2, "PRIMARY" /* PRIMARY */ , "emphasis"), _defineProperty(_obj2, "LOYALTY" /* LOYALTY */ , "loyalty"), _defineProperty(_obj2, "SECONDARY" /* SECONDARY */ , "default"), _defineProperty(_obj2, "INVERSE" /* INVERSE */ , "inverse"), _obj2));
// src/components/helpers/themes-dictionary.tsx
var CARD_THEME_DICTIONARY = {
    PRIMARY: UitkCardBackgroundThemes.PRIMARY,
    SECONDARY: UitkCardBackgroundThemes.SECONDARY,
    GLOBAL_LOYALTY_STANDARD: UitkCardBackgroundThemes.GLOBAL_LOYALTY_STANDARD,
    GLOBAL_LOYALTY_LOW: UitkCardBackgroundThemes.GLOBAL_LOYALTY_LOW,
    GLOBAL_LOYALTY_HIGH: UitkCardBackgroundThemes.GLOBAL_LOYALTY_HIGH,
    GLOBAL_LOYALTY_EXTRAHIGH: UitkCardBackgroundThemes.GLOBAL_LOYALTY_EXTRAHIGH,
    GLOBAL_LOYALTY_MIDDLE: UitkCardBackgroundThemes.GLOBAL_LOYALTY_MIDDLE
};
var _CARD_THEME_DICTIONARY_;
var getCardTheme = function(cardTheme) {
    return (_CARD_THEME_DICTIONARY_ = CARD_THEME_DICTIONARY["".concat(cardTheme)]) !== null && _CARD_THEME_DICTIONARY_ !== void 0 ? _CARD_THEME_DICTIONARY_ : UitkCardBackgroundThemes.GLOBAL_LOYALTY_STANDARD;
};
var _UitkTextThemeMap_;
var getTextTheme = function(textTheme) {
    return (_UitkTextThemeMap_ = UitkTextThemeMap["".concat(textTheme)]) !== null && _UitkTextThemeMap_ !== void 0 ? _UitkTextThemeMap_ : UitkTextThemeMap["INVERSE" /* INVERSE */ ];
};
var LINK_THEME_DICTIONARY = {
    INVERSE: "inverse",
    DEFAULT: "default"
};
var _LINK_THEME_DICTIONARY_;
var getLinkTheme = function(linkTheme) {
    return (_LINK_THEME_DICTIONARY_ = LINK_THEME_DICTIONARY["".concat(linkTheme)]) !== null && _LINK_THEME_DICTIONARY_ !== void 0 ? _LINK_THEME_DICTIONARY_ : "inverse";
};
// src/components/configurable-banner/configurable-banner-body-dictionary.tsx
import React13 from "react";
import { UitkCard as UitkCard3 } from "uitk-react-cards";
import { UitkViewRow as UitkViewRow3 } from "uitk-react-view";
var CardBody = function(param) {
    var background = param.background, border = param.border, children = param.children;
    return /* @__PURE__ */ React13.createElement(UitkCard3, {
        border: border,
        backgroundTheme: getCardTheme(background !== null && background !== void 0 ? background : "GLOBAL_LOYALTY_STANDARD" /* GLOBAL_LOYALTY_STANDARD */ ),
        padded: true
    }, children);
};
var RowBody = function(param) {
    var children = param.children;
    return /* @__PURE__ */ React13.createElement(UitkViewRow3, {
        canvasTheme: "brand_promo_primary",
        layout: "centered"
    }, children);
};
var AnchorBody = function(param) {
    var children = param.children, bannerLink = param.bannerLink, onCardClickCallback = param.onCardClickCallback;
    return bannerLink ? /* @__PURE__ */ React13.createElement("a", {
        href: bannerLink,
        onClick: onCardClickCallback,
        onKeyDown: onCardClickCallback
    }, children) : /* @__PURE__ */ React13.createElement(React13.Fragment, null, children);
};
var _obj3;
var BODY_DICTIONARY = (_obj3 = {}, _defineProperty(_obj3, "PRE_HEADER" /* PRE_HEADER */ , RowBody), _defineProperty(_obj3, "IN_PAGE" /* IN_PAGE */ , CardBody), _obj3);
var getGenericBannerBodyComponent = function(location) {
    return BODY_DICTIONARY["".concat(location)] || CardBody;
};
// src/components/configurable-banner/configurable-banner-body-field.tsx
import React14 from "react";
import { UitkText as UitkText7 } from "uitk-react-text";
var BodyField = function(props) {
    var _body_, _body__egdsItems;
    var body = props.body;
    var bodyItems = body === null || body === void 0 ? void 0 : (_body_ = body[0]) === null || _body_ === void 0 ? void 0 : (_body__egdsItems = _body_.egdsItems) === null || _body__egdsItems === void 0 ? void 0 : _body__egdsItems[0];
    var textTheme = (bodyItems === null || bodyItems === void 0 ? void 0 : bodyItems.__typename) === "NotificationEGDSTextNode" ? bodyItems === null || bodyItems === void 0 ? void 0 : bodyItems.theme : "INVERSE" /* INVERSE */ ;
    return /* @__PURE__ */ React14.createElement(React14.Fragment, null, body.map(function(bodyItem, index) {
        var _bodyItem_items;
        return (_bodyItem_items = bodyItem.items) === null || _bodyItem_items === void 0 ? void 0 : _bodyItem_items.map(function(param, textIndex) {
            var text = param.text, styles = param.styles;
            /* @__PURE__ */ return React14.createElement(UitkText7, {
                key: "body-".concat(index, ".item-").concat(textIndex),
                theme: getTextTheme(textTheme),
                align: "left",
                size: 300,
                weight: (styles === null || styles === void 0 ? void 0 : styles[0]) === "IMPORTANT" /* IMPORTANT */  ? "bold" : "regular"
            }, text);
        });
    }));
};
// src/components/configurable-banner/configurable-banner-links-field.tsx
import React15 from "react";
import { UitkButtonSize as UitkButtonSize4 } from "uitk-react-button";
import { UitkLayoutFlex as UitkLayoutFlex7, UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink5 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
// src/components/configurable-banner/configurable-banner-button-dictionary.tsx
import { UitkPrimaryButton as UitkPrimaryButton3, UitkSecondaryButton as UitkSecondaryButton2, UitkTertiaryButton } from "uitk-react-button";
var _obj4;
var BUTTON_DICTIONARY = (_obj4 = {}, _defineProperty(_obj4, "PRIMARY_BUTTON" /* PRIMARY_BUTTON */ , UitkPrimaryButton3), _defineProperty(_obj4, "SECONDARY_BUTTON" /* SECONDARY_BUTTON */ , UitkSecondaryButton2), _defineProperty(_obj4, "TERTIARY_BUTTON" /* TERTIARY_BUTTON */ , UitkTertiaryButton), _obj4);
var getButtonComponent2 = function(buttonType) {
    return BUTTON_DICTIONARY["".concat(buttonType)] || UitkPrimaryButton3;
};
// src/components/configurable-banner/configurable-banner-links-field.tsx
var LinksField = function(props) {
    var links = props.links, isMobile = props.isMobile, isButtonOnRight = props.isButtonOnRight, referer = props.referer;
    var customerNotificationActionsExecutor = useNotificationActionExecutor();
    var buttonsSpacing = isButtonOnRight ? {
        padding: {
            extra_large: {
                blockstart: "unset",
                inlinestart: "unset"
            },
            large: {
                blockstart: "unset",
                inlinestart: "unset"
            },
            medium: {
                blockstart: "three",
                inlinestart: "unset"
            },
            small: {
                blockstart: "three",
                inlinestart: "unset"
            }
        }
    } : {
        padding: {
            blockstart: "three",
            inlinestart: "unset"
        }
    };
    return /* @__PURE__ */ React15.createElement(UitkLayoutFlexItem6, {
        shrink: 0
    }, /* @__PURE__ */ React15.createElement(UitkSpacing6, {
        padding: buttonsSpacing.padding
    }, /* @__PURE__ */ React15.createElement(UitkLayoutFlex7, {
        direction: "row",
        alignItems: "center"
    }, links === null || links === void 0 ? void 0 : links.map(function(button, index) {
        var _button_uri;
        var buttonLink = createDeepLinkUrl((_button_uri = button.uri) === null || _button_uri === void 0 ? void 0 : _button_uri.value, referer);
        if (button.type === "ANCHOR") {
            var _getLinkTheme;
            return /* @__PURE__ */ React15.createElement(UitkSpacing6, {
                padding: {
                    block: "two"
                }
            }, /* @__PURE__ */ React15.createElement(UitkLayoutFlex7, {
                direction: "row",
                alignItems: "start",
                justifyContent: "space-between"
            }, /* @__PURE__ */ React15.createElement(UitkLink5, {
                noWrap: true,
                theme: (_getLinkTheme = getLinkTheme(button === null || button === void 0 ? void 0 : button.linkTheme)) !== null && _getLinkTheme !== void 0 ? _getLinkTheme : "inverse",
                onClick: function() {
                    return customerNotificationActionsExecutor(button.actions);
                }
            }, /* @__PURE__ */ React15.createElement("a", {
                "aria-label": button === null || button === void 0 ? void 0 : button.text,
                href: buttonLink,
                target: "_blank",
                rel: "noopener noreferrer"
            }, button.text))));
        }
        var ButtonComponent = getButtonComponent2(button.type);
        var buttonSize = isMobile ? UitkButtonSize4.SMALL : UitkButtonSize4.MEDIUM;
        return /* @__PURE__ */ React15.createElement(UitkSpacing6, {
            margin: {
                inlineend: "three"
            },
            key: index
        }, /* @__PURE__ */ React15.createElement(ButtonComponent, {
            href: buttonLink,
            size: buttonSize,
            onClick: function() {
                return customerNotificationActionsExecutor(button.actions);
            }
        }, button.text));
    }))));
};
// src/components/configurable-banner/configurable-banner-sub-body-field.tsx
import React16 from "react";
import { UitkText as UitkText8 } from "uitk-react-text";
var SubBodyField = function(props) {
    var _subBody__title, _subBody__title_egdsItems;
    var subBody = props.subBody;
    var titleItem = (_subBody__title = subBody === null || subBody === void 0 ? void 0 : subBody[0].title) === null || _subBody__title === void 0 ? void 0 : (_subBody__title_egdsItems = _subBody__title.egdsItems) === null || _subBody__title_egdsItems === void 0 ? void 0 : _subBody__title_egdsItems[0];
    var titleTheme = (titleItem === null || titleItem === void 0 ? void 0 : titleItem.__typename) === "NotificationEGDSTextNode" ? titleItem === null || titleItem === void 0 ? void 0 : titleItem.theme : "INVERSE" /* INVERSE */ ;
    var titleText = titleItem && "text" in titleItem && titleItem.text;
    var titleWeight = titleItem && "weight" in titleItem && titleItem.weight || "REGULAR" /* REGULAR */ ;
    return /* @__PURE__ */ React16.createElement(React16.Fragment, null, /* @__PURE__ */ React16.createElement(UitkText8, {
        theme: getTextTheme(titleTheme),
        weight: titleWeight && UitkTextWeightMap[titleWeight],
        size: 300
    }, titleText));
};
// src/components/configurable-banner/configurable-banner.tsx
var ConfigurableBanner = function(param) {
    var type = param.type, notificationLocation = param.notificationLocation, title = param.title, revealActions = param.revealActions, logo = param.logo, links = param.links, containerLink = param.containerLink, dismiss = param.dismiss, referer = param.referer, body = param.body, subBody = param.subBody, icon = param.icon, qrCode = param.qrCode, backgroundTheme = param.backgroundTheme, border = param.border;
    var _title_egdsItems, _title_items, _qrCode_image, _qrCode_image1, _qrCode_image2, _title_items1, _title_items2;
    var customerNotificationActionsExecutor = useNotificationActionExecutor();
    var _React17_useState = _slicedToArray(React17.useState(true), 2), display = _React17_useState[0], setDisplay = _React17_useState[1];
    var cache = useApolloClient3().cache;
    var isCardBody = notificationLocation === "IN_PAGE" /* IN_PAGE */ ;
    var titleEgdsItems = title === null || title === void 0 ? void 0 : (_title_egdsItems = title.egdsItems) === null || _title_egdsItems === void 0 ? void 0 : _title_egdsItems[0];
    var textTheme = (titleEgdsItems === null || titleEgdsItems === void 0 ? void 0 : titleEgdsItems.__typename) === "NotificationEGDSTextNode" ? titleEgdsItems === null || titleEgdsItems === void 0 ? void 0 : titleEgdsItems.theme : "INVERSE" /* INVERSE */ ;
    var notificationBorder = border !== null && border !== void 0 ? border : void 0;
    var memoizedImpressionLogger = React17.useCallback(function() {
        if (display) {
            customerNotificationActionsExecutor(revealActions);
        }
        return display;
    }, [
        display
    ]);
    var logoImageSize = isCardBody ? 10 : 12;
    var logoIconSpacing = isCardBody ? {
        margin: {
            blockstart: "one"
        }
    } : {
        margin: {}
    };
    var BodyWrapper = React17.useMemo(function() {
        return getGenericBannerBodyComponent(notificationLocation);
    }, []);
    var containerBannerLink = React17.useMemo(function() {
        var _containerLink_uri;
        return createDeepLinkUrl(containerLink === null || containerLink === void 0 ? void 0 : (_containerLink_uri = containerLink.uri) === null || _containerLink_uri === void 0 ? void 0 : _containerLink_uri.value, referer);
    }, []);
    var onClickDismiss = React17.useCallback(function() {
        setDisplay(false);
        customerNotificationActionsExecutor(dismiss === null || dismiss === void 0 ? void 0 : dismiss.actions);
        cacheEviction(cache, type, notificationLocation);
    }, []);
    var onCardClick = React17.useCallback(function() {
        customerNotificationActionsExecutor(containerLink === null || containerLink === void 0 ? void 0 : containerLink.actions);
    }, []);
    return /* @__PURE__ */ React17.createElement(React17.Fragment, null, display && memoizedImpressionLogger() && /* @__PURE__ */ React17.createElement(Viewport3, null, /* @__PURE__ */ React17.createElement(ViewLarge, null, /* @__PURE__ */ React17.createElement(BodyWrapper, {
        background: backgroundTheme,
        border: notificationBorder
    }, /* @__PURE__ */ React17.createElement(UitkLayoutFlex8, {
        direction: "row",
        alignContent: "center",
        justifyContent: "space-between",
        space: "twelve"
    }, /* @__PURE__ */ React17.createElement(UitkLayoutFlexItem7, {
        alignSelf: "center"
    }, /* @__PURE__ */ React17.createElement(AnchorBody, {
        bannerLink: !isCardBody ? containerBannerLink : null,
        onCardClickCallback: onCardClick
    }, /* @__PURE__ */ React17.createElement(UitkSpacing7, {
        padding: {
            block: isCardBody ? "unset" : "three"
        }
    }, /* @__PURE__ */ React17.createElement(UitkLayoutFlex8, {
        direction: "row",
        alignItems: "center"
    }, /* @__PURE__ */ React17.createElement(UitkLayoutFlexItem7, {
        alignSelf: "center",
        grow: 0,
        shrink: isCardBody ? 0 : 1
    }, (logo === null || logo === void 0 ? void 0 : logo.url) ? /* @__PURE__ */ React17.createElement(UitkMark, {
        url: logo.url,
        description: logo.description,
        size: logoImageSize
    }) : null, (icon === null || icon === void 0 ? void 0 : icon.id) ? /* @__PURE__ */ React17.createElement("span", null, /* @__PURE__ */ React17.createElement(UitkIcon4, {
        name: icon.id,
        title: icon.title || "",
        description: icon.description,
        spotlight: {
            theme: "standard",
            background: true
        }
    })) : null), /* @__PURE__ */ React17.createElement(UitkLayoutFlexItem7, {
        alignSelf: "center",
        grow: 0,
        shrink: 1
    }, /* @__PURE__ */ React17.createElement(UitkSpacing7, {
        padding: {
            inlinestart: isCardBody ? "four" : "three"
        }
    }, /* @__PURE__ */ React17.createElement(UitkLayoutFlex8, {
        direction: "column",
        alignItems: "start",
        space: isCardBody ? "half" : void 0
    }, title === null || title === void 0 ? void 0 : (_title_items = title.items) === null || _title_items === void 0 ? void 0 : _title_items.map(function(param, index) {
        var text = param.text, styles = param.styles;
        /* @__PURE__ */ return React17.createElement(UitkText9, {
            key: "text-element-".concat(index),
            theme: getTextTheme(textTheme),
            align: "left",
            size: 300,
            weight: (styles === null || styles === void 0 ? void 0 : styles[0]) === "IMPORTANT" /* IMPORTANT */  ? "bold" : "medium"
        }, text);
    }), body && /* @__PURE__ */ React17.createElement(BodyField, {
        body: body,
        isCardBody: isCardBody
    }), subBody && /* @__PURE__ */ React17.createElement(SubBodyField, {
        subBody: subBody
    }), links && (qrCode === null || qrCode === void 0 ? void 0 : qrCode.title) && /* @__PURE__ */ React17.createElement(LinksField, {
        links: links,
        referer: referer
    })))))))), dismiss && /* @__PURE__ */ React17.createElement(UitkLayoutFlexItem7, {
        alignSelf: "center"
    }, /* @__PURE__ */ React17.createElement(UitkOverlayButton3, {
        onClick: onClickDismiss,
        name: "close",
        "aria-label": "close",
        size: UitkButtonSize5.SMALL
    }, /* @__PURE__ */ React17.createElement(UitkIcon4, {
        name: "close",
        size: UitkIconSize2.SMALL
    }))), links && !qrCode && /* @__PURE__ */ React17.createElement(LinksField, {
        links: links,
        isButtonOnRight: true,
        referer: referer
    }), qrCode && /* @__PURE__ */ React17.createElement(UitkLayoutFlexItem7, {
        grow: 1,
        minWidth: 76,
        maxWidth: 76,
        alignSelf: "center"
    }, /* @__PURE__ */ React17.createElement(UitkLayoutFlex8, {
        direction: "column",
        wrap: "wrap"
    }, (qrCode === null || qrCode === void 0 ? void 0 : (_qrCode_image = qrCode.image) === null || _qrCode_image === void 0 ? void 0 : _qrCode_image.url) && /* @__PURE__ */ React17.createElement(UitkLayoutFlexItem7, {
        grow: 1,
        minWidth: 78,
        maxWidth: 150,
        alignSelf: "end"
    }, /* @__PURE__ */ React17.createElement(UitkFigure4, {
        imageFit: "contain"
    }, /* @__PURE__ */ React17.createElement(UitkImage3, {
        src: qrCode === null || qrCode === void 0 ? void 0 : (_qrCode_image1 = qrCode.image) === null || _qrCode_image1 === void 0 ? void 0 : _qrCode_image1.url,
        alt: qrCode.image.description,
        placeholderImage: true
    }))), (qrCode === null || qrCode === void 0 ? void 0 : (_qrCode_image2 = qrCode.image) === null || _qrCode_image2 === void 0 ? void 0 : _qrCode_image2.url) && (qrCode === null || qrCode === void 0 ? void 0 : qrCode.title) && /* @__PURE__ */ React17.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */ React17.createElement(UitkText9, {
        theme: "inverse",
        size: 300,
        align: "center"
    }, qrCode === null || qrCode === void 0 ? void 0 : qrCode.title))))))), /* @__PURE__ */ React17.createElement(ViewMedium3, null, /* @__PURE__ */ React17.createElement(BodyWrapper, {
        background: backgroundTheme,
        border: notificationBorder
    }, /* @__PURE__ */ React17.createElement(UitkLayoutFlex8, {
        direction: "row",
        alignContent: "center",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React17.createElement(UitkLayoutFlexItem7, {
        alignSelf: "center"
    }, /* @__PURE__ */ React17.createElement(AnchorBody, {
        bannerLink: !isCardBody ? containerBannerLink : null,
        onCardClickCallback: onCardClick
    }, /* @__PURE__ */ React17.createElement(UitkSpacing7, {
        padding: {
            block: isCardBody ? "unset" : "three"
        }
    }, /* @__PURE__ */ React17.createElement(UitkLayoutFlex8, {
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React17.createElement(UitkLayoutFlexItem7, {
        alignSelf: "start",
        grow: 0,
        shrink: isCardBody ? 0 : 1
    }, /* @__PURE__ */ React17.createElement(UitkSpacing7, {
        margin: logoIconSpacing.margin
    }, (logo === null || logo === void 0 ? void 0 : logo.url) ? /* @__PURE__ */ React17.createElement(UitkMark, {
        url: logo.url,
        description: logo.description,
        size: logoImageSize
    }) : null, (icon === null || icon === void 0 ? void 0 : icon.id) ? /* @__PURE__ */ React17.createElement("span", null, /* @__PURE__ */ React17.createElement(UitkIcon4, {
        name: icon.id,
        title: icon.title || "",
        description: icon.description,
        theme: "primary",
        size: UitkIconSize2.LARGE,
        spotlight: "standard"
    })) : null)), /* @__PURE__ */ React17.createElement(UitkLayoutFlexItem7, {
        alignSelf: "center",
        grow: 1,
        shrink: 1
    }, /* @__PURE__ */ React17.createElement(UitkSpacing7, {
        padding: {
            inlinestart: isCardBody ? "four" : "three"
        }
    }, /* @__PURE__ */ React17.createElement(UitkLayoutFlex8, {
        direction: "column",
        alignItems: "start",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, title === null || title === void 0 ? void 0 : (_title_items1 = title.items) === null || _title_items1 === void 0 ? void 0 : _title_items1.map(function(param, index) {
        var text = param.text, styles = param.styles;
        return /* @__PURE__ */ React17.createElement(UitkText9, {
            key: "text-element-".concat(index),
            theme: getTextTheme(textTheme),
            align: "left",
            size: 300,
            weight: styles[0] === "IMPORTANT" /* IMPORTANT */  ? "bold" : "regular"
        }, text);
    }), body && /* @__PURE__ */ React17.createElement(BodyField, {
        body: body,
        isCardBody: isCardBody
    }), subBody && (qrCode === null || qrCode === void 0 ? void 0 : qrCode.title) && /* @__PURE__ */ React17.createElement(SubBodyField, {
        subBody: subBody
    }), links && /* @__PURE__ */ React17.createElement(LinksField, {
        links: links,
        isMobile: true,
        referer: referer
    })))))))), dismiss && /* @__PURE__ */ React17.createElement(UitkLayoutFlexItem7, {
        alignSelf: "center"
    }, /* @__PURE__ */ React17.createElement(UitkOverlayButton3, {
        onClick: onClickDismiss,
        name: "close",
        "aria-label": "close",
        size: UitkButtonSize5.SMALL
    }, /* @__PURE__ */ React17.createElement(UitkIcon4, {
        name: "close",
        size: UitkIconSize2.SMALL
    })))))), /* @__PURE__ */ React17.createElement(ViewSmall3, null, /* @__PURE__ */ React17.createElement(BodyWrapper, {
        background: backgroundTheme,
        border: notificationBorder
    }, /* @__PURE__ */ React17.createElement(UitkLayoutFlex8, {
        direction: "row",
        alignItems: "center",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React17.createElement(UitkLayoutFlexItem7, {
        alignSelf: "center"
    }, /* @__PURE__ */ React17.createElement(AnchorBody, {
        bannerLink: !isCardBody ? containerBannerLink : null,
        onCardClickCallback: onCardClick
    }, /* @__PURE__ */ React17.createElement(UitkSpacing7, {
        padding: {
            block: isCardBody ? "unset" : "three"
        }
    }, /* @__PURE__ */ React17.createElement(UitkLayoutFlex8, {
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React17.createElement(UitkLayoutFlexItem7, {
        alignSelf: isCardBody ? "start" : "center",
        grow: 0,
        shrink: isCardBody ? 0 : 1
    }, /* @__PURE__ */ React17.createElement(UitkSpacing7, {
        margin: logoIconSpacing.margin
    }, (logo === null || logo === void 0 ? void 0 : logo.url) ? /* @__PURE__ */ React17.createElement(UitkMark, {
        url: logo.url,
        description: logo.description,
        size: logoImageSize
    }) : null, (icon === null || icon === void 0 ? void 0 : icon.id) ? /* @__PURE__ */ React17.createElement("span", null, /* @__PURE__ */ React17.createElement(UitkIcon4, {
        id: icon.id,
        name: icon.id,
        title: icon.title || "",
        description: icon.description,
        theme: "primary",
        size: UitkIconSize2.LARGE,
        spotlight: "standard"
    })) : null)), /* @__PURE__ */ React17.createElement(UitkLayoutFlexItem7, {
        alignSelf: "center",
        grow: 1,
        shrink: 1
    }, /* @__PURE__ */ React17.createElement(UitkSpacing7, {
        padding: {
            inlinestart: isCardBody ? "four" : "three",
            inlineend: isCardBody ? "six" : "unset",
            blockend: isCardBody ? "one" : "unset"
        }
    }, /* @__PURE__ */ React17.createElement(UitkLayoutFlex8, {
        direction: "column",
        alignItems: "start",
        blockSize: "full_size",
        justifyContent: "start"
    }, title === null || title === void 0 ? void 0 : (_title_items2 = title.items) === null || _title_items2 === void 0 ? void 0 : _title_items2.map(function(param, index) {
        var text = param.text, styles = param.styles;
        return /* @__PURE__ */ React17.createElement(UitkText9, {
            key: "text-element-".concat(index),
            theme: getTextTheme(textTheme),
            align: "left",
            size: 300,
            weight: styles[0] === "IMPORTANT" /* IMPORTANT */  ? "bold" : "regular"
        }, text);
    }), body && /* @__PURE__ */ React17.createElement(BodyField, {
        body: body,
        isCardBody: isCardBody
    }), subBody && (qrCode === null || qrCode === void 0 ? void 0 : qrCode.title) && /* @__PURE__ */ React17.createElement(SubBodyField, {
        subBody: subBody
    }), links && /* @__PURE__ */ React17.createElement(LinksField, {
        links: links,
        isMobile: true,
        referer: referer
    })))))))), dismiss && /* @__PURE__ */ React17.createElement(UitkLayoutFlexItem7, {
        alignSelf: "center"
    }, /* @__PURE__ */ React17.createElement(UitkOverlayButton3, {
        onClick: onClickDismiss,
        name: "close",
        "aria-label": "close",
        size: UitkButtonSize5.SMALL
    }, /* @__PURE__ */ React17.createElement(UitkIcon4, {
        name: "close",
        size: UitkIconSize2.SMALL
    }))))))));
};
ConfigurableBanner.displayName = "ConfigurableBanner";
// src/components/configurable-banner/configurable-banner-wrapper.tsx
var MemoizedConfigurableBanner = React18.memo(ConfigurableBanner);
var ConfigurableBannerWrapper = function(props) {
    var _ref = props || {}, _ref_data = _ref.data, notificationLocation = _ref_data.notificationLocation, title = _ref_data.title, logo = _ref_data.logo, dismiss = _ref_data.dismiss, revealActions = _ref_data.revealActions, links = _ref_data.links, containerLink = _ref_data.containerLink, body = _ref_data.body, subBody = _ref_data.subBody, icon = _ref_data.icon, customQrCode = _ref_data.customQrCode, theme = _ref_data.theme, optionalContext = _ref.inputs.optionalContext;
    var backgroundTheme = (theme === null || theme === void 0 ? void 0 : theme.__typename) === "NotificationCardTheme" ? theme === null || theme === void 0 ? void 0 : theme.themeValue : null;
    var border = (theme === null || theme === void 0 ? void 0 : theme.__typename) === "NotificationCardTheme" ? theme === null || theme === void 0 ? void 0 : theme.cardBorder : false;
    var memoizedConfigurableData = React18.useMemo(function() {
        return {
            type: "CONFIGURABLE" /* CONFIGURABLE */ ,
            notificationLocation: notificationLocation,
            title: title,
            revealActions: revealActions,
            logo: logo,
            links: links,
            containerLink: containerLink,
            dismiss: dismiss,
            referer: optionalContext === null || optionalContext === void 0 ? void 0 : optionalContext.referer,
            body: body,
            subBody: subBody,
            icon: icon,
            qrCode: customQrCode,
            backgroundTheme: backgroundTheme,
            border: border
        };
    }, []);
    if (!title) {
        return null;
    }
    return /* @__PURE__ */ React18.createElement(MemoizedConfigurableBanner, _objectSpread({}, memoizedConfigurableData));
};
// src/components/generic-notification/generic-notification-wrapper.tsx
import React21 from "react";
// src/components/generic-notification/generic-notification.tsx
import React19 from "react";
import { UitkCard as UitkCard4, UitkCardContentSection as UitkCardContentSection3 } from "uitk-react-cards";
import { UitkLink as UitkLink6 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading5, UitkText as UitkText10 } from "uitk-react-text";
var GenericNotification = function(props) {
    var heading = props.heading, body = props.body, links = props.links, revealActions = props.revealActions;
    var customerNotificationActionsExecutor = useNotificationActionExecutor();
    React19.useEffect(function() {
        customerNotificationActionsExecutor(revealActions);
    }, []);
    var handleClick = React19.useCallback(function(actions) {
        return function() {
            customerNotificationActionsExecutor(actions);
        };
    }, [
        customerNotificationActionsExecutor
    ]);
    return /* @__PURE__ */ React19.createElement(UitkCard4, {
        border: true
    }, /* @__PURE__ */ React19.createElement(UitkSpacing8, {
        padding: {
            inlinestart: "four"
        }
    }, /* @__PURE__ */ React19.createElement(UitkCardContentSection3, null, heading && /* @__PURE__ */ React19.createElement("div", null, /* @__PURE__ */ React19.createElement(UitkHeading5, {
        tag: "h3",
        size: 5
    }, heading)), body && /* @__PURE__ */ React19.createElement("div", null, body.map(function(bodyItem, index) {
        var _bodyItem_items, _bodyItem_items_;
        /* @__PURE__ */ return React19.createElement(UitkText10, {
            key: "body-".concat(index),
            spacing: "one",
            size: 300
        }, (_bodyItem_items = bodyItem.items) === null || _bodyItem_items === void 0 ? void 0 : (_bodyItem_items_ = _bodyItem_items[0]) === null || _bodyItem_items_ === void 0 ? void 0 : _bodyItem_items_.text);
    })), links && /* @__PURE__ */ React19.createElement(UitkSpacing8, {
        margin: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React19.createElement(UitkText10, {
        spacing: "three",
        size: 300
    }, links.map(function(linkItem, index) {
        var _linkItem_uri, _linkItem_icon;
        /* @__PURE__ */ return React19.createElement(UitkSpacing8, {
            key: "link-".concat(index),
            margin: {
                inlineend: "twelve"
            }
        }, /* @__PURE__ */ React19.createElement(UitkLink6, {
            inline: true
        }, /* @__PURE__ */ React19.createElement("a", {
            "aria-label": linkItem.text,
            href: (_linkItem_uri = linkItem.uri) === null || _linkItem_uri === void 0 ? void 0 : _linkItem_uri.value,
            target: "_blank",
            rel: "noopener noreferrer",
            onClick: handleClick(linkItem.actions)
        }, linkItem.text, ((_linkItem_icon = linkItem.icon) === null || _linkItem_icon === void 0 ? void 0 : _linkItem_icon.description) && /* @__PURE__ */ React19.createElement("span", {
            className: "is-visually-hidden"
        }, " ", linkItem.icon.description))));
    }))))));
};
// src/components/generic-notification/generic-notification-with-icon.tsx
import React20 from "react";
import { UitkCard as UitkCard5 } from "uitk-react-cards";
import { UitkIcon as UitkIcon5 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex9, UitkLayoutFlexItem as UitkLayoutFlexItem8 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink7 } from "uitk-react-link";
import { UitkList, UitkListItem } from "uitk-react-list";
import { UitkSpacing as UitkSpacing9 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading6, UitkText as UitkText11 } from "uitk-react-text";
var GenericNotificationWithIcon = function(props) {
    var heading = props.heading, body = props.body, links = props.links, icon = props.icon, revealActions = props.revealActions;
    var customerNotificationActionsExecutor = useNotificationActionExecutor();
    React20.useEffect(function() {
        customerNotificationActionsExecutor(revealActions);
    }, []);
    var handleClick = React20.useCallback(function(actions) {
        return function() {
            customerNotificationActionsExecutor(actions);
        };
    }, [
        customerNotificationActionsExecutor
    ]);
    var _icon_description, _icon_title;
    return /* @__PURE__ */ React20.createElement(UitkCard5, {
        padded: true,
        border: true
    }, /* @__PURE__ */ React20.createElement(UitkLayoutFlex9, {
        alignItems: "center",
        space: "three"
    }, /* @__PURE__ */ React20.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React20.createElement("div", null, /* @__PURE__ */ React20.createElement(UitkIcon5, {
        id: icon.description || icon.title ? "generic-notification-icon-".concat(icon.id) : void 0,
        name: icon.id,
        spotlight: "info",
        description: (_icon_description = icon.description) !== null && _icon_description !== void 0 ? _icon_description : void 0,
        title: (_icon_title = icon.title) !== null && _icon_title !== void 0 ? _icon_title : void 0
    }))), /* @__PURE__ */ React20.createElement(UitkLayoutFlexItem8, null, /* @__PURE__ */ React20.createElement("div", null, heading && /* @__PURE__ */ React20.createElement(UitkHeading6, {
        size: 7,
        tag: "h2"
    }, heading), body && /* @__PURE__ */ React20.createElement(UitkSpacing9, {
        margin: {
            blockstart: "half"
        }
    }, body.map(function(bodyItem, index) {
        var _bodyItem_items, _bodyItem_items_;
        /* @__PURE__ */ return React20.createElement(UitkText11, {
            key: "body-text-".concat(index)
        }, (_bodyItem_items = bodyItem.items) === null || _bodyItem_items === void 0 ? void 0 : (_bodyItem_items_ = _bodyItem_items[0]) === null || _bodyItem_items_ === void 0 ? void 0 : _bodyItem_items_.text);
    })), links && /* @__PURE__ */ React20.createElement(UitkList, {
        bullet: "no-bullet",
        orientation: "inline",
        size: 2,
        spacing: true,
        type: "unordered"
    }, /* @__PURE__ */ React20.createElement(UitkListItem, null, links.map(function(linkItem, index) {
        var _linkItem_uri;
        /* @__PURE__ */ return React20.createElement(UitkLink7, {
            inline: true,
            key: "link-text-".concat(index)
        }, /* @__PURE__ */ React20.createElement("a", {
            href: (_linkItem_uri = linkItem.uri) === null || _linkItem_uri === void 0 ? void 0 : _linkItem_uri.value,
            "aria-label": linkItem.text,
            onClick: handleClick(linkItem.actions)
        }, linkItem.text));
    })))))));
};
// src/components/generic-notification/generic-notification-wrapper.tsx
var GenericNotificationWrapper = function(props) {
    var _title_items, _title_items_, _title_items1, _title_items_1;
    var data = props.data;
    var _ref = data || {}, title = _ref.title, body = _ref.body, links = _ref.links, revealActions = _ref.revealActions, icon = _ref.icon;
    return icon ? /* @__PURE__ */ React21.createElement(GenericNotificationWithIcon, {
        heading: title === null || title === void 0 ? void 0 : (_title_items = title.items) === null || _title_items === void 0 ? void 0 : (_title_items_ = _title_items[0]) === null || _title_items_ === void 0 ? void 0 : _title_items_.text,
        body: body,
        links: links,
        icon: icon,
        revealActions: revealActions
    }) : /* @__PURE__ */ React21.createElement(GenericNotification, {
        heading: title === null || title === void 0 ? void 0 : (_title_items1 = title.items) === null || _title_items1 === void 0 ? void 0 : (_title_items_1 = _title_items1[0]) === null || _title_items_1 === void 0 ? void 0 : _title_items_1.text,
        body: body,
        links: links,
        revealActions: revealActions
    });
};
// src/components/header-banner/header-banner-wrapper.tsx
import React23 from "react";
// src/components/header-banner/header-banner.tsx
import React22 from "react";
import { useApolloClient as useApolloClient4 } from "@apollo/client";
import { UitkButtonSize as UitkButtonSize6, UitkOverlayButton as UitkOverlayButton4 } from "uitk-react-button";
import { UitkIcon as UitkIcon6, UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex10, UitkLayoutFlexItem as UitkLayoutFlexItem9 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing10 } from "uitk-react-spacing";
import { UitkText as UitkText12 } from "uitk-react-text";
import { UitkViewRow as UitkViewRow4 } from "uitk-react-view";
var HeaderBanner = function(param) {
    var type = param.type, notificationLocation = param.notificationLocation, title = param.title, revealActions = param.revealActions, logo = param.logo, containerLink = param.containerLink, dismiss = param.dismiss, referrer = param.referrer, body = param.body;
    var _containerLink_uri, _title_items;
    var customerNotificationActionsExecutor = useNotificationActionExecutor();
    var _React22_useState = _slicedToArray(React22.useState(true), 2), display = _React22_useState[0], setDisplay = _React22_useState[1];
    var cache = useApolloClient4().cache;
    React22.useEffect(function() {
        customerNotificationActionsExecutor(revealActions);
    }, []);
    if (!display) {
        return null;
    }
    var bannerLink = createDeepLinkUrl(containerLink === null || containerLink === void 0 ? void 0 : (_containerLink_uri = containerLink.uri) === null || _containerLink_uri === void 0 ? void 0 : _containerLink_uri.value, referrer);
    var onClickDismiss = function() {
        setDisplay(false);
        customerNotificationActionsExecutor(dismiss === null || dismiss === void 0 ? void 0 : dismiss.actions);
        cacheEviction(cache, type, notificationLocation);
    };
    var onCardClick = function() {
        customerNotificationActionsExecutor(containerLink === null || containerLink === void 0 ? void 0 : containerLink.actions);
    };
    return /* @__PURE__ */ React22.createElement(UitkViewRow4, {
        canvasTheme: "brand_promo_primary",
        layout: "centered"
    }, /* @__PURE__ */ React22.createElement(UitkLayoutFlex10, {
        direction: "row",
        alignItems: "center",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React22.createElement(UitkLayoutFlexItem9, {
        alignSelf: "center"
    }, /* @__PURE__ */ React22.createElement("section", null, /* @__PURE__ */ React22.createElement("a", {
        href: bannerLink,
        onClick: onCardClick,
        onKeyDown: onCardClick
    }, /* @__PURE__ */ React22.createElement(UitkSpacing10, {
        padding: {
            block: "three"
        }
    }, /* @__PURE__ */ React22.createElement(UitkLayoutFlex10, {
        direction: "row",
        alignItems: "center",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React22.createElement(UitkLayoutFlexItem9, {
        alignSelf: "center",
        grow: 0,
        shrink: 1
    }, /* @__PURE__ */ React22.createElement("img", {
        alt: logo.description,
        src: logo.url,
        width: "48",
        height: "48"
    })), /* @__PURE__ */ React22.createElement(UitkLayoutFlexItem9, {
        alignSelf: "center",
        grow: 1,
        shrink: 1
    }, /* @__PURE__ */ React22.createElement(UitkLayoutFlex10, {
        direction: "column",
        alignItems: "start",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, title && /* @__PURE__ */ React22.createElement(UitkSpacing10, {
        padding: {
            inlinestart: "three"
        }
    }, (_title_items = title.items) === null || _title_items === void 0 ? void 0 : _title_items.map(function(param, index) {
        var text = param.text;
        return /* @__PURE__ */ React22.createElement(UitkText12, {
            key: "text-element-".concat(index),
            theme: "inverse",
            align: "left",
            size: 300,
            weight: "medium"
        }, text);
    })), body && /* @__PURE__ */ React22.createElement(UitkSpacing10, {
        padding: {
            inlinestart: "three"
        }
    }, body.map(function(bodyItem, index) {
        var _bodyItem_items;
        return (_bodyItem_items = bodyItem.items) === null || _bodyItem_items === void 0 ? void 0 : _bodyItem_items.map(function(param, textIndex) {
            var text = param.text;
            return /* @__PURE__ */ React22.createElement(UitkText12, {
                key: "body-".concat(index, ".item-").concat(textIndex),
                theme: "inverse",
                align: "left",
                size: 300
            }, text);
        });
    }))))))))), /* @__PURE__ */ React22.createElement(UitkLayoutFlexItem9, {
        alignSelf: "center"
    }, /* @__PURE__ */ React22.createElement(UitkOverlayButton4, {
        onClick: onClickDismiss,
        name: "close",
        "aria-label": "close",
        size: UitkButtonSize6.SMALL
    }, /* @__PURE__ */ React22.createElement(UitkIcon6, {
        name: "close",
        size: UitkIconSize3.SMALL
    })))));
};
HeaderBanner.displayName = "HeaderBanner";
// src/components/header-banner/header-banner-wrapper.tsx
var HeaderBannerWrapper = function(props) {
    var _ref = props || {}, _ref_data = _ref.data, type = _ref_data.type, notificationLocation = _ref_data.notificationLocation, title = _ref_data.title, logo = _ref_data.logo, dismiss = _ref_data.dismiss, revealActions = _ref_data.revealActions, containerLink = _ref_data.containerLink, body = _ref_data.body, optionalContext = _ref.inputs.optionalContext;
    if (!logo || !dismiss) {
        return null;
    }
    return /* @__PURE__ */ React23.createElement(HeaderBanner, {
        type: type,
        notificationLocation: notificationLocation,
        title: title,
        logo: logo,
        containerLink: containerLink,
        revealActions: revealActions,
        dismiss: dismiss,
        referrer: optionalContext === null || optionalContext === void 0 ? void 0 : optionalContext.referer,
        body: body
    });
};
// src/components/mad-marquee/mad-marquee-form-section-wrapper.tsx
import React30 from "react";
// src/components/mad-marquee/mad-marquee-form-section.tsx
import React29 from "react";
import { UitkLayoutFlex as UitkLayoutFlex11, UitkLayoutFlexItem as UitkLayoutFlexItem10 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing11 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading7 } from "uitk-react-text";
// src/components/mad-marquee/form-field/selection-field.tsx
import React25 from "react";
import { UitkSelect } from "uitk-react-input";
// src/components/mad-marquee/context.tsx
import React24 from "react";
var initialFormState = {
    countryCode: "",
    phoneNumber: "",
    phoneNumberErrMsg: "",
    hasInvalidFields: false
};
var FormContext = React24.createContext({
    state: initialFormState
});
var reducer = function(state, param) {
    var field = param.field, value = param.value;
    return _objectSpreadProps(_objectSpread({}, state), _defineProperty({}, field, value));
};
var FormProvider = function(props) {
    var children = props.children, defaultSelectedOptionVal = props.defaultSelectedOptionVal;
    var formState = _objectSpreadProps(_objectSpread({}, initialFormState), {
        countryCode: defaultSelectedOptionVal
    });
    var _React24_useReducer = _slicedToArray(React24.useReducer(reducer, formState), 2), state = _React24_useReducer[0], dispatch = _React24_useReducer[1];
    return /* @__PURE__ */ React24.createElement(FormContext.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        }
    }, children);
};
// src/components/mad-marquee/form-field/selection-field.tsx
var CustomerNotificationSelectionField = function(props) {
    var data = props.data;
    var _ref = data || {}, label = _ref.label, id = _ref.id, options = _ref.options;
    var _React25_useContext = React25.useContext(FormContext), state = _React25_useContext.state, dispatch = _React25_useContext.dispatch;
    if (!options || !options.length) {
        return null;
    }
    return /* @__PURE__ */ React25.createElement(UitkSelect, {
        id: id,
        name: id,
        label: label,
        value: state.countryCode,
        onChange: function(event) {
            return dispatch({
                field: event.target.name,
                value: event.target.value
            });
        }
    }, options.map(function(option) {
        return /* @__PURE__ */ React25.createElement("option", {
            key: option.id,
            value: option.value
        }, option.id === state.countryCode ? option.shortLabel : option.text);
    }));
};
CustomerNotificationSelectionField.displayName = "CustomerNotificationSelectionField";
// src/components/mad-marquee/form-field/text-input-field.tsx
import React26 from "react";
import { UitkTextInput } from "uitk-react-input";
var CustomerNotificationTextInputField = function(props) {
    var data = props.data;
    var _ref = data || {}, label = _ref.label, id = _ref.id;
    var _React26_useContext = React26.useContext(FormContext), state = _React26_useContext.state, dispatch = _React26_useContext.dispatch;
    var inputRef = React26.useRef();
    React26.useEffect(function() {
        if (state.hasInvalidFields && (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) && typeof (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current.focus) === "function") {
            inputRef === null || inputRef === void 0 ? void 0 : inputRef.current.focus();
        }
    }, [
        inputRef,
        state.hasInvalidFields
    ]);
    return /* @__PURE__ */ React26.createElement(UitkTextInput, {
        id: id,
        name: id,
        label: label,
        value: state.phoneNumber,
        invalid: state.phoneNumberErrMsg,
        onChange: function(event) {
            return dispatch({
                field: event.target.name,
                value: event.target.value
            });
        },
        domRef: inputRef
    });
};
CustomerNotificationTextInputField.displayName = "CustomerNotificationTextInputField";
// src/components/mad-marquee/form-field/submit-button.tsx
import React27 from "react";
import { UitkButtonSize as UitkButtonSize7 } from "uitk-react-button";
// src/components/mad-marquee/mad-marquee-button-dictionary.ts
import { UitkPrimaryButton as UitkPrimaryButton4, UitkSecondaryButton as UitkSecondaryButton3 } from "uitk-react-button";
var _obj5;
var BUTTON_DICTIONARY2 = (_obj5 = {}, _defineProperty(_obj5, "PRIMARY_BUTTON" /* PRIMARY_BUTTON */ , UitkPrimaryButton4), _defineProperty(_obj5, "SECONDARY_BUTTON" /* SECONDARY_BUTTON */ , UitkSecondaryButton3), _obj5);
var getButtonComponent3 = function(buttonType) {
    return BUTTON_DICTIONARY2["".concat(buttonType)] || UitkPrimaryButton4;
};
// src/components/mad-marquee/form-field/submit-button.tsx
var CustomerNotificationSubmitButton = function(props) {
    var data = props.data;
    var _ref = data || {}, id = _ref.id, label = _ref.label, buttonType = _ref.buttonType;
    var ButtonComponent = getButtonComponent3(buttonType);
    return /* @__PURE__ */ React27.createElement(ButtonComponent, {
        id: id,
        name: id,
        type: "submit",
        size: UitkButtonSize7.LARGE,
        isFullWidth: true
    }, label);
};
CustomerNotificationSubmitButton.displayName = "CustomerNotificationSubmitButton";
// src/components/mad-marquee/mad-marquee-form-fields-dictionary.ts
var FORM_FIELDS_DICTIONARY = {
    NotificationTextInputField: CustomerNotificationTextInputField,
    NotificationSubmitButton: CustomerNotificationSubmitButton,
    NotificationSelectionField: CustomerNotificationSelectionField
};
// src/components/mad-marquee/marquee-context.tsx
import React28 from "react";
var initialMarqueeState = {
    rootElements: {
        heading: false,
        body: false,
        qrCode: false,
        formSections: false,
        qrCodeTitle: false,
        backgroundImageUrl: false
    }
};
var MarqueeContext = React28.createContext(initialMarqueeState);
var MarqueeProvider = function(props) {
    var _title_items_, _customQrCode_image, _customQrCode_image1;
    var children = props.children, data = props.data;
    var title = data.title, body = data.body, customQrCode = data.customQrCode, form = data.form, backgroundImage = data.backgroundImage;
    var heading = (_title_items_ = title === null || title === void 0 ? void 0 : title.items[0]) === null || _title_items_ === void 0 ? void 0 : _title_items_.text;
    var qrCode = (customQrCode === null || customQrCode === void 0 ? void 0 : (_customQrCode_image = customQrCode.image) === null || _customQrCode_image === void 0 ? void 0 : _customQrCode_image.url) && (customQrCode === null || customQrCode === void 0 ? void 0 : (_customQrCode_image1 = customQrCode.image) === null || _customQrCode_image1 === void 0 ? void 0 : _customQrCode_image1.description);
    var formSections = form === null || form === void 0 ? void 0 : form.sections;
    var qrCodeTitle = customQrCode === null || customQrCode === void 0 ? void 0 : customQrCode.title;
    var backgroundImageUrl = backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.url;
    var marqueeState = {
        rootElements: {
            heading: !!heading,
            body: !!body,
            qrCode: !!qrCode,
            formSections: !!formSections,
            qrCodeTitle: !!qrCodeTitle,
            backgroundImageUrl: !!backgroundImageUrl
        }
    };
    return /* @__PURE__ */ React28.createElement(MarqueeContext.Provider, {
        value: marqueeState
    }, children);
};
var useMarqueeContext = function() {
    return React28.useContext(MarqueeContext);
};
// src/components/mad-marquee/mad-marquee-form-section.tsx
var MadMarqueeFormSection = function(props) {
    var title = props.title, fields = props.fields, formTitle = props.formTitle;
    var rootElements = useMarqueeContext().rootElements;
    var titlePadding = !rootElements.body && !rootElements.heading ? "unset" : "six";
    return /* @__PURE__ */ React29.createElement(React29.Fragment, null, title && /* @__PURE__ */ React29.createElement(UitkSpacing11, {
        padding: {
            blockstart: titlePadding,
            blockend: "three"
        }
    }, /* @__PURE__ */ React29.createElement("div", null, /* @__PURE__ */ React29.createElement(UitkHeading7, {
        tag: "h3",
        size: 5
    }, title))), formTitle && /* @__PURE__ */ React29.createElement("span", {
        className: "is-visually-hidden"
    }, formTitle), /* @__PURE__ */ React29.createElement(UitkSpacing11, {
        padding: {
            blockstart: title ? "unset" : "six"
        }
    }, /* @__PURE__ */ React29.createElement(UitkLayoutFlex11, {
        space: "four",
        wrap: "wrap"
    }, fields.map(function(field, index) {
        var FormFieldComponent = FORM_FIELDS_DICTIONARY[field.__typename];
        return /* @__PURE__ */ React29.createElement(UitkLayoutFlexItem10, {
            key: index,
            grow: 2,
            minWidth: "twenty_four"
        }, /* @__PURE__ */ React29.createElement("div", null, /* @__PURE__ */ React29.createElement(FormFieldComponent, {
            data: field
        })));
    }))));
};
MadMarqueeFormSection.displayName = "MadMarqueeFormSection";
// src/components/mad-marquee/mad-marquee-form-section-wrapper.tsx
var MadMarqueeFormSectionWrapper = function(param) {
    var data = param.data, formTitle = param.formTitle;
    var _ref = data || {}, title = _ref.title, fields = _ref.fields;
    if (!fields || !fields.length) {
        return null;
    }
    return /* @__PURE__ */ React30.createElement(MadMarqueeFormSection, {
        title: title,
        fields: fields,
        formTitle: formTitle
    });
};
// src/components/mad-marquee/mad-marquee-wrapper.tsx
import React40 from "react";
// src/components/mad-marquee/custom-inpage-marquee.tsx
import React35 from "react";
import { ViewLarge as ViewLarge2, ViewMedium as ViewMedium4, Viewport as Viewport4, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard6, UitkCardContentSection as UitkCardContentSection4 } from "uitk-react-cards";
import { UitkFigure as UitkFigure5, UitkFigureAspectRatioType as UitkFigureAspectRatioType3, UitkImage as UitkImage4 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex12, UitkLayoutFlexItem as UitkLayoutFlexItem11 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid5, UitkLayoutGridItem as UitkLayoutGridItem5 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing14 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading8 } from "uitk-react-text";
// src/components/mad-marquee/mad-marquee-sub-section.tsx
import React31 from "react";
import { UitkList as UitkList2, UitkListItem as UitkListItem2 } from "uitk-react-list";
import { UitkSpacing as UitkSpacing12 } from "uitk-react-spacing";
import { UitkText as UitkText13 } from "uitk-react-text";
var MadMarqueeSubSection = function(props) {
    var _body__items, _body__items_;
    var body = props.body, isMobile = props.isMobile;
    var rootElements = useMarqueeContext().rootElements;
    var formSections = rootElements.formSections, qrCode = rootElements.qrCode, qrCodeTitle = rootElements.qrCodeTitle;
    var isPromoMarquee = !formSections && qrCode && qrCodeTitle;
    var spacingProps = isMobile ? {
        padding: {
            blockstart: "one",
            blockend: "two"
        }
    } : {
        padding: {
            blockstart: "two",
            inlineend: "four"
        }
    };
    return /* @__PURE__ */ React31.createElement(React31.Fragment, null, isPromoMarquee && /* @__PURE__ */ React31.createElement(UitkSpacing12, {
        padding: {
            blockstart: "six",
            inlineend: "four",
            blockend: "six"
        }
    }, /* @__PURE__ */ React31.createElement(UitkList2, {
        spacing: false
    }, body.map(function(bodyItem, index) {
        var _bodyItem_items;
        var item = (_bodyItem_items = bodyItem.items) === null || _bodyItem_items === void 0 ? void 0 : _bodyItem_items[0];
        return /* @__PURE__ */ React31.createElement(UitkText13, {
            key: index,
            weight: item.styles[0] === "IMPORTANT" /* IMPORTANT */  ? "bold" : "regular",
            size: item.styles[0] === "IMPORTANT" /* IMPORTANT */  ? 500 : 400
        }, item === null || item === void 0 ? void 0 : item.text);
    }))), body.length > 1 && !isPromoMarquee && /* @__PURE__ */ React31.createElement(UitkSpacing12, {
        padding: {
            blockstart: "three",
            inlineend: "four"
        }
    }, /* @__PURE__ */ React31.createElement(UitkList2, {
        spacing: false
    }, body.map(function(bodyItem, index) {
        var _bodyItem_items, _bodyItem_items_;
        /* @__PURE__ */ return React31.createElement(UitkListItem2, {
            key: index
        }, (_bodyItem_items = bodyItem.items) === null || _bodyItem_items === void 0 ? void 0 : (_bodyItem_items_ = _bodyItem_items[0]) === null || _bodyItem_items_ === void 0 ? void 0 : _bodyItem_items_.text);
    }))), body.length === 1 && !isPromoMarquee && /* @__PURE__ */ React31.createElement(UitkSpacing12, {
        padding: spacingProps.padding
    }, /* @__PURE__ */ React31.createElement(UitkText13, {
        className: "uitk-type-paragraph-300"
    }, (_body__items = body[0].items) === null || _body__items === void 0 ? void 0 : (_body__items_ = _body__items[0]) === null || _body__items_ === void 0 ? void 0 : _body__items_.text)));
};
MadMarqueeSubSection.displayName = "MadMarqueeSubSection";
// src/components/mad-marquee/marquee-button-link-component.tsx
import React32 from "react";
import { UitkButtonSize as UitkButtonSize8 } from "uitk-react-button";
var MarqueeButtonLinkComponent = function(param) {
    var appDownloadLink = param.appDownloadLink, tuneLink = param.tuneLink, onClickButton = param.onClickButton;
    var ButtonComponent = getButtonComponent3(tuneLink.type);
    return /* @__PURE__ */ React32.createElement(ButtonComponent, {
        id: "download-btn",
        name: "download-btn",
        href: appDownloadLink,
        onClick: onClickButton,
        size: UitkButtonSize8.LARGE,
        isFullWidth: true
    }, tuneLink.text);
};
// src/components/mad-marquee/marquee-secondary-link-component.tsx
import React33 from "react";
import { UitkLink as UitkLink8 } from "uitk-react-link";
var MarqueeSecondaryLinkComponent = function(param) {
    var onSecondaryClickButton = param.onSecondaryClickButton, secondaryLink = param.secondaryLink, secondLink = param.secondLink;
    /* @__PURE__ */ return React33.createElement(UitkLink8, {
        noWrap: true,
        inline: true,
        onClick: onSecondaryClickButton
    }, /* @__PURE__ */ React33.createElement("a", {
        "aria-label": secondLink === null || secondLink === void 0 ? void 0 : secondLink.text,
        href: secondaryLink,
        target: "_blank",
        rel: "noopener noreferrer"
    }, secondLink === null || secondLink === void 0 ? void 0 : secondLink.text));
};
// src/components/mad-marquee/marquee-sub-body-component.tsx
import React34 from "react";
import { UitkSpacing as UitkSpacing13 } from "uitk-react-spacing";
import { UitkText as UitkText14 } from "uitk-react-text";
var MarqueeSubBodyComponent = function(param) {
    var subBody = param.subBody;
    if (subBody && subBody[0].title.egdsItems.length === 0) {
        return null;
    }
    var titleItem = subBody === null || subBody === void 0 ? void 0 : subBody[0].title.egdsItems[0];
    var titleText = titleItem && "text" in titleItem && titleItem.text;
    var titleWeight = titleItem && "weight" in titleItem && titleItem.weight || void 0;
    if (!titleText || !titleWeight) {
        return null;
    }
    return /* @__PURE__ */ React34.createElement(UitkSpacing13, {
        padding: {
            blockstart: "twelve",
            inlineend: "four",
            blockend: "two"
        }
    }, /* @__PURE__ */ React34.createElement(UitkText14, {
        weight: titleWeight && UitkTextWeightMap[titleWeight],
        size: 400
    }, titleText));
};
// src/components/mad-marquee/custom-inpage-marquee.tsx
var CustomInpageMarquee = function(props) {
    var _tuneLink_uri, _secondLink_uri;
    var backgroundImageUrl = props.backgroundImageUrl, backgroundImageDescription = props.backgroundImageDescription, heading = props.heading, body = props.body, subBody = props.subBody, qrCodeUrl = props.qrCodeUrl, qrCodeDesc = props.qrCodeDesc, qrCodeTitle = props.qrCodeTitle, tuneLink = props.tuneLink, secondLink = props.secondLink, revealActions = props.revealActions, referer = props.referer;
    var customerNotificationActionsExecutor = useNotificationActionExecutor();
    React35.useEffect(function() {
        customerNotificationActionsExecutor(revealActions);
    }, []);
    var onClickButton = function() {
        customerNotificationActionsExecutor(tuneLink.actions);
    };
    var onSecondaryClickButton = function() {
        customerNotificationActionsExecutor(secondLink === null || secondLink === void 0 ? void 0 : secondLink.actions);
    };
    var regionColumns = 4;
    var placementId = "app_72";
    var isSlim = false;
    var isPromoMarquee = false;
    if (qrCodeUrl && qrCodeDesc) {
        placementId = "app_71";
        regionColumns = 3;
        if (body && qrCodeTitle) {
            regionColumns = 5;
            isSlim = true;
            isPromoMarquee = true;
        }
    }
    var appDownloadLink = createDeepLinkUrl((_tuneLink_uri = tuneLink.uri) === null || _tuneLink_uri === void 0 ? void 0 : _tuneLink_uri.value, referer);
    var secondaryLink = createDeepLinkUrl(secondLink === null || secondLink === void 0 ? void 0 : (_secondLink_uri = secondLink.uri) === null || _secondLink_uri === void 0 ? void 0 : _secondLink_uri.value, referer);
    return /* @__PURE__ */ React35.createElement(Viewport4, null, /* @__PURE__ */ React35.createElement(ViewLarge2, null, /* @__PURE__ */ React35.createElement(UitkCard6, {
        border: true
    }, /* @__PURE__ */ React35.createElement(UitkLayoutGrid5, {
        columns: 3
    }, /* @__PURE__ */ React35.createElement(UitkLayoutGridItem5, {
        colSpan: 3
    }, /* @__PURE__ */ React35.createElement(UitkCardContentSection4, {
        padded: false
    }, /* @__PURE__ */ React35.createElement(UitkSpacing14, {
        padding: "six"
    }, /* @__PURE__ */ React35.createElement(UitkLayoutGrid5, {
        columns: isSlim ? 7 : 4,
        space: "half"
    }, /* @__PURE__ */ React35.createElement(UitkLayoutGridItem5, {
        alignSelf: "start",
        colSpan: regionColumns
    }, /* @__PURE__ */ React35.createElement("div", {
        role: "region",
        "aria-labelledby": "marquee-title"
    }, /* @__PURE__ */ React35.createElement(UitkSpacing14, {
        padding: {
            blockend: isSlim ? "six" : "one"
        }
    }, heading && /* @__PURE__ */ React35.createElement(UitkHeading8, {
        tag: "h2",
        size: 3,
        id: "marquee-title"
    }, heading)), body && /* @__PURE__ */ React35.createElement(MadMarqueeSubSection, {
        body: body
    }), subBody && /* @__PURE__ */ React35.createElement(MarqueeSubBodyComponent, {
        subBody: subBody
    }))), qrCodeUrl && qrCodeDesc && /* @__PURE__ */ React35.createElement(UitkLayoutGridItem5, {
        colSpan: isPromoMarquee ? 2 : 1
    }, /* @__PURE__ */ React35.createElement("div", null, qrCodeTitle && /* @__PURE__ */ React35.createElement("div", {
        role: "definition",
        "aria-labelledby": "qrCodeTitle"
    }, /* @__PURE__ */ React35.createElement("input", {
        type: "hidden",
        id: "qrCodeTitle",
        "aria-label": qrCodeTitle
    })), /* @__PURE__ */ React35.createElement(UitkSpacing14, {
        padding: {
            blockstart: isPromoMarquee ? "unset" : "four"
        }
    }, /* @__PURE__ */ React35.createElement("div", null, /* @__PURE__ */ React35.createElement(UitkFigure5, {
        ratio: UitkFigureAspectRatioType3.R1_1
    }, /* @__PURE__ */ React35.createElement(UitkImage4, {
        src: qrCodeUrl,
        alt: qrCodeDesc
    })))), qrCodeTitle && /* @__PURE__ */ React35.createElement(UitkSpacing14, {
        padding: {
            inlinestart: "four"
        }
    }, /* @__PURE__ */ React35.createElement(UitkHeading8, {
        tag: "h3",
        align: "center",
        size: 7,
        "aria-hidden": "true"
    }, qrCodeTitle))))))))))), /* @__PURE__ */ React35.createElement(ViewMedium4, null, /* @__PURE__ */ React35.createElement(UitkCard6, {
        border: true
    }, /* @__PURE__ */ React35.createElement(UitkLayoutGrid5, {
        columns: 3
    }, /* @__PURE__ */ React35.createElement(React35.Fragment, null, backgroundImageUrl && /* @__PURE__ */ React35.createElement(UitkLayoutGridItem5, {
        colSpan: 1
    }, /* @__PURE__ */ React35.createElement(UitkFigure5, {
        ratio: UitkFigureAspectRatioType3.R16_9
    }, /* @__PURE__ */ React35.createElement(UitkImage4, {
        placeholderImage: true,
        src: backgroundImageUrl,
        alt: backgroundImageDescription
    }))), /* @__PURE__ */ React35.createElement(UitkLayoutGridItem5, {
        colSpan: backgroundImageUrl ? 2 : 3
    }, /* @__PURE__ */ React35.createElement(UitkCardContentSection4, {
        padded: false
    }, /* @__PURE__ */ React35.createElement(UitkSpacing14, {
        padding: "six"
    }, /* @__PURE__ */ React35.createElement("div", {
        role: "region",
        "aria-labelledby": "marquee-title"
    }, /* @__PURE__ */ React35.createElement(UitkHeading8, {
        tag: "h2",
        size: 3,
        id: "marquee-title"
    }, heading), body && /* @__PURE__ */ React35.createElement(MadMarqueeSubSection, {
        body: body
    }), /* @__PURE__ */ React35.createElement(UitkLayoutGrid5, {
        space: "six",
        columns: secondLink ? 8 : 6
    }, /* @__PURE__ */ React35.createElement(UitkLayoutGridItem5, {
        colSpan: isSlim ? 8 : 4
    }, /* @__PURE__ */ React35.createElement(UitkSpacing14, {
        padding: {
            blockstart: isSlim ? "unset" : "six"
        }
    }, /* @__PURE__ */ React35.createElement("div", null, /* @__PURE__ */ React35.createElement(MarqueeButtonLinkComponent, {
        appDownloadLink: appDownloadLink,
        tuneLink: tuneLink,
        onClickButton: onClickButton
    })))), secondLink && /* @__PURE__ */ React35.createElement(UitkLayoutGridItem5, {
        alignSelf: "center",
        colSpan: 1
    }, /* @__PURE__ */ React35.createElement(UitkSpacing14, {
        padding: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React35.createElement("div", null, /* @__PURE__ */ React35.createElement(MarqueeSecondaryLinkComponent, {
        secondaryLink: secondaryLink,
        onSecondaryClickButton: onSecondaryClickButton,
        secondLink: secondLink
    }))))))))))))), /* @__PURE__ */ React35.createElement(ViewSmall4, null, /* @__PURE__ */ React35.createElement(UitkCard6, {
        border: true
    }, backgroundImageUrl && /* @__PURE__ */ React35.createElement(UitkFigure5, {
        className: "all-image-fit-cover",
        ratio: UitkFigureAspectRatioType3.R21_9
    }, /* @__PURE__ */ React35.createElement(UitkImage4, {
        placeholderImage: true,
        src: backgroundImageUrl,
        alt: backgroundImageDescription
    })), /* @__PURE__ */ React35.createElement(UitkCardContentSection4, {
        padded: false
    }, /* @__PURE__ */ React35.createElement(UitkSpacing14, {
        padding: "six"
    }, /* @__PURE__ */ React35.createElement(UitkLayoutGrid5, {
        columns: 4
    }, /* @__PURE__ */ React35.createElement(UitkLayoutGridItem5, {
        colSpan: 4
    }, /* @__PURE__ */ React35.createElement("div", {
        role: "region",
        "aria-labelledby": "marquee-title"
    }, /* @__PURE__ */ React35.createElement(UitkHeading8, {
        tag: "h2",
        size: 5,
        id: "marquee-title"
    }, heading), body && /* @__PURE__ */ React35.createElement(MadMarqueeSubSection, {
        body: body,
        isMobile: true
    }), /* @__PURE__ */ React35.createElement(UitkSpacing14, {
        padding: {
            blockstart: isSlim ? "unset" : "four"
        }
    }, /* @__PURE__ */ React35.createElement(UitkLayoutFlex12, {
        space: "four",
        direction: "column",
        alignItems: "center"
    }, /* @__PURE__ */ React35.createElement(React35.Fragment, null, /* @__PURE__ */ React35.createElement(UitkLayoutFlexItem11, null, /* @__PURE__ */ React35.createElement(MarqueeButtonLinkComponent, {
        appDownloadLink: appDownloadLink,
        tuneLink: tuneLink,
        onClickButton: onClickButton
    })), secondLink && /* @__PURE__ */ React35.createElement(UitkLayoutFlexItem11, null, /* @__PURE__ */ React35.createElement(UitkSpacing14, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React35.createElement("div", null, /* @__PURE__ */ React35.createElement(MarqueeSecondaryLinkComponent, {
        secondaryLink: secondaryLink,
        onSecondaryClickButton: onSecondaryClickButton,
        secondLink: secondLink
    })))))))))))))));
};
CustomInpageMarquee.displayName = "CustomInpageMarquee";
// src/components/mad-marquee/mad-marquee.tsx
import React39 from "react";
import { ViewLarge as ViewLarge3, ViewMedium as ViewMedium5, Viewport as Viewport5, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";
import { UitkCard as UitkCard7, UitkCardContentSection as UitkCardContentSection5 } from "uitk-react-cards";
import { UitkFigure as UitkFigure6, UitkFigureAspectRatioType as UitkFigureAspectRatioType4, UitkImage as UitkImage5 } from "uitk-react-images";
import { UitkLayoutFlex as UitkLayoutFlex13, UitkLayoutFlexItem as UitkLayoutFlexItem12 } from "uitk-react-layout-flex";
import { UitkLayoutGrid as UitkLayoutGrid6, UitkLayoutGridItem as UitkLayoutGridItem6 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing17 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading9 } from "uitk-react-text";
// src/components/mad-marquee/mad-marquee-form-wrapper.tsx
import React37 from "react";
// src/components/mad-marquee/mad-marquee-form.tsx
import React36 from "react";
import { useMutation } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { UitkLoader } from "uitk-react-loader";
import { UitkSpacing as UitkSpacing15 } from "uitk-react-spacing";
import { UitkText as UitkText15 } from "uitk-react-text";
import { Level, liveAnnounce } from "uitk-react-utils";
// src/components/mad-marquee/mutation/send-text-to-download-app-mutation.tsx
import { gql as gql2 } from "@apollo/client";
var SendTextToDownloadAppMutation = gql2(_templateObject1());
// src/components/mad-marquee/mad-marquee-form.tsx
var MadMarqueeForm = function(props) {
    var _formSections_, _formSections__fields, _submitBtn_actions, _data_sendTextToDownloadApp, _data_sendTextToDownloadApp1, _data_sendTextToDownloadApp2, _formMessages_;
    var formTitle = props.formTitle, formSections = props.formSections, formMessages = props.formMessages, placementId = props.placementId, successFormAnalytics = props.successFormAnalytics, errorFormAnalytics = props.errorFormAnalytics;
    var customerNotificationActionsExecutor = useNotificationActionExecutor();
    var submitBtn = (_formSections_ = formSections[0]) === null || _formSections_ === void 0 ? void 0 : (_formSections__fields = _formSections_.fields) === null || _formSections__fields === void 0 ? void 0 : _formSections__fields.find(function(field) {
        return field.__typename === "NotificationSubmitButton";
    });
    var submitFormButtonAction = submitBtn === null || submitBtn === void 0 ? void 0 : (_submitBtn_actions = submitBtn.actions) === null || _submitBtn_actions === void 0 ? void 0 : _submitBtn_actions.find(function(action) {
        return action.__typename === "NotificationAnalytics";
    });
    var successActions = (submitFormButtonAction === null || submitFormButtonAction === void 0 ? void 0 : submitFormButtonAction.schema) ? submitBtn === null || submitBtn === void 0 ? void 0 : submitBtn.actions : successFormAnalytics;
    var _useMutation = _slicedToArray(useMutation(SendTextToDownloadAppMutation), 2), textToDownloadMutation = _useMutation[0], _useMutation_ = _useMutation[1], loading = _useMutation_.loading, error = _useMutation_.error, data = _useMutation_.data;
    var _React36_useContext = React36.useContext(FormContext), state = _React36_useContext.state, dispatch = _React36_useContext.dispatch;
    var invalidNumCallBack = function(field, value) {
        dispatch({
            field: field,
            value: value
        });
    };
    var resetInvalidField = function() {
        dispatch({
            field: "hasInvalidFields",
            value: false
        });
        invalidNumCallBack("phoneNumberErrMsg", "");
    };
    var unsuccessfulAction = [];
    var invalidNumberAction = [];
    errorFormAnalytics === null || errorFormAnalytics === void 0 ? void 0 : errorFormAnalytics.forEach(function(action) {
        if (action.__typename === "NotificationAnalytics") {
            if (action.description === "Invalid Phone Number omtr event") {
                invalidNumberAction === null || invalidNumberAction === void 0 ? void 0 : invalidNumberAction.push(action);
            } else if (action.description === "Unsuccessful text message omtr event") {
                unsuccessfulAction === null || unsuccessfulAction === void 0 ? void 0 : unsuccessfulAction.push(action);
            }
        }
    });
    var liveAnnounceLoaderMessage = function(messageLevel, messageName) {
        formMessages === null || formMessages === void 0 ? void 0 : formMessages.forEach(function(formMessage) {
            if (formMessage.displayType === "FORM") {
                if (formMessage.level === messageLevel && formMessage.name === messageName) {
                    liveAnnounce(formMessage.text, Level.POLITE);
                }
            }
        });
    };
    React36.useEffect(function() {
        var _data_sendTextToDownloadApp, _data_sendTextToDownloadApp1, _data_sendTextToDownloadApp2, _data_sendTextToDownloadApp3, _data_sendTextToDownloadApp_invalidFields;
        if (!loading && !error && (data === null || data === void 0 ? void 0 : (_data_sendTextToDownloadApp = data.sendTextToDownloadApp) === null || _data_sendTextToDownloadApp === void 0 ? void 0 : _data_sendTextToDownloadApp.messageType) === "SUCCESS") {
            var _data_sendTextToDownloadApp4;
            liveAnnounce(data === null || data === void 0 ? void 0 : (_data_sendTextToDownloadApp4 = data.sendTextToDownloadApp) === null || _data_sendTextToDownloadApp4 === void 0 ? void 0 : _data_sendTextToDownloadApp4.messageBody, Level.POLITE);
            if (state.hasInvalidFields) {
                resetInvalidField();
            }
            customerNotificationActionsExecutor(successActions);
        }
        if (!loading && (data === null || data === void 0 ? void 0 : (_data_sendTextToDownloadApp1 = data.sendTextToDownloadApp) === null || _data_sendTextToDownloadApp1 === void 0 ? void 0 : _data_sendTextToDownloadApp1.messageType) === "SERVICE_ERROR" && !data.sendTextToDownloadApp.invalidFields || error) {
            liveAnnounceLoaderMessage("ERROR" /* ERROR */ , "service_error_msg");
            if (state.hasInvalidFields) {
                resetInvalidField();
            }
            customerNotificationActionsExecutor((submitFormButtonAction === null || submitFormButtonAction === void 0 ? void 0 : submitFormButtonAction.schema) ? submitBtn === null || submitBtn === void 0 ? void 0 : submitBtn.actions : unsuccessfulAction);
        }
        if (!loading && !error && !state.hasInvalidFields && (data === null || data === void 0 ? void 0 : (_data_sendTextToDownloadApp2 = data.sendTextToDownloadApp) === null || _data_sendTextToDownloadApp2 === void 0 ? void 0 : _data_sendTextToDownloadApp2.messageType) === "SERVICE_ERROR" && (data === null || data === void 0 ? void 0 : (_data_sendTextToDownloadApp3 = data.sendTextToDownloadApp) === null || _data_sendTextToDownloadApp3 === void 0 ? void 0 : (_data_sendTextToDownloadApp_invalidFields = _data_sendTextToDownloadApp3.invalidFields) === null || _data_sendTextToDownloadApp_invalidFields === void 0 ? void 0 : _data_sendTextToDownloadApp_invalidFields[0])) {
            dispatch({
                field: "hasInvalidFields",
                value: true
            });
            invalidNumCallBack(data.sendTextToDownloadApp.invalidFields[0], data.sendTextToDownloadApp.messageBody);
            if (invalidNumberAction.length > 0) {
                customerNotificationActionsExecutor(invalidNumberAction);
            } else {
                customerNotificationActionsExecutor((submitFormButtonAction === null || submitFormButtonAction === void 0 ? void 0 : submitFormButtonAction.schema) ? submitBtn === null || submitBtn === void 0 ? void 0 : submitBtn.actions : unsuccessfulAction);
            }
        }
    });
    var context = useBexApi().context;
    var onFormSubmission = function(event) {
        if (formMessages) {
            liveAnnounceLoaderMessage("INFO" /* INFO */ , "info_msg");
        }
        event.preventDefault();
        resetInvalidField();
        textToDownloadMutation({
            variables: {
                context: context,
                placementId: placementId,
                customerInput: {
                    inputs: [
                        {
                            value: state.phoneNumber,
                            type: "phoneNumber"
                        },
                        {
                            value: state.countryCode,
                            type: "countryCode"
                        }
                    ]
                }
            }
        });
    };
    return /* @__PURE__ */ React36.createElement("form", {
        onSubmit: onFormSubmission
    }, /* @__PURE__ */ React36.createElement(UitkSpacing15, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React36.createElement("div", null, formSections.map(function(section, index) {
        return /* @__PURE__ */ React36.createElement(MadMarqueeFormSectionWrapper, {
            data: section,
            key: index,
            formTitle: formTitle
        });
    }))), !loading && !error && (data === null || data === void 0 ? void 0 : (_data_sendTextToDownloadApp = data.sendTextToDownloadApp) === null || _data_sendTextToDownloadApp === void 0 ? void 0 : _data_sendTextToDownloadApp.messageType) === "SUCCESS" && !state.hasInvalidFields && /* @__PURE__ */ React36.createElement(UitkSpacing15, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React36.createElement(UitkText15, {
        size: 300,
        theme: "positive"
    }, data.sendTextToDownloadApp.messageBody)), !loading && !error && (data === null || data === void 0 ? void 0 : (_data_sendTextToDownloadApp1 = data.sendTextToDownloadApp) === null || _data_sendTextToDownloadApp1 === void 0 ? void 0 : _data_sendTextToDownloadApp1.messageType) === "SERVICE_ERROR" && !state.hasInvalidFields && !(data === null || data === void 0 ? void 0 : (_data_sendTextToDownloadApp2 = data.sendTextToDownloadApp) === null || _data_sendTextToDownloadApp2 === void 0 ? void 0 : _data_sendTextToDownloadApp2.invalidFields) && /* @__PURE__ */ React36.createElement(UitkSpacing15, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React36.createElement(UitkText15, {
        size: 300,
        theme: "negative"
    }, data.sendTextToDownloadApp.messageBody)), error && (formMessages === null || formMessages === void 0 ? void 0 : (_formMessages_ = formMessages[0]) === null || _formMessages_ === void 0 ? void 0 : _formMessages_.text) && /* @__PURE__ */ React36.createElement(UitkSpacing15, {
        padding: {
            blockend: "three"
        }
    }, /* @__PURE__ */ React36.createElement(UitkText15, {
        size: 300,
        theme: "negative"
    }, formMessages[0].text)), loading && /* @__PURE__ */ React36.createElement(UitkLoader, {
        isSmall: true
    }), formTitle && /* @__PURE__ */ React36.createElement(UitkText15, {
        size: 200,
        "aria-hidden": true
    }, formTitle));
};
MadMarqueeForm.displayName = "MadMarqueeForm";
// src/components/mad-marquee/mad-marquee-form-wrapper.tsx
var MadMarqueeFormWrapper = function(props) {
    var _formSections_, _formSections__fields, _selectionField_options;
    var formTitle = props.formTitle, formSections = props.formSections, formMessages = props.formMessages, placementId = props.placementId, successFormAnalytics = props.successFormAnalytics, errorFormAnalytics = props.errorFormAnalytics;
    var selectionField = (_formSections_ = formSections[0]) === null || _formSections_ === void 0 ? void 0 : (_formSections__fields = _formSections_.fields) === null || _formSections__fields === void 0 ? void 0 : _formSections__fields.find(function(field) {
        return field.__typename === "NotificationSelectionField";
    });
    var defaultSelectedOption = (_selectionField_options = selectionField.options) === null || _selectionField_options === void 0 ? void 0 : _selectionField_options.find(function(option) {
        return option.selected === true;
    });
    return /* @__PURE__ */ React37.createElement(FormProvider, {
        defaultSelectedOptionVal: (defaultSelectedOption === null || defaultSelectedOption === void 0 ? void 0 : defaultSelectedOption.value) || ""
    }, /* @__PURE__ */ React37.createElement(MadMarqueeForm, {
        formTitle: formTitle,
        formSections: formSections,
        formMessages: formMessages,
        placementId: placementId,
        successFormAnalytics: successFormAnalytics,
        errorFormAnalytics: errorFormAnalytics
    }));
};
MadMarqueeFormWrapper.displayName = "MadMarqueeFormWrapper";
// src/components/mad-marquee/marquee-legal-text-and-link-component.tsx
import React38 from "react";
import { UitkLink as UitkLink9 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing16 } from "uitk-react-spacing";
import { UitkText as UitkText16 } from "uitk-react-text";
var MarqueeLegalTextAndLinkComponent = function(param) {
    var legalText = param.legalText;
    var _legalText_items;
    /* @__PURE__ */ return React38.createElement(React38.Fragment, null, legalText === null || legalText === void 0 ? void 0 : (_legalText_items = legalText.items) === null || _legalText_items === void 0 ? void 0 : _legalText_items.map(function(item, index) {
        /* @__PURE__ */ return React38.createElement("div", {
            key: "text-element-container-".concat(index)
        }, /* @__PURE__ */ React38.createElement(UitkSpacing16, {
            padding: {
                blockstart: "four"
            }
        }, (item === null || item === void 0 ? void 0 : item.__typename) === "NotificationPhraseLinkNode" && (item === null || item === void 0 ? void 0 : item.uri) && item.uri.value ? /* @__PURE__ */ React38.createElement("div", null, /* @__PURE__ */ React38.createElement(UitkLink9, {
            inline: true
        }, /* @__PURE__ */ React38.createElement("a", {
            href: item.uri.value,
            key: "text-element-".concat(index),
            target: "_blank",
            rel: "noopener noreferrer"
        }, item.text))) : /* @__PURE__ */ React38.createElement("div", null, /* @__PURE__ */ React38.createElement(UitkText16, {
            size: 300
        }, " ", item.text, " "))));
    }));
};
// src/components/mad-marquee/mad-marquee.tsx
var MadMarquee = function(props) {
    var _tuneLink_uri, _secondLink_uri;
    var backgroundImageUrl = props.backgroundImageUrl, backgroundImageDescription = props.backgroundImageDescription, heading = props.heading, body = props.body, subBody = props.subBody, formTitle = props.formTitle, formSections = props.formSections, formMessages = props.formMessages, successFormAnalytics = props.successFormAnalytics, errorFormAnalytics = props.errorFormAnalytics, qrCodeUrl = props.qrCodeUrl, qrCodeDesc = props.qrCodeDesc, qrCodeTitle = props.qrCodeTitle, tuneLink = props.tuneLink, secondLink = props.secondLink, revealActions = props.revealActions, referer = props.referer, legalText = props.legalText;
    var customerNotificationActionsExecutor = useNotificationActionExecutor();
    React39.useEffect(function() {
        customerNotificationActionsExecutor(revealActions);
    }, []);
    var onClickButton = function() {
        customerNotificationActionsExecutor(tuneLink.actions);
    };
    var onSecondaryClickButton = function() {
        customerNotificationActionsExecutor(secondLink === null || secondLink === void 0 ? void 0 : secondLink.actions);
    };
    var isLayoutOnRight = backgroundImageDescription === "RIGHT_FULLBLEED_ONE_HALF";
    var regionColumns = 4;
    var placementId = "app_72";
    var isSlim = false;
    var isPromoMarquee = false;
    if (qrCodeUrl && qrCodeDesc) {
        placementId = "app_71";
        regionColumns = 3;
        if (!backgroundImageUrl && !heading && !body) {
            regionColumns = 5;
            isSlim = true;
        }
        if (body && !formSections && qrCodeTitle) {
            regionColumns = 5;
            isSlim = true;
            isPromoMarquee = true;
        }
    }
    var appDownloadLink = createDeepLinkUrl((_tuneLink_uri = tuneLink.uri) === null || _tuneLink_uri === void 0 ? void 0 : _tuneLink_uri.value, referer);
    var secondaryLink = createDeepLinkUrl(secondLink === null || secondLink === void 0 ? void 0 : (_secondLink_uri = secondLink.uri) === null || _secondLink_uri === void 0 ? void 0 : _secondLink_uri.value, referer);
    return /* @__PURE__ */ React39.createElement(Viewport5, null, /* @__PURE__ */ React39.createElement(ViewLarge3, null, /* @__PURE__ */ React39.createElement(UitkCard7, {
        border: true
    }, /* @__PURE__ */ React39.createElement(UitkLayoutGrid6, {
        columns: 3
    }, /* @__PURE__ */ React39.createElement(React39.Fragment, null, backgroundImageUrl && !isLayoutOnRight && /* @__PURE__ */ React39.createElement(UitkLayoutGridItem6, {
        colSpan: 1
    }, /* @__PURE__ */ React39.createElement(UitkFigure6, {
        ratio: UitkFigureAspectRatioType4.R3_2
    }, /* @__PURE__ */ React39.createElement(UitkImage5, {
        placeholderImage: true,
        src: backgroundImageUrl,
        alt: backgroundImageDescription
    }))), /* @__PURE__ */ React39.createElement(UitkLayoutGridItem6, {
        colSpan: backgroundImageUrl ? 2 : 3
    }, /* @__PURE__ */ React39.createElement(UitkCardContentSection5, {
        padded: false
    }, /* @__PURE__ */ React39.createElement(UitkSpacing17, {
        padding: "six"
    }, /* @__PURE__ */ React39.createElement(UitkLayoutGrid6, {
        columns: isSlim ? 6 : 4,
        space: "six"
    }, /* @__PURE__ */ React39.createElement(UitkLayoutGridItem6, {
        alignSelf: isPromoMarquee ? "center" : "start",
        colSpan: regionColumns
    }, /* @__PURE__ */ React39.createElement("div", {
        role: "region",
        "aria-labelledby": "marquee-title"
    }, heading && /* @__PURE__ */ React39.createElement(UitkHeading9, {
        tag: "h2",
        size: 3,
        id: "marquee-title"
    }, heading), body && /* @__PURE__ */ React39.createElement(MadMarqueeSubSection, {
        body: body
    }), subBody && /* @__PURE__ */ React39.createElement(MarqueeSubBodyComponent, {
        subBody: subBody
    }), secondLink && /* @__PURE__ */ React39.createElement(UitkLayoutGrid6, {
        space: "six",
        columns: 6
    }, /* @__PURE__ */ React39.createElement(UitkLayoutGridItem6, {
        colSpan: 3
    }, /* @__PURE__ */ React39.createElement(UitkSpacing17, {
        padding: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React39.createElement("div", null, /* @__PURE__ */ React39.createElement(MarqueeButtonLinkComponent, {
        appDownloadLink: appDownloadLink,
        tuneLink: tuneLink,
        onClickButton: onClickButton
    })))), /* @__PURE__ */ React39.createElement(UitkLayoutGridItem6, {
        alignSelf: "center",
        colSpan: 3
    }, /* @__PURE__ */ React39.createElement(UitkSpacing17, {
        padding: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React39.createElement("div", null, /* @__PURE__ */ React39.createElement(MarqueeSecondaryLinkComponent, {
        secondaryLink: secondaryLink,
        onSecondaryClickButton: onSecondaryClickButton,
        secondLink: secondLink
    }))))), formSections && /* @__PURE__ */ React39.createElement(MadMarqueeFormWrapper, {
        formTitle: formTitle,
        formSections: formSections,
        formMessages: formMessages,
        successFormAnalytics: successFormAnalytics,
        errorFormAnalytics: errorFormAnalytics,
        placementId: placementId
    }), /* @__PURE__ */ React39.createElement(MarqueeLegalTextAndLinkComponent, {
        legalText: legalText
    }))), qrCodeUrl && qrCodeDesc && /* @__PURE__ */ React39.createElement(UitkLayoutGridItem6, {
        colSpan: 1
    }, /* @__PURE__ */ React39.createElement("div", null, qrCodeTitle && /* @__PURE__ */ React39.createElement("div", {
        role: "definition",
        "aria-labelledby": "qrCodeTitle"
    }, /* @__PURE__ */ React39.createElement("input", {
        type: "hidden",
        id: "qrCodeTitle",
        "aria-label": qrCodeTitle
    })), /* @__PURE__ */ React39.createElement(UitkSpacing17, {
        padding: {
            inlinestart: "four"
        }
    }, /* @__PURE__ */ React39.createElement("div", null, /* @__PURE__ */ React39.createElement(UitkFigure6, {
        ratio: UitkFigureAspectRatioType4.R1_1
    }, /* @__PURE__ */ React39.createElement(UitkImage5, {
        src: qrCodeUrl,
        alt: qrCodeDesc
    })))), qrCodeTitle && /* @__PURE__ */ React39.createElement(UitkSpacing17, {
        padding: {
            inlinestart: "four"
        }
    }, /* @__PURE__ */ React39.createElement(UitkHeading9, {
        tag: "h3",
        align: "center",
        size: 7,
        "aria-hidden": "true"
    }, qrCodeTitle)))))))), backgroundImageUrl && isLayoutOnRight && /* @__PURE__ */ React39.createElement(UitkLayoutGridItem6, {
        colSpan: 1
    }, /* @__PURE__ */ React39.createElement(UitkFigure6, {
        ratio: UitkFigureAspectRatioType4.R16_9
    }, /* @__PURE__ */ React39.createElement(UitkImage5, {
        placeholderImage: true,
        src: backgroundImageUrl,
        alt: backgroundImageDescription
    }))))))), /* @__PURE__ */ React39.createElement(ViewMedium5, null, /* @__PURE__ */ React39.createElement(UitkCard7, {
        border: true
    }, /* @__PURE__ */ React39.createElement(UitkLayoutGrid6, {
        columns: 3
    }, /* @__PURE__ */ React39.createElement(React39.Fragment, null, backgroundImageUrl && /* @__PURE__ */ React39.createElement(UitkLayoutGridItem6, {
        colSpan: 1
    }, /* @__PURE__ */ React39.createElement(UitkFigure6, {
        ratio: UitkFigureAspectRatioType4.R3_2
    }, /* @__PURE__ */ React39.createElement(UitkImage5, {
        placeholderImage: true,
        src: backgroundImageUrl,
        alt: backgroundImageDescription
    }))), /* @__PURE__ */ React39.createElement(UitkLayoutGridItem6, {
        colSpan: backgroundImageUrl ? 2 : 3
    }, /* @__PURE__ */ React39.createElement(UitkCardContentSection5, {
        padded: false
    }, /* @__PURE__ */ React39.createElement(UitkSpacing17, {
        padding: "six"
    }, /* @__PURE__ */ React39.createElement("div", {
        role: "region",
        "aria-labelledby": "marquee-title"
    }, /* @__PURE__ */ React39.createElement(UitkHeading9, {
        tag: "h2",
        size: 3,
        id: "marquee-title"
    }, heading), body && /* @__PURE__ */ React39.createElement(MadMarqueeSubSection, {
        body: body
    }), /* @__PURE__ */ React39.createElement(UitkLayoutGrid6, {
        space: "six",
        columns: secondLink ? 6 : 3
    }, /* @__PURE__ */ React39.createElement(UitkLayoutGridItem6, {
        colSpan: isSlim ? 6 : 1
    }, /* @__PURE__ */ React39.createElement(UitkSpacing17, {
        padding: {
            blockstart: isSlim ? "unset" : "six"
        }
    }, /* @__PURE__ */ React39.createElement("div", null, /* @__PURE__ */ React39.createElement(MarqueeButtonLinkComponent, {
        appDownloadLink: appDownloadLink,
        tuneLink: tuneLink,
        onClickButton: onClickButton
    })))), secondLink && /* @__PURE__ */ React39.createElement(UitkLayoutGridItem6, {
        alignSelf: "center",
        colSpan: 1
    }, /* @__PURE__ */ React39.createElement(UitkSpacing17, {
        padding: {
            blockstart: "six"
        }
    }, /* @__PURE__ */ React39.createElement("div", null, /* @__PURE__ */ React39.createElement(MarqueeSecondaryLinkComponent, {
        secondaryLink: secondaryLink,
        onSecondaryClickButton: onSecondaryClickButton,
        secondLink: secondLink
    }))))), /* @__PURE__ */ React39.createElement(MarqueeLegalTextAndLinkComponent, {
        legalText: legalText
    }))))))))), /* @__PURE__ */ React39.createElement(ViewSmall5, null, /* @__PURE__ */ React39.createElement(UitkCard7, {
        border: true
    }, backgroundImageUrl && /* @__PURE__ */ React39.createElement(UitkFigure6, {
        className: "all-image-fit-cover",
        ratio: UitkFigureAspectRatioType4.R3_2
    }, /* @__PURE__ */ React39.createElement(UitkImage5, {
        placeholderImage: true,
        src: backgroundImageUrl,
        alt: backgroundImageDescription
    })), /* @__PURE__ */ React39.createElement(UitkCardContentSection5, {
        padded: false
    }, /* @__PURE__ */ React39.createElement(UitkSpacing17, {
        padding: "six"
    }, /* @__PURE__ */ React39.createElement(UitkLayoutGrid6, {
        columns: 4
    }, /* @__PURE__ */ React39.createElement(UitkLayoutGridItem6, {
        colSpan: 4
    }, /* @__PURE__ */ React39.createElement("div", {
        role: "region",
        "aria-labelledby": "marquee-title"
    }, /* @__PURE__ */ React39.createElement(UitkHeading9, {
        tag: "h2",
        size: 5,
        id: "marquee-title"
    }, heading), body && /* @__PURE__ */ React39.createElement(MadMarqueeSubSection, {
        body: body,
        isMobile: true
    }), /* @__PURE__ */ React39.createElement(UitkSpacing17, {
        padding: {
            blockstart: isSlim ? "unset" : "four"
        }
    }, /* @__PURE__ */ React39.createElement(UitkLayoutFlex13, {
        space: "four",
        direction: "column",
        alignItems: "center"
    }, /* @__PURE__ */ React39.createElement(React39.Fragment, null, /* @__PURE__ */ React39.createElement(UitkLayoutFlexItem12, null, /* @__PURE__ */ React39.createElement(MarqueeButtonLinkComponent, {
        appDownloadLink: appDownloadLink,
        tuneLink: tuneLink,
        onClickButton: onClickButton
    })), secondLink && /* @__PURE__ */ React39.createElement(UitkLayoutFlexItem12, null, /* @__PURE__ */ React39.createElement(UitkSpacing17, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React39.createElement("div", null, /* @__PURE__ */ React39.createElement(MarqueeSecondaryLinkComponent, {
        secondaryLink: secondaryLink,
        onSecondaryClickButton: onSecondaryClickButton,
        secondLink: secondLink
    })))), /* @__PURE__ */ React39.createElement(MarqueeLegalTextAndLinkComponent, {
        legalText: legalText
    }))))))))))));
};
MadMarquee.displayName = "MadMarquee";
// src/components/mad-marquee/mad-marquee-wrapper.tsx
var MadMarqueeWrapper = function(props) {
    var _title_items_, _customQrCode_image, _customQrCode_image1;
    var data = props.data, inputs = props.inputs;
    var optionalContext = inputs.optionalContext, notificationLocation = inputs.notificationLocation;
    var _ref = data || {}, legalText = _ref.legalText, title = _ref.title, body = _ref.body, subBody = _ref.subBody, logo = _ref.logo, links = _ref.links, revealActions = _ref.revealActions, backgroundImage = _ref.backgroundImage, form = _ref.form, customQrCode = _ref.customQrCode;
    if (!logo || !(links === null || links === void 0 ? void 0 : links.length)) {
        return null;
    }
    var heading = ((_title_items_ = title === null || title === void 0 ? void 0 : title.items[0]) === null || _title_items_ === void 0 ? void 0 : _title_items_.text) || "";
    var isCustomMarquee = notificationLocation === "IN_PAGE" /* IN_PAGE */ ;
    if (isCustomMarquee) {
        var _customQrCode_image2, _customQrCode_image3;
        return /* @__PURE__ */ React40.createElement(MarqueeProvider, {
            data: data
        }, /* @__PURE__ */ React40.createElement(CustomInpageMarquee, {
            body: body || null,
            subBody: subBody || null,
            heading: heading,
            backgroundImageUrl: backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.url,
            backgroundImageDescription: backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.description,
            qrCodeUrl: customQrCode === null || customQrCode === void 0 ? void 0 : (_customQrCode_image2 = customQrCode.image) === null || _customQrCode_image2 === void 0 ? void 0 : _customQrCode_image2.url,
            qrCodeDesc: customQrCode === null || customQrCode === void 0 ? void 0 : (_customQrCode_image3 = customQrCode.image) === null || _customQrCode_image3 === void 0 ? void 0 : _customQrCode_image3.description,
            qrCodeTitle: customQrCode === null || customQrCode === void 0 ? void 0 : customQrCode.title,
            tuneLink: links[0],
            secondLink: links[1],
            revealActions: revealActions,
            referer: optionalContext === null || optionalContext === void 0 ? void 0 : optionalContext.referer
        }));
    }
    return /* @__PURE__ */ React40.createElement(MarqueeProvider, {
        data: data
    }, /* @__PURE__ */ React40.createElement(MadMarquee, {
        body: body || null,
        subBody: subBody || null,
        heading: heading,
        backgroundImageUrl: backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.url,
        backgroundImageDescription: backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.description,
        formTitle: (form === null || form === void 0 ? void 0 : form.title) || null,
        formSections: (form === null || form === void 0 ? void 0 : form.sections) || null,
        formMessages: (form === null || form === void 0 ? void 0 : form.feedbackMessages) || null,
        successFormAnalytics: (form === null || form === void 0 ? void 0 : form.successFormAnalytics) || null,
        errorFormAnalytics: (form === null || form === void 0 ? void 0 : form.errorFormAnalytics) || null,
        qrCodeUrl: customQrCode === null || customQrCode === void 0 ? void 0 : (_customQrCode_image = customQrCode.image) === null || _customQrCode_image === void 0 ? void 0 : _customQrCode_image.url,
        qrCodeDesc: customQrCode === null || customQrCode === void 0 ? void 0 : (_customQrCode_image1 = customQrCode.image) === null || _customQrCode_image1 === void 0 ? void 0 : _customQrCode_image1.description,
        qrCodeTitle: customQrCode === null || customQrCode === void 0 ? void 0 : customQrCode.title,
        tuneLink: links[0],
        secondLink: links[1],
        legalText: legalText,
        revealActions: revealActions,
        referer: optionalContext === null || optionalContext === void 0 ? void 0 : optionalContext.referer
    }));
};
// src/components/one-key-banner/one-key-banner-wrapper.tsx
import React42 from "react";
// src/components/one-key-banner/one-key-banner.tsx
import React41 from "react";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard8 } from "uitk-react-cards";
import { UitkLayoutFlex as UitkLayoutFlex14, UitkLayoutFlexItem as UitkLayoutFlexItem13 } from "uitk-react-layout-flex";
import { UitkMark as UitkMark2, UitkMarkTokenSizesList } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing18 } from "uitk-react-spacing";
import { UitkSwitch } from "uitk-react-switch";
import { Level as Level2, liveAnnounce as liveAnnounce2 } from "uitk-react-utils";
var OneKeyBanner = function(param) {
    var checked = param.checked, checkedLabel = param.checkedLabel, toggleEnabledAnnounceMsg = param.toggleEnabledAnnounceMsg, uncheckedLabel = param.uncheckedLabel, toggleDisabledAnnounceMsg = param.toggleDisabledAnnounceMsg, logoUrl = param.logoUrl, logoDescription = param.logoDescription, revealActions = param.revealActions, checkedAnalytics = param.checkedAnalytics, uncheckedAnalytics = param.uncheckedAnalytics, switchHandler = param.switchHandler, backgroundTheme = param.backgroundTheme;
    var customerNotificationActionsExecutor = useNotificationActionExecutor();
    var analyticsTracker = useClickTracker2();
    React41.useEffect(function() {
        customerNotificationActionsExecutor(revealActions);
    }, []);
    var _React41_useState = _slicedToArray(React41.useState(checked), 2), isChecked = _React41_useState[0], setIsChecked = _React41_useState[1];
    var handleOnChange = React41.useCallback(function() {
        if (checkedAnalytics && !isChecked) {
            analyticsTracker(checkedAnalytics.referrerId, checkedAnalytics.linkName);
            if (toggleEnabledAnnounceMsg) {
                setTimeout(function() {
                    return liveAnnounce2(toggleEnabledAnnounceMsg, Level2.POLITE);
                }, 500);
            }
        }
        if (uncheckedAnalytics && isChecked) {
            analyticsTracker(uncheckedAnalytics.referrerId, uncheckedAnalytics.linkName);
            if (toggleDisabledAnnounceMsg) {
                setTimeout(function() {
                    return liveAnnounce2(toggleDisabledAnnounceMsg, Level2.POLITE);
                }, 500);
            }
        }
        setIsChecked(!isChecked);
        switchHandler(!isChecked);
    }, [
        checkedAnalytics,
        uncheckedAnalytics,
        isChecked,
        switchHandler
    ]);
    return /* @__PURE__ */ React41.createElement(UitkCard8, {
        backgroundTheme: getCardTheme(backgroundTheme !== null && backgroundTheme !== void 0 ? backgroundTheme : "PRIMARY" /* PRIMARY */ )
    }, /* @__PURE__ */ React41.createElement(UitkSpacing18, {
        padding: {
            inlinestart: "four"
        }
    }, /* @__PURE__ */ React41.createElement(UitkLayoutFlex14, {
        direction: "row",
        alignItems: "center",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React41.createElement(UitkLayoutFlexItem13, {
        alignSelf: "center"
    }, /* @__PURE__ */ React41.createElement("section", null, /* @__PURE__ */ React41.createElement(UitkSpacing18, {
        padding: {
            block: "two"
        }
    }, /* @__PURE__ */ React41.createElement(UitkLayoutFlex14, {
        direction: "row",
        alignItems: "start",
        justifyContent: "space-between"
    }, logoUrl && logoDescription && /* @__PURE__ */ React41.createElement(UitkLayoutFlexItem13, {
        grow: 0,
        shrink: 1
    }, /* @__PURE__ */ React41.createElement(UitkMark2, {
        url: logoUrl,
        description: logoDescription,
        size: UitkMarkTokenSizesList["7"]
    })), checkedLabel && uncheckedLabel && /* @__PURE__ */ React41.createElement(UitkLayoutFlexItem13, {
        alignSelf: "center",
        grow: 1,
        shrink: 1
    }, /* @__PURE__ */ React41.createElement(UitkLayoutFlex14, {
        direction: "column",
        alignItems: "center",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React41.createElement(UitkSpacing18, {
        padding: {
            inline: "four"
        }
    }, /* @__PURE__ */ React41.createElement(UitkSwitch, {
        id: "SwitchLabelTrailing",
        switchPosition: "trailing",
        checked: isChecked,
        onChange: handleOnChange,
        label: isChecked ? checkedLabel : uncheckedLabel,
        labelClassName: "uitk-type-400 uitk-type-medium"
    })))))))))));
};
OneKeyBanner.displayName = "OneKeyBanner";
// src/components/one-key-banner/one-key-banner-wrapper.tsx
var MemoizedConfigurableBanner2 = React42.memo(ConfigurableBanner);
var OneKeyWrapper = function(props) {
    var data = props.data, switchHandler = props.switchHandler, useRewards = props.useRewards, inputs = props.inputs;
    var _ref = data || {}, type = _ref.type, notificationLocation = _ref.notificationLocation, title = _ref.title, logo = _ref.logo, dismiss = _ref.dismiss, revealActions = _ref.revealActions, links = _ref.links, containerLink = _ref.containerLink, body = _ref.body, subBody = _ref.subBody, icon = _ref.icon, customQrCode = _ref.customQrCode, theme = _ref.theme;
    var switchData = data.switch;
    var isToggleOneKey = !!switchData;
    var backupHandler = function(isChecked) {
        return isChecked;
    };
    var checked = (switchData === null || switchData === void 0 ? void 0 : switchData.checked) === true && useRewards === true;
    var backgroundTheme = (theme === null || theme === void 0 ? void 0 : theme.__typename) === "NotificationCardTheme" ? theme === null || theme === void 0 ? void 0 : theme.themeValue : null;
    var border = (theme === null || theme === void 0 ? void 0 : theme.__typename) === "NotificationCardTheme" ? theme === null || theme === void 0 ? void 0 : theme.cardBorder : false;
    var memoizedConfigurableData = React42.useMemo(function() {
        var _inputs_optionalContext;
        return {
            type: type,
            notificationLocation: notificationLocation,
            title: title,
            revealActions: revealActions,
            logo: logo,
            links: links,
            containerLink: containerLink,
            dismiss: dismiss,
            referer: (_inputs_optionalContext = inputs.optionalContext) === null || _inputs_optionalContext === void 0 ? void 0 : _inputs_optionalContext.referer,
            body: body,
            subBody: subBody,
            icon: icon,
            qrCode: customQrCode,
            backgroundTheme: backgroundTheme,
            border: border
        };
    }, []);
    return /* @__PURE__ */ React42.createElement(React42.Fragment, null, isToggleOneKey ? /* @__PURE__ */ React42.createElement(OneKeyBanner, {
        checked: checked,
        checkedLabel: switchData === null || switchData === void 0 ? void 0 : switchData.checkedLabel,
        toggleEnabledAnnounceMsg: switchData === null || switchData === void 0 ? void 0 : switchData.checkedAccessibilityLabel,
        uncheckedLabel: switchData === null || switchData === void 0 ? void 0 : switchData.uncheckedLabel,
        toggleDisabledAnnounceMsg: switchData === null || switchData === void 0 ? void 0 : switchData.uncheckedAccessibilityLabel,
        logoUrl: logo === null || logo === void 0 ? void 0 : logo.url,
        logoDescription: logo === null || logo === void 0 ? void 0 : logo.description,
        revealActions: revealActions,
        checkedAnalytics: switchData === null || switchData === void 0 ? void 0 : switchData.checkedAnalytics,
        uncheckedAnalytics: switchData === null || switchData === void 0 ? void 0 : switchData.uncheckedAnalytics,
        switchHandler: switchHandler || backupHandler,
        backgroundTheme: backgroundTheme
    }) : /* @__PURE__ */ React42.createElement(MemoizedConfigurableBanner2, _objectSpread({}, memoizedConfigurableData)));
};
// src/components/onetrust/onetrust-wrapper.tsx
import React44 from "react";
// src/components/onetrust/onetrust.tsx
import React43 from "react";
import { useLogger } from "@shared-ui/logger-context";
// src/components/onetrust/helpers/onetrust-banner-helpers.tsx
var ONETRUST_SCRIPT_ID = "cust-notif-onetrust-script";
var CAN_SELL_COOKIE_VALUE_ATTRIBUTE_KEY = "canSellCookieValue";
var SHOULD_RELOAD_ON_ACCEPT = "shouldReloadOnAccept";
var createScript = function(oneTrustUrl, domainId) {
    var envId = window.location.hostname.includes("karmalab") || window.location.hostname.includes("localhost") ? "-test" : "";
    var script = document.createElement("script");
    script.src = oneTrustUrl;
    script.id = ONETRUST_SCRIPT_ID;
    script.setAttribute("data-domain-script", "".concat(domainId).concat(envId));
    script.type = "text/javascript";
    script.setAttribute("data-document-language", "true");
    script.setAttribute("charset", "UTF-8");
    return script;
};
var createCookieBlockingScript = function(blockingScriptUrl) {
    var script = document.createElement("script");
    script.src = blockingScriptUrl;
    script.id = ONETRUST_SCRIPT_ID;
    script.type = "text/javascript";
    script.setAttribute("data-document-language", "true");
    return script;
};
var formatActiveGroups = function(groups) {
    return groups.split(",").filter(function(item) {
        return item.length > 0;
    });
};
var findAttribute = function(attributes, key) {
    if (attributes) {
        var _attributes_find;
        return (_attributes_find = attributes.find(function(attribute) {
            return attribute.name && attribute.name === key;
        })) === null || _attributes_find === void 0 ? void 0 : _attributes_find.value;
    }
    return void 0;
};
var setOptInEGCookies = function(optInUrl, shouldReloadOnAccept, logger) {
    fetch(optInUrl, {
        method: "POST"
    }).then(function(res) {
        if (res.ok || res.redirected) {
            if (shouldReloadOnAccept === "true") {
                window.location.reload();
            }
        } else {
            throw new Error("OT_OIP_REQUEST_FAILED" /* OT_OIP_REQUEST_FAILED */ );
        }
    }).catch(function(err) {
        logger(err);
    });
};
var setOptOutEGCookies = function(optOutUrl, logger) {
    fetch(optOutUrl, {
        method: "POST"
    }).then(function(res) {
        if (res.ok || res.redirected) {} else {
            throw new Error("OT_OIP_REQUEST_FAILED" /* OT_OIP_REQUEST_FAILED */ );
        }
    }).catch(function(err) {
        logger(err);
    });
};
var registerOnetrustHandlers = function(attributes, logger) {
    try {
        var OIP = attributes === null || attributes === void 0 ? void 0 : attributes[2].value;
        var OIP_CCPA = findAttribute(attributes, CAN_SELL_COOKIE_VALUE_ATTRIBUTE_KEY);
        var optInUrl = attributes === null || attributes === void 0 ? void 0 : attributes[3].value;
        var optOutUrl = attributes === null || attributes === void 0 ? void 0 : attributes[4].value;
        var CATEGORIES = attributes === null || attributes === void 0 ? void 0 : attributes[5].value.split("|");
        var cookieGroupsActive = window.OnetrustActiveGroups ? formatActiveGroups(window.OnetrustActiveGroups) : [];
        var shouldReloadOnAccept = findAttribute(attributes, SHOULD_RELOAD_ON_ACCEPT);
        var consented = CATEGORIES.every(function(element) {
            return cookieGroupsActive.includes(element);
        });
        if (OIP === "gdpr|-1" || OIP === "null" && OIP_CCPA === "null") {
            if (consented) {
                setOptInEGCookies(optInUrl, shouldReloadOnAccept, logger);
            } else {
                setOptOutEGCookies(optOutUrl, logger);
            }
        } else if ((OIP === "gdpr|0" || OIP_CCPA === "ccpa|0") && consented) {
            setOptInEGCookies(optInUrl, shouldReloadOnAccept, logger);
        } else if ((OIP === "gdpr|1" || OIP_CCPA === "ccpa|1") && !consented) {
            setOptOutEGCookies(optOutUrl, logger);
        }
    } catch (err) {
        logger("OT_OIP_REQUEST_FAILED" /* OT_OIP_REQUEST_FAILED */ , err);
    }
};
// src/components/onetrust/onetrust.tsx
var USER_ID_ATTRIBUTE_NAME = "OneTrustUserId";
var USER_ID_ENCODED_ATTRIBUTE_NAME = "OneTrustUserIdEncoded";
var SHOULD_AUTO_OPEN_PREFS_ATTRIBUTE_NAME = "ShouldAutoOpenPrefs";
var Onetrust = function(props) {
    var onetrustAttributes = props.onetrustAttributes;
    var _useLogger = useLogger(), logError = _useLogger.error;
    var _React43_useState = _slicedToArray(React43.useState(false), 2), isInitilizing = _React43_useState[0], setIsInitilizing = _React43_useState[1];
    var scriptUrl;
    var domainId;
    var blockingScriptUrl;
    if (onetrustAttributes) {
        var _onetrustAttributes_, _onetrustAttributes_1, _onetrustAttributes_2;
        scriptUrl = onetrustAttributes === null || onetrustAttributes === void 0 ? void 0 : (_onetrustAttributes_ = onetrustAttributes[0]) === null || _onetrustAttributes_ === void 0 ? void 0 : _onetrustAttributes_.value;
        domainId = onetrustAttributes === null || onetrustAttributes === void 0 ? void 0 : (_onetrustAttributes_1 = onetrustAttributes[1]) === null || _onetrustAttributes_1 === void 0 ? void 0 : _onetrustAttributes_1.value;
        blockingScriptUrl = onetrustAttributes === null || onetrustAttributes === void 0 ? void 0 : (_onetrustAttributes_2 = onetrustAttributes[6]) === null || _onetrustAttributes_2 === void 0 ? void 0 : _onetrustAttributes_2.value;
    }
    var userIdAttribute = findAttribute(onetrustAttributes, USER_ID_ATTRIBUTE_NAME);
    var userIdEncodedAttribute = findAttribute(onetrustAttributes, USER_ID_ENCODED_ATTRIBUTE_NAME);
    var shouldAutoOpenPrefsAttribute = findAttribute(onetrustAttributes, SHOULD_AUTO_OPEN_PREFS_ATTRIBUTE_NAME);
    var shouldAddCrossDeviceUserData = userIdAttribute && userIdEncodedAttribute && userIdAttribute !== "-1" && userIdEncodedAttribute !== "null";
    React43.useEffect(function() {
        var onInitWrapper = function() {
            var _window_OneTrust, _window_OneTrust1;
            if (window === null || window === void 0 ? void 0 : (_window_OneTrust = window.OneTrust) === null || _window_OneTrust === void 0 ? void 0 : _window_OneTrust.OnConsentChanged) {
                window.OneTrust.OnConsentChanged(function() {
                    registerOnetrustHandlers(onetrustAttributes, logError);
                });
            } else {
                logError("ERROR_LOAD_OT_NOT_DEFINED_ON_INIT" /* ERROR_LOAD_OT_NOT_DEFINED_ON_INIT */ );
            }
            if (shouldAutoOpenPrefsAttribute === "true" && (window === null || window === void 0 ? void 0 : (_window_OneTrust1 = window.OneTrust) === null || _window_OneTrust1 === void 0 ? void 0 : _window_OneTrust1.ToggleInfoDisplay)) {
                window.OneTrust.ToggleInfoDisplay();
            }
        };
        if (!isInitilizing) {
            setIsInitilizing(true);
            if (!document.getElementById(ONETRUST_SCRIPT_ID) && scriptUrl && domainId && !window.OneTrust) {
                if (shouldAddCrossDeviceUserData) {
                    window.OneTrust = {
                        dataSubjectParams: {
                            id: userIdAttribute,
                            isAnonymous: false,
                            token: userIdEncodedAttribute
                        }
                    };
                }
                window.OptanonWrapper = onInitWrapper;
                if (blockingScriptUrl) {
                    document.head.appendChild(createCookieBlockingScript(blockingScriptUrl));
                }
                document.head.appendChild(createScript(scriptUrl, domainId));
            } else {
                logError("ERROR_LOADING_OT_MISSING_PARAMS" /* ERROR_LOADING_OT_MISSING_PARAMS */ );
            }
        }
    }, [
        isInitilizing,
        logError,
        scriptUrl,
        domainId,
        onetrustAttributes,
        blockingScriptUrl,
        shouldAddCrossDeviceUserData,
        userIdAttribute,
        userIdEncodedAttribute,
        shouldAutoOpenPrefsAttribute
    ]);
    return null;
};
// src/components/onetrust/onetrust-wrapper.tsx
var OnetrustWrapper = function(param) {
    var data = param.data;
    var _attributes_;
    var attributes = (data || {}).attributes;
    var onetrustBannerUrl = attributes === null || attributes === void 0 ? void 0 : (_attributes_ = attributes[0]) === null || _attributes_ === void 0 ? void 0 : _attributes_.value;
    if (!onetrustBannerUrl) {
        return null;
    }
    return /* @__PURE__ */ React44.createElement(Onetrust, {
        onetrustAttributes: attributes === null || attributes === void 0 ? void 0 : attributes.map(function(attribute) {
            return {
                name: attribute.name,
                value: attribute.value
            };
        })
    });
};
// src/components/osano-banner/osano-banner-wrapper.tsx
import React46 from "react";
// src/components/osano-banner/osano-banner.tsx
import React45 from "react";
import { useLogger as useLogger2 } from "@shared-ui/logger-context";
import { useProvidedState } from "@shared-ui/provided-state-context";
// src/components/osano-banner/helpers/osano-banner-helpers.ts
var OSANO_SCRIPT_ID = "cust-notif-osano-script";
var SHOULD_RELOAD_ON_ACCEPT2 = "shouldReloadOnAccept";
function getOsanoFromDOM() {
    if (typeof window !== "undefined") {
        if (window === null || window === void 0 ? void 0 : window.Osano) {
            return window.Osano;
        }
    }
    return void 0;
}
var makeScript = function(javascriptUrl, langId) {
    var templateOverride = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "three", onScriptLoad = arguments.length > 3 ? arguments[3] : void 0;
    var script = document.createElement("script");
    script.src = "".concat(javascriptUrl, "?language=").concat(langId, "&variant=").concat(templateOverride);
    script.id = OSANO_SCRIPT_ID;
    script.onload = onScriptLoad;
    return script;
};
var makeStyle = function() {
    var sheet = document.createElement("style");
    sheet.innerHTML = ".osano-cm-widget{display: none;}";
    return sheet;
};
var setCookieLink = function(linkText) {
    var cookieLink = document.querySelector(".osano-cm-link");
    if (cookieLink) {
        cookieLink.innerHTML = linkText;
    }
};
var findAttribute2 = function(attributes, key) {
    if (attributes) {
        var _attributes_find;
        return (_attributes_find = attributes.find(function(attribute) {
            return attribute.name && attribute.name === key;
        })) === null || _attributes_find === void 0 ? void 0 : _attributes_find.value;
    }
    return void 0;
};
var setOptInEGCookies2 = function(optInUrl, shouldReloadOnAccept, logger) {
    fetch(optInUrl, {
        method: "POST"
    }).then(function(res) {
        if (res.ok || res.redirected) {
            if (shouldReloadOnAccept === "true") {
                window.location.reload();
            }
        } else {
            throw new Error("OIP_REQUEST_FAILED" /* OIP_REQUEST_FAILED */ );
        }
    }).catch(function(err) {
        logger("OSANO_OPT_IN_REQUEST_FAILED" /* OSANO_OPT_IN_REQUEST_FAILED */ , err);
    });
};
var setOptOutEGCookies2 = function(optOutUrl, logger) {
    fetch(optOutUrl, {
        method: "POST"
    }).then(function(res) {
        if (res.ok || res.redirected) {} else {
            throw new Error("OIP_REQUEST_FAILED" /* OIP_REQUEST_FAILED */ );
        }
    }).catch(function(err) {
        logger("OSANO_OPT_OUT_REQUEST_FAILED" /* OSANO_OPT_OUT_REQUEST_FAILED */ , err);
    });
};
var registerOsanoHandlers = function(cm, osanoAttributes, logger) {
    var handleConsent = function(consentObject) {
        if (consentObject) {
            try {
                var OIP = osanoAttributes === null || osanoAttributes === void 0 ? void 0 : osanoAttributes[3].value;
                var optInUrl = osanoAttributes === null || osanoAttributes === void 0 ? void 0 : osanoAttributes[4].value;
                var optOutUrl = osanoAttributes === null || osanoAttributes === void 0 ? void 0 : osanoAttributes[5].value;
                var CATEGORIES = osanoAttributes === null || osanoAttributes === void 0 ? void 0 : osanoAttributes[6].value.split("|");
                var shouldReloadOnAccept = findAttribute2(osanoAttributes, SHOULD_RELOAD_ON_ACCEPT2);
                var categoriesAccepted = CATEGORIES.every(function(category) {
                    return consentObject[category] === "ACCEPT";
                });
                if (OIP === "gdpr|-1") {
                    if (categoriesAccepted) {
                        setOptInEGCookies2(optInUrl, shouldReloadOnAccept, logger);
                    } else {
                        setOptOutEGCookies2(optOutUrl, logger);
                    }
                } else if (OIP === "gdpr|0" && categoriesAccepted) {
                    setOptInEGCookies2(optInUrl, shouldReloadOnAccept, logger);
                } else if (OIP === "gdpr|1" && !categoriesAccepted) {
                    setOptOutEGCookies2(optOutUrl, logger);
                }
            } catch (err) {
                logger("OSANO_CM_SAVED_EVENT_FAILED" /* OSANO_CM_SAVED_EVENT_FAILED */ , err);
            }
        }
    };
    cm.addEventListener("osano-cm-initialized", function(consentObject) {
        return handleConsent(consentObject);
    });
    cm.addEventListener("osano-cm-consent-saved", function(consentObject) {
        return handleConsent(consentObject);
    });
};
// src/components/osano-banner/osano-banner.tsx
var TEMPLATE_OVERRIDE = "templateOverride";
var OsanoBanner = function(props) {
    var _osanoAttributes_, _osanoAttributes_1, _osanoAttributes_2;
    var osanoAttributes = props.osanoAttributes;
    var _useLogger2 = useLogger2(), logError = _useLogger2.error;
    var _React45_useState = _slicedToArray(React45.useState(), 2), osanoBanner = _React45_useState[0], setOsanoBanner = _React45_useState[1];
    var _React45_useState1 = _slicedToArray(React45.useState(false), 2), isInitilizing = _React45_useState1[0], setIsInitilizing = _React45_useState1[1];
    var _useProvidedState = _slicedToArray(useProvidedState(), 2), dispatch = _useProvidedState[1];
    var osanoBannerUrl = osanoAttributes === null || osanoAttributes === void 0 ? void 0 : (_osanoAttributes_ = osanoAttributes[0]) === null || _osanoAttributes_ === void 0 ? void 0 : _osanoAttributes_.value;
    var osanoBannerLocale = osanoAttributes === null || osanoAttributes === void 0 ? void 0 : (_osanoAttributes_1 = osanoAttributes[1]) === null || _osanoAttributes_1 === void 0 ? void 0 : _osanoAttributes_1.value;
    var cookieLinkText = (osanoAttributes === null || osanoAttributes === void 0 ? void 0 : (_osanoAttributes_2 = osanoAttributes[2]) === null || _osanoAttributes_2 === void 0 ? void 0 : _osanoAttributes_2.name) || "";
    var templateOverride = findAttribute2(osanoAttributes, TEMPLATE_OVERRIDE);
    var dispatchInitialized = function() {
        dispatch({
            type: "osanoInitialized" /* OsanoInitialized */ 
        });
    };
    var onScriptLoad = function() {
        var osano = getOsanoFromDOM();
        if (osano) {
            osano.cm.locale = osanoBannerLocale;
            setCookieLink(cookieLinkText);
            registerOsanoHandlers(osano.cm, osanoAttributes, logError);
        } else {
            logError("NO_VALID_OSANO_SCRIPT_FOUND" /* NO_VALID_OSANO_SCRIPT_FOUND */ );
        }
    };
    React45.useEffect(function() {
        if (!osanoBanner && !document.getElementById(OSANO_SCRIPT_ID)) {
            if (!isInitilizing && osanoBannerUrl && osanoBannerLocale && !getOsanoFromDOM()) {
                document.head.appendChild(makeScript(osanoBannerUrl, osanoBannerLocale, templateOverride, onScriptLoad));
                document.head.appendChild(makeStyle());
                setIsInitilizing(true);
            } else {
                var instance = getOsanoFromDOM();
                if (instance) {
                    setOsanoBanner(instance);
                    dispatchInitialized();
                }
            }
        }
    }, [
        isInitilizing,
        logError,
        osanoAttributes,
        dispatchInitialized,
        osanoBanner,
        osanoBannerUrl,
        osanoBannerLocale,
        cookieLinkText,
        templateOverride,
        onScriptLoad
    ]);
    return null;
};
// src/components/osano-banner/osano-banner-wrapper.tsx
var OsanoBannerWrapper = function(param) {
    var data = param.data;
    var _attributes_;
    var attributes = (data || {}).attributes;
    var osanoBannerUrl = attributes === null || attributes === void 0 ? void 0 : (_attributes_ = attributes[0]) === null || _attributes_ === void 0 ? void 0 : _attributes_.value;
    if (!osanoBannerUrl) {
        return null;
    }
    return /* @__PURE__ */ React46.createElement(OsanoBanner, {
        osanoAttributes: attributes === null || attributes === void 0 ? void 0 : attributes.map(function(attribute) {
            return {
                name: attribute.name,
                value: attribute.value
            };
        })
    });
};
// src/components/takeover-banner/takeover-banner-wrapper.tsx
import React48 from "react";
// src/components/takeover-banner/takeover-banner.tsx
import React47 from "react";
import { useApolloClient as useApolloClient5 } from "@apollo/client";
import { UitkButtonSize as UitkButtonSize9, UitkOverlayButton as UitkOverlayButton5, UitkPrimaryButton as UitkPrimaryButton5 } from "uitk-react-button";
import { UitkIcon as UitkIcon7 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex15, UitkLayoutFlexItem as UitkLayoutFlexItem14 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink10 } from "uitk-react-link";
import { UitkSpacing as UitkSpacing19 } from "uitk-react-spacing";
import { UitkText as UitkText17 } from "uitk-react-text";
import { UitkView, UitkViewRow as UitkViewRow5 } from "uitk-react-view";
var TakeoverBanner = function(param) {
    var type = param.type, notificationLocation = param.notificationLocation, title = param.title, revealActions = param.revealActions, logo = param.logo, bannerLink = param.bannerLink, dismiss = param.dismiss, referer = param.referer, legalText = param.legalText;
    var _bannerLink_uri, _title_items, _legalText_items;
    var _React47_useState = _slicedToArray(React47.useState(true), 2), display = _React47_useState[0], setDisplay = _React47_useState[1];
    var customerNotificationActionsExecutor = useNotificationActionExecutor();
    var cache = useApolloClient5().cache;
    React47.useEffect(function() {
        customerNotificationActionsExecutor(revealActions);
    }, []);
    var onClickDismiss = function() {
        setDisplay(false);
        customerNotificationActionsExecutor(dismiss.actions);
        cacheEviction(cache, type, notificationLocation);
    };
    var onClickButton = function() {
        customerNotificationActionsExecutor(bannerLink === null || bannerLink === void 0 ? void 0 : bannerLink.actions);
    };
    if (!display) {
        return null;
    }
    var deepLinkUrl = createDeepLinkUrl(bannerLink === null || bannerLink === void 0 ? void 0 : (_bannerLink_uri = bannerLink.uri) === null || _bannerLink_uri === void 0 ? void 0 : _bannerLink_uri.value, referer);
    return /* @__PURE__ */ React47.createElement(UitkView, null, /* @__PURE__ */ React47.createElement(UitkSpacing19, {
        padding: "six"
    }, /* @__PURE__ */ React47.createElement(UitkViewRow5, {
        canvasTheme: "brand_promo_primary",
        layout: "fullwidth"
    }, /* @__PURE__ */ React47.createElement(UitkLayoutFlex15, {
        direction: "column",
        blockSize: "full_size",
        justifyContent: "space-between"
    }, /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem14, {
        alignSelf: "end"
    }, /* @__PURE__ */ React47.createElement(UitkOverlayButton5, {
        onClick: onClickDismiss,
        "aria-label": "close"
    }, /* @__PURE__ */ React47.createElement(UitkIcon7, {
        name: "close"
    }))), /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem14, {
        alignSelf: "center"
    }, /* @__PURE__ */ React47.createElement("img", {
        alt: logo.description,
        src: logo.url,
        width: "64",
        height: "64"
    })), /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem14, null, /* @__PURE__ */ React47.createElement(UitkSpacing19, {
        margin: {
            blockstart: "six"
        }
    }, title === null || title === void 0 ? void 0 : (_title_items = title.items) === null || _title_items === void 0 ? void 0 : _title_items.map(function(param, index) {
        var text = param.text;
        return /* @__PURE__ */ React47.createElement(UitkText17, {
            key: "text-element-".concat(index),
            theme: "inverse",
            align: "center",
            size: 700,
            weight: "medium"
        }, text);
    }))), (bannerLink === null || bannerLink === void 0 ? void 0 : bannerLink.uri) && /* @__PURE__ */ React47.createElement(UitkLayoutFlexItem14, {
        alignSelf: "center"
    }, /* @__PURE__ */ React47.createElement(UitkSpacing19, {
        margin: {
            blockstart: "six",
            blockend: "three"
        }
    }, /* @__PURE__ */ React47.createElement(UitkPrimaryButton5, {
        inverse: true,
        href: deepLinkUrl,
        size: UitkButtonSize9.LARGE,
        onClick: onClickButton
    }, bannerLink.text))), legalText === null || legalText === void 0 ? void 0 : (_legalText_items = legalText.items) === null || _legalText_items === void 0 ? void 0 : _legalText_items.map(function(item, index) {
        return (item === null || item === void 0 ? void 0 : item.__typename) === "NotificationPhraseLinkNode" && (item === null || item === void 0 ? void 0 : item.uri) && item.uri.value && /* @__PURE__ */ React47.createElement(UitkLink10, {
            align: "center",
            inline: true
        }, /* @__PURE__ */ React47.createElement("a", {
            href: item.uri.value,
            key: "text-element-".concat(index),
            target: "_blank",
            rel: "noopener noreferrer"
        }, /* @__PURE__ */ React47.createElement(UitkText17, {
            key: "text-element-".concat(index),
            theme: "inverse"
        }, item.text)));
    })))));
};
TakeoverBanner.displayName = "TakeoverBanner";
// src/components/takeover-banner/takeover-banner-wrapper.tsx
var TakeoverBannerWrapper = function(props) {
    var _ref = props || {}, _ref_data = _ref.data, type = _ref_data.type, notificationLocation = _ref_data.notificationLocation, title = _ref_data.title, logo = _ref_data.logo, links = _ref_data.links, dismiss = _ref_data.dismiss, revealActions = _ref_data.revealActions, legalText = _ref_data.legalText, optionalContext = _ref.inputs.optionalContext;
    if (!title || !logo || !dismiss) {
        return null;
    }
    var bannerLink;
    links === null || links === void 0 ? void 0 : links.forEach(function(link) {
        if (link.type === "APP_DOWNLOAD_LINK" /* APP_DOWNLOAD_LINK */ ) {
            bannerLink = link;
        }
    });
    return /* @__PURE__ */ React48.createElement(TakeoverBanner, {
        type: type,
        notificationLocation: notificationLocation,
        title: title,
        logo: logo,
        bannerLink: bannerLink,
        revealActions: revealActions,
        dismiss: dismiss,
        referer: optionalContext === null || optionalContext === void 0 ? void 0 : optionalContext.referer,
        legalText: legalText
    });
};
// src/components/travel-advisory/travel-advisory-wrapper.tsx
import React50 from "react";
// src/components/travel-advisory/travel-advisory.tsx
import React49 from "react";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { useSignalSubscriber } from "@shared-ui/signal-events-context";
import { UitkBanner } from "uitk-react-banner";
import { UitkIcon as UitkIcon8 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex16, UitkLayoutFlexItem as UitkLayoutFlexItem15 } from "uitk-react-layout-flex";
import { UitkLink as UitkLink11 } from "uitk-react-link";
import { UitkList as UitkList3, UitkListItem as UitkListItem3 } from "uitk-react-list";
import { UitkSpacing as UitkSpacing20 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading10, UitkText as UitkText18 } from "uitk-react-text";
var TravelAdvisory = function(props) {
    var heading = props.heading, message = props.message, icon = props.icon, links = props.links, revealActions = props.revealActions, queryInputs = props.queryInputs, actionCallback = props.actionCallback;
    var customerNotificationActionsExecutor = useNotificationActionExecutor();
    var _React49_useState = _slicedToArray(React49.useState(true), 2), display = _React49_useState[0], setDisplay = _React49_useState[1];
    var _useDialog2 = _slicedToArray(useDialog2("multi-advisory-dialog"), 3), isDialogOpen = _useDialog2[0], dialogActions = _useDialog2[1], DialogComponent = _useDialog2[2];
    var onTravelAdvisoryHideSignalReceived = {
        query: {
            type: "TRAVEL_ADVISORY_HIDE" /* TRAVEL_ADVISORY_HIDE */ 
        },
        callback: function() {
            return setDisplay(false);
        }
    };
    useSignalSubscriber([
        onTravelAdvisoryHideSignalReceived
    ]);
    React49.useEffect(function() {
        customerNotificationActionsExecutor(revealActions);
    }, []);
    if (!display) {
        return null;
    }
    var onClickLink = function(link) {
        return function(e) {
            var _link_uri;
            customerNotificationActionsExecutor(link.actions);
            actionCallback === null || actionCallback === void 0 ? void 0 : actionCallback({
                id: link.id,
                notificationType: "TRAVEL_ADVISORY" /* TRAVEL_ADVISORY */ ,
                notificationLocation: queryInputs.notificationLocation,
                notificationLinkType: link.type
            });
            if (!((_link_uri = link.uri) === null || _link_uri === void 0 ? void 0 : _link_uri.value) && link.id !== "open_multi_advisory_popup") {
                e.preventDefault();
                e.stopPropagation();
                setDisplay(false);
            } else if (link.id === "open_multi_advisory_popup") {
                dialogActions.openDialog();
            }
        };
    };
    var dialogActionCallback = function(action) {
        if (action.id === "close_multi_advisory_popup" || action.id === "notification-not-found-error" || action.id === "notification-validation-error" || action.id === "notification-network-error") {
            dialogActions.closeDialog();
        }
        actionCallback === null || actionCallback === void 0 ? void 0 : actionCallback(action);
    };
    var linkComponents = links === null || links === void 0 ? void 0 : links.map(function(link, index) {
        return /* @__PURE__ */ React49.createElement(UitkListItem3, {
            key: index
        }, /* @__PURE__ */ React49.createElement(UitkLink11, {
            onClick: onClickLink(link),
            inline: true
        }, link.uri ? /* @__PURE__ */ React49.createElement("a", {
            href: link.uri.value,
            target: "_blank",
            rel: "noopener noreferrer"
        }, link.text) : /* @__PURE__ */ React49.createElement("button", {
            type: "button"
        }, link.text)));
    });
    return /* @__PURE__ */ React49.createElement(React49.Fragment, null, isDialogOpen && /* @__PURE__ */ React49.createElement(DialogComponent, null, /* @__PURE__ */ React49.createElement(CustomerNotification, {
        inputs: _objectSpreadProps(_objectSpread({}, queryInputs), {
            notificationLocation: "POPUP" /* POPUP */ 
        }),
        actionCallback: dialogActionCallback
    })), /* @__PURE__ */ React49.createElement(UitkBanner, null, /* @__PURE__ */ React49.createElement(UitkSpacing20, {
        padding: {
            block: "one"
        }
    }, /* @__PURE__ */ React49.createElement(UitkLayoutFlex16, {
        alignItems: "center",
        space: "two"
    }, icon && /* @__PURE__ */ React49.createElement(UitkLayoutFlexItem15, null, /* @__PURE__ */ React49.createElement(UitkSpacing20, {
        margin: {
            inlinestart: "four",
            inlineend: "six"
        }
    }, /* @__PURE__ */ React49.createElement(UitkIcon8, {
        name: icon.iconName,
        description: icon.iconDescription,
        title: icon.iconTitle
    }))), /* @__PURE__ */ React49.createElement(UitkLayoutFlexItem15, null, /* @__PURE__ */ React49.createElement("div", null, /* @__PURE__ */ React49.createElement(UitkHeading10, {
        tag: "h4"
    }, heading.heading), /* @__PURE__ */ React49.createElement(UitkText18, null, message), /* @__PURE__ */ React49.createElement(UitkList3, {
        bullet: "no-bullet",
        orientation: "inline"
    }, linkComponents)))))));
};
TravelAdvisory.displayName = "TravelAdvisory";
// src/components/travel-advisory/travel-advisory-wrapper.tsx
var TravelAdvisoryWrapper = function(props) {
    var _title_items, _body_;
    var data = props.data, inputs = props.inputs, actionCallback = props.actionCallback;
    var _ref = data || {}, title = _ref.title, body = _ref.body, links = _ref.links, revealActions = _ref.revealActions, icon = _ref.icon;
    var heading = title === null || title === void 0 ? void 0 : (_title_items = title.items) === null || _title_items === void 0 ? void 0 : _title_items[0].text;
    var accessibilityHeading = title === null || title === void 0 ? void 0 : title.accessibilityLabel;
    var message = body === null || body === void 0 ? void 0 : (_body_ = body[0]) === null || _body_ === void 0 ? void 0 : _body_.items[0].text;
    var possibleLinks = links === null || links === void 0 ? void 0 : links.slice(0, 2);
    var iconName = icon === null || icon === void 0 ? void 0 : icon.id;
    var iconDescription = (icon === null || icon === void 0 ? void 0 : icon.description) || "";
    var iconTitle = (icon === null || icon === void 0 ? void 0 : icon.title) || "";
    if (!message) {
        return null;
    }
    if (!iconName) {
        iconName = "warning";
    }
    return /* @__PURE__ */ React50.createElement(TravelAdvisory, {
        heading: {
            heading: heading,
            accessibilityHeading: accessibilityHeading
        },
        message: message,
        icon: {
            iconName: iconName,
            iconDescription: iconDescription,
            iconTitle: iconTitle
        },
        links: possibleLinks,
        revealActions: revealActions,
        queryInputs: inputs,
        actionCallback: actionCallback
    });
};
// src/components/travel-advisory-dialog/travel-advisory-dialog-wrapper.tsx
import React53 from "react";
// src/components/travel-advisory-dialog/travel-advisory-dialog.tsx
import React52 from "react";
import { UitkSheet as UitkSheet3, UitkSheetContent as UitkSheetContent3 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing21 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading12 } from "uitk-react-text";
import { UitkToolbar } from "uitk-react-toolbar";
// src/components/travel-advisory-dialog/travel-advisory-dialog-item.tsx
import React51 from "react";
import { UitkLink as UitkLink12 } from "uitk-react-link";
import { UitkHeading as UitkHeading11 } from "uitk-react-text";
var TravelAdvisoryDialogItem = function(props) {
    var index = props.index, separator = props.separator, heading = props.heading, message = props.message, possibleLink = props.possibleLink, actionCallback = props.actionCallback;
    var customerNotificationActionsExecutor = useNotificationActionExecutor();
    var onClickLink = function(link) {
        return function() {
            customerNotificationActionsExecutor(link.actions);
            actionCallback === null || actionCallback === void 0 ? void 0 : actionCallback({
                id: link.id,
                notificationType: "TRAVEL_ADVISORY" /* TRAVEL_ADVISORY */ ,
                notificationLocation: "POPUP" /* POPUP */ ,
                notificationLinkType: link.type
            });
        };
    };
    return /* @__PURE__ */ React51.createElement(React51.Fragment, {
        key: index
    }, heading !== "" && /* @__PURE__ */ React51.createElement(UitkHeading11, {
        tag: "h3",
        size: 6
    }, /* @__PURE__ */ React51.createElement("span", {
        "data-stid": "customer-notification__travel-advisory-dialog-messages-heading-".concat(index)
    }, heading)), /* @__PURE__ */ React51.createElement("p", {
        "data-stid": "customer-notification__travel-advisory-dialog-messages-message-".concat(index)
    }, message), possibleLink && possibleLink.__typename === "NotificationPhraseLinkNode" && possibleLink.uri && possibleLink.uri.value && /* @__PURE__ */ React51.createElement(UitkLink12, {
        onClick: onClickLink(possibleLink)
    }, /* @__PURE__ */ React51.createElement("a", {
        href: possibleLink.uri.value,
        target: "_blank",
        rel: "noopener noreferrer",
        "data-stid": "customer-notification__travel-advisory-dialog-messages-link-".concat(index)
    }, possibleLink.text, possibleLink.icon && /* @__PURE__ */ React51.createElement("span", {
        className: "is-visually-hidden"
    }, possibleLink.icon.description))), separator && /* @__PURE__ */ React51.createElement("hr", null));
};
TravelAdvisoryDialogItem.displayName = "TravelAdvisoryDialogItem";
// src/components/travel-advisory-dialog/travel-advisory-dialog.tsx
var TravelAdvisoryDialog = function(props) {
    var heading = props.heading, body = props.body, dismiss = props.dismiss, revealActions = props.revealActions, actionCallback = props.actionCallback;
    var triggerRef = React52.useRef(null);
    var customerNotificationActionsExecutor = useNotificationActionExecutor();
    React52.useEffect(function() {
        customerNotificationActionsExecutor(revealActions);
    }, []);
    var onCloseDialog = function() {
        customerNotificationActionsExecutor(dismiss.actions);
        actionCallback === null || actionCallback === void 0 ? void 0 : actionCallback({
            id: "close_multi_advisory_popup",
            notificationType: "TRAVEL_ADVISORY" /* TRAVEL_ADVISORY */ ,
            notificationLocation: "POPUP" /* POPUP */ ,
            notificationLinkType: "BUTTON" /* BUTTON */ 
        });
    };
    return /* @__PURE__ */ React52.createElement(UitkSheet3, {
        type: "full",
        isVisible: true,
        triggerRef: triggerRef,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React52.createElement(UitkToolbar, {
        navigationContent: {
            onClick: onCloseDialog,
            navIconLabel: dismiss.icon.description,
            navType: "close"
        }
    }), /* @__PURE__ */ React52.createElement(UitkSheetContent3, null, heading && /* @__PURE__ */ React52.createElement(UitkHeading12, {
        tag: "h2",
        size: 3
    }, heading), /* @__PURE__ */ React52.createElement(UitkSpacing21, {
        margin: {
            blockstart: "twelve"
        }
    }, /* @__PURE__ */ React52.createElement("div", {
        "data-stid": "customer-notification__travel-advisory-dialog-messages"
    }, body.map(function(bodyElement, index) {
        return /* @__PURE__ */ React52.createElement(TravelAdvisoryDialogItem, {
            key: index,
            index: index,
            separator: index < body.length - 1,
            heading: bodyElement.items[0].text,
            message: bodyElement.items[1].text,
            possibleLink: bodyElement.items[2],
            actionCallback: actionCallback
        });
    })))));
};
TravelAdvisoryDialog.displayName = "TravelAdvisoryDialog";
// src/components/travel-advisory-dialog/travel-advisory-dialog-wrapper.tsx
var TravelAdvisoryDialogWrapper = function(props) {
    var data = props.data, actionCallback = props.actionCallback;
    var _ref = data || {}, title = _ref.title, body = _ref.body, dismiss = _ref.dismiss, revealActions = _ref.revealActions;
    if (!body || !dismiss) {
        actionCallback === null || actionCallback === void 0 ? void 0 : actionCallback({
            id: "notification-validation-error",
            notificationLocation: "POPUP" /* POPUP */ ,
            notificationType: "TRAVEL_ADVISORY" /* TRAVEL_ADVISORY */ 
        });
        return null;
    }
    return /* @__PURE__ */ React53.createElement(TravelAdvisoryDialog, {
        heading: title === null || title === void 0 ? void 0 : title.items[0].text,
        body: body,
        dismiss: dismiss,
        revealActions: revealActions,
        actionCallback: actionCallback
    });
};
// src/components/trust-message/trust-message-wrapper.tsx
import React55 from "react";
import { ViewLarge as ViewLarge4, ViewMedium as ViewMedium6, Viewport as Viewport6, ViewSmall as ViewSmall6 } from "@shared-ui/viewport-context";
import { UitkLayoutGrid as UitkLayoutGrid7 } from "uitk-react-layout-grid";
import { UitkMarkSize } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing23 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading13, UitkText as UitkText20 } from "uitk-react-text";
// src/components/trust-message/trust-message.tsx
import React54 from "react";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { UitkCard as UitkCard9 } from "uitk-react-cards";
import { UitkIcon as UitkIcon9, UitkIconSize as UitkIconSize4 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex17, UitkLayoutFlexItem as UitkLayoutFlexItem16 } from "uitk-react-layout-flex";
import { UitkLayoutGridItem as UitkLayoutGridItem7 } from "uitk-react-layout-grid";
import { UitkLink as UitkLink13 } from "uitk-react-link";
import { UitkMark as UitkMark3 } from "uitk-react-mark";
import { UitkSpacing as UitkSpacing22 } from "uitk-react-spacing";
import { UitkText as UitkText19 } from "uitk-react-text";
var TrustMessage = function(props) {
    var _body_, _graphicElement_url;
    var graphicElement = props.graphicElement, markSize = props.markSize, title = props.title, body = props.body, links = props.links, layout = props.layout;
    var titleItem = title.egdsItems[0];
    var titleText = "text" in titleItem && titleItem.text;
    var titleTheme = "theme" in titleItem && titleItem.theme || void 0;
    var titleWeight = "weight" in titleItem && titleItem.weight || void 0;
    var bodyItem = body === null || body === void 0 ? void 0 : (_body_ = body[0]) === null || _body_ === void 0 ? void 0 : _body_.egdsItems[0];
    var bodyText = bodyItem && "text" in bodyItem && bodyItem.text;
    var bodyTheme = bodyItem && "theme" in bodyItem && bodyItem.theme || void 0;
    var bodyWeight = bodyItem && "weight" in bodyItem && bodyItem.weight || void 0;
    var analyticsTracker = useClickTracker3();
    var usedTexts = /* @__PURE__ */ React54.createElement(React54.Fragment, null, titleText && /* @__PURE__ */ React54.createElement(UitkText19, {
        align: "left",
        size: 400,
        spacing: "two",
        theme: titleTheme && UitkTextThemeMap[titleTheme],
        weight: titleWeight && UitkTextWeightMap[titleWeight]
    }, titleText), bodyText && /* @__PURE__ */ React54.createElement(UitkText19, {
        align: "left",
        size: 300,
        spacing: "two",
        theme: bodyTheme && UitkTextThemeMap[bodyTheme],
        weight: bodyWeight && UitkTextWeightMap[bodyWeight]
    }, bodyText));
    var usedLinks = links === null || links === void 0 ? void 0 : links.map(function(linkItem, index) {
        var actions = linkItem.actions;
        var actionItem = actions === null || actions === void 0 ? void 0 : actions[0];
        var referrerId = actionItem && "referrerId" in actionItem && actionItem.referrerId || "";
        var description = actionItem && "description" in actionItem && actionItem.description || "";
        var onClickButton = function() {
            if (actions) {
                analyticsTracker(referrerId, description);
            }
        };
        return /* @__PURE__ */ React54.createElement(UitkLayoutFlexItem16, {
            key: index,
            alignSelf: "start"
        }, linkItem.uri && /* @__PURE__ */ React54.createElement(UitkLink13, {
            onClick: onClickButton
        }, /* @__PURE__ */ React54.createElement("a", {
            href: linkItem.uri.value,
            target: "_blank",
            rel: "noreferrer"
        }, linkItem.text)));
    });
    var _graphicElement_theme;
    var usedGraphics = /* @__PURE__ */ React54.createElement(React54.Fragment, null, (graphicElement === null || graphicElement === void 0 ? void 0 : graphicElement.__typename) === "Mark" && /* @__PURE__ */ React54.createElement(UitkMark3, {
        name: graphicElement.id,
        url: (_graphicElement_url = graphicElement.url) === null || _graphicElement_url === void 0 ? void 0 : _graphicElement_url.value,
        description: graphicElement.description,
        size: markSize !== null && markSize !== void 0 ? markSize : 12
    }), (graphicElement === null || graphicElement === void 0 ? void 0 : graphicElement.__typename) === "Icon" && /* @__PURE__ */ React54.createElement(UitkIcon9, {
        id: Math.random().toString(),
        description: graphicElement.description,
        name: graphicElement.id,
        size: graphicElement.size ? UitkIconSize4[graphicElement.size] : UitkIconSize4.MEDIUM,
        theme: (_graphicElement_theme = graphicElement.theme) !== null && _graphicElement_theme !== void 0 ? _graphicElement_theme : void 0,
        spotlight: graphicElement.withBackground ? "positive" : void 0
    }));
    return /* @__PURE__ */ React54.createElement("li", null, /* @__PURE__ */ React54.createElement(UitkLayoutGridItem7, null, /* @__PURE__ */ React54.createElement(UitkCard9, {
        padded: true
    }, /* @__PURE__ */ React54.createElement(UitkLayoutFlex17, {
        alignItems: "center",
        space: "two"
    }, /* @__PURE__ */ React54.createElement(UitkLayoutFlexItem16, null, usedGraphics), layout === "ICON_ON_SIDE" && /* @__PURE__ */ React54.createElement(UitkLayoutFlexItem16, {
        alignSelf: "center"
    }, /* @__PURE__ */ React54.createElement("div", null, usedTexts, links && /* @__PURE__ */ React54.createElement(UitkSpacing22, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React54.createElement(UitkLayoutFlex17, {
        alignItems: "center"
    }, usedLinks))))), layout === "ICON_ON_TOP" && /* @__PURE__ */ React54.createElement(React54.Fragment, null, usedTexts, usedLinks))));
};
TrustMessage.displayName = "TrustMessage";
// src/components/trust-message/trust-message-wrapper.tsx
var TrustMessageWrapper = function(param) {
    var data = param.data;
    var _ref = data || {}, title = _ref.title, subBody = _ref.subBody;
    if (!subBody && !title) {
        return null;
    }
    var titleItem = title === null || title === void 0 ? void 0 : title.egdsItems[0];
    var weightProp = titleItem && "weight" in titleItem && titleItem.weight;
    var themeProp = titleItem && "theme" in titleItem && titleItem.theme;
    var columnNumber = subBody === null || subBody === void 0 ? void 0 : subBody.length;
    var trustMessageCards = subBody === null || subBody === void 0 ? void 0 : subBody.map(function(card, index) {
        var graphicElement = "graphicElement" in card ? card.graphicElement : null;
        var markSize = graphicElement && "markSize" in graphicElement && graphicElement.markSize || UitkMarkSize.LARGE;
        return /* @__PURE__ */ React55.createElement(TrustMessage, {
            key: index,
            title: card.title,
            graphicElement: graphicElement,
            markSize: markSize,
            body: "body" in card ? card.body : null,
            links: "links" in card ? card.links : null,
            layout: "layout" in card ? card.layout : null
        });
    });
    var trustMessageHeading = (title === null || title === void 0 ? void 0 : title.completeText) && /* @__PURE__ */ React55.createElement(UitkText20, {
        weight: weightProp ? UitkTextWeightMap[weightProp] : void 0,
        size: 700,
        theme: themeProp ? UitkTextThemeMap[themeProp] : void 0
    }, titleItem && "text" in titleItem && titleItem.text);
    return /* @__PURE__ */ React55.createElement(React55.Fragment, null, /* @__PURE__ */ React55.createElement(Viewport6, null, /* @__PURE__ */ React55.createElement(ViewSmall6, null, /* @__PURE__ */ React55.createElement(UitkHeading13, {
        size: 3
    }, trustMessageHeading)), /* @__PURE__ */ React55.createElement(ViewMedium6, null, /* @__PURE__ */ React55.createElement(UitkHeading13, {
        size: 4
    }, trustMessageHeading))), subBody && /* @__PURE__ */ React55.createElement(Viewport6, null, /* @__PURE__ */ React55.createElement(ViewSmall6, null, /* @__PURE__ */ React55.createElement(UitkSpacing23, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React55.createElement(UitkLayoutGrid7, {
        columns: 1,
        space: "four",
        tag: "ul"
    }, trustMessageCards))), /* @__PURE__ */ React55.createElement(ViewMedium6, null, /* @__PURE__ */ React55.createElement(UitkSpacing23, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React55.createElement(UitkLayoutGrid7, {
        columns: 2,
        space: "four",
        tag: "ul"
    }, trustMessageCards))), /* @__PURE__ */ React55.createElement(ViewLarge4, null, /* @__PURE__ */ React55.createElement(UitkSpacing23, {
        margin: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React55.createElement(UitkLayoutGrid7, {
        columns: columnNumber,
        space: "four",
        tag: "ul"
    }, trustMessageCards)))));
};
TrustMessageWrapper.displayName = "TrustMessageWrapper";
var _obj6;
// src/components/customer-notification/customer-notification-components-dictionary.ts
var NOTIFICATION_COMPONENTS_DICTIONARY = (_obj6 = {}, _defineProperty(_obj6, "AFTER_HEADER|TRAVEL_ADVISORY" /* TRAVEL_ADVISORY */ , TravelAdvisoryWrapper), _defineProperty(_obj6, "AFTER_WIZARD|CLEANLINESS" /* CLEANLINESS */ , CleanlinessBannerWrapper), _defineProperty(_obj6, "AFTER_WIZARD|GENERIC" /* GENERIC */ , GenericNotificationWrapper), _defineProperty(_obj6, "AFTER_WIZARD|ONE_KEY" /* ONE_KEY */ , OneKeyWrapper), _defineProperty(_obj6, "AFTER_WIZARD|TRAVEL_ADVISORY" /* TRAVEL_ADVISORY */ , TravelAdvisoryWrapper), _defineProperty(_obj6, "FOOTER|MAD_MARQUEE" /* MAD_MARQUEE */ , MadMarqueeWrapper), _defineProperty(_obj6, "IN_PAGE_AD|CITI_COBRAND" /* CITI_COBRAND */ , CitiCobrandAdWrapper), _defineProperty(_obj6, "IN_PAGE_AD|CITI_COBRAND_VERTICAL" /* CITI_COBRAND_VERTICAL */ , CitiCobrandAdWrapper), _defineProperty(_obj6, "IN_PAGE_AD|ONE_KEY" /* ONE_KEY */ , OneKeyWrapper), _defineProperty(_obj6, "IN_PAGE|CONFIGURABLE" /* CONFIGURABLE */ , ConfigurableBannerWrapper), _defineProperty(_obj6, "IN_PAGE|GENERIC" /* GENERIC */ , GenericNotificationWrapper), _defineProperty(_obj6, "IN_PAGE|MAD_MARQUEE" /* MAD_MARQUEE */ , MadMarqueeWrapper), _defineProperty(_obj6, "IN_PAGE|ONE_KEY" /* ONE_KEY */ , OneKeyWrapper), _defineProperty(_obj6, "IN_PAGE|TRUST_MSG_BANNER" /* TRUST_MSG_BANNER */ , TrustMessageWrapper), _defineProperty(_obj6, "LEGAL|OSANO" /* OSANO */ , OsanoBannerWrapper), _defineProperty(_obj6, "LEGAL|ONETRUST" /* ONETRUST */ , OnetrustWrapper), _defineProperty(_obj6, "POPUP|BOTTOM_SHEET" /* BOTTOM_SHEET */ , BottomSheetWrapper), _defineProperty(_obj6, "POPUP|CENTERED_SHEET" /* CENTERED_SHEET */ , CenteredSheetWrapper), _defineProperty(_obj6, "POPUP|TRAVEL_ADVISORY" /* TRAVEL_ADVISORY */ , TravelAdvisoryDialogWrapper), _defineProperty(_obj6, "PRE_HEADER|APP_HERO" /* APP_HERO */ , AppHeroBannerWrapper), _defineProperty(_obj6, "PRE_HEADER|CONFIGURABLE" /* CONFIGURABLE */ , ConfigurableBannerWrapper), _defineProperty(_obj6, "PRE_HEADER|HEADER" /* HEADER */ , HeaderBannerWrapper), _defineProperty(_obj6, "PRE_HEADER|TAKEOVER" /* TAKEOVER */ , TakeoverBannerWrapper), _obj6);
var getCustomerNotificationComponent = function(location, type) {
    return NOTIFICATION_COMPONENTS_DICTIONARY["".concat(location, "|").concat(type)] || null;
};
// src/components/customer-notification/customer-notification-placeholder.tsx
import React56 from "react";
import { UitkCard as UitkCard10, UitkCardContentSection as UitkCardContentSection6 } from "uitk-react-cards";
import { UitkLineSkeleton } from "uitk-react-skeleton";
var CustomerNotificationPlaceholder = function() {
    return /* @__PURE__ */ React56.createElement(React56.Fragment, null, /* @__PURE__ */ React56.createElement(UitkCard10, {
        backgroundTheme: "global-loyalty-standard",
        padded: false,
        "data-stid": "customer-notifications-placeholder"
    }, /* @__PURE__ */ React56.createElement(UitkCardContentSection6, null, /* @__PURE__ */ React56.createElement(UitkLineSkeleton, null)), /* @__PURE__ */ React56.createElement(UitkCardContentSection6, null, /* @__PURE__ */ React56.createElement(UitkLineSkeleton, {
        animation: true,
        type: "secondary"
    }))));
};
// src/components/customer-notification/customer-notification-wrapper.tsx
import React57 from "react";
import { useProvidedState as useProvidedState2 } from "@shared-ui/provided-state-context";
// src/components/customer-notification/state/customer-notification-control-state.ts
var CustomerNotificationStateEvent = /* @__PURE__ */ function(CustomerNotificationStateEvent2) {
    CustomerNotificationStateEvent2["CustomerNotificationNone"] = "customerNotificationNone";
    CustomerNotificationStateEvent2["CustomerNotificationInitialized"] = "customerNotificationInitialized";
    CustomerNotificationStateEvent2["CustomerNotificationError"] = "customerNotificationError";
    return CustomerNotificationStateEvent2;
}(CustomerNotificationStateEvent || {});
var CustomerNotificationControlState = /*#__PURE__*/ function() {
    "use strict";
    function CustomerNotificationControlState() {
        _classCallCheck(this, CustomerNotificationControlState);
        this.data = Object.keys(NotificationLocationOnPage).reduce(function(acc, location) {
            acc[location] = {
                state: "customerNotificationNone" /* CustomerNotificationNone */ ,
                type: "NONE" /* NONE */ 
            };
            return acc;
        }, {});
        this.events = Object.values(CustomerNotificationStateEvent);
        this.stateFieldName = "customerNotificationControlState";
    }
    _createClass(CustomerNotificationControlState, [
        {
            key: "update",
            value: function update(event, currentState, payload) {
                var newState = Object.assign(currentState);
                if (payload.data) {
                    newState[payload.data.location] = {
                        state: event,
                        type: payload.data.type
                    };
                }
                return newState;
            }
        }
    ]);
    return CustomerNotificationControlState;
}();
// src/components/customer-notification/customer-notification-wrapper.tsx
var CustomerNotificationWrapper = function(param) {
    var notificationLocation = param.notificationLocation, notificationType = param.notificationType, children = param.children;
    var _useProvidedState2 = _slicedToArray(useProvidedState2(), 2), dispatch = _useProvidedState2[1];
    React57.useEffect(function() {
        dispatch({
            type: "customerNotificationInitialized" /* CustomerNotificationInitialized */ ,
            payload: {
                location: notificationLocation,
                type: notificationType
            }
        });
    }, [
        dispatch,
        notificationLocation,
        notificationType
    ]);
    return /* @__PURE__ */ React57.createElement(React57.Fragment, null, children);
};
// src/components/customer-notification/helpers/get-optional-context.ts
var stringToDateInput = function(date) {
    if (typeof date === "string") {
        var identifiers = date.split("-").map(function(identifier) {
            return identifier.trim();
        });
        return {
            day: +identifiers[2],
            month: +identifiers[1],
            year: +identifiers[0]
        };
    }
    return date;
};
var getJourneyCriterias = function(customJourneyCriterias) {
    return customJourneyCriterias ? customJourneyCriterias.map(function(journeyCriteria) {
        var _journeyCriteria_dateRange, _journeyCriteria_dateRange1;
        if ((journeyCriteria === null || journeyCriteria === void 0 ? void 0 : (_journeyCriteria_dateRange = journeyCriteria.dateRange) === null || _journeyCriteria_dateRange === void 0 ? void 0 : _journeyCriteria_dateRange.start) && (journeyCriteria === null || journeyCriteria === void 0 ? void 0 : (_journeyCriteria_dateRange1 = journeyCriteria.dateRange) === null || _journeyCriteria_dateRange1 === void 0 ? void 0 : _journeyCriteria_dateRange1.end)) {
            return _objectSpreadProps(_objectSpread({}, journeyCriteria), {
                dateRange: {
                    start: stringToDateInput(journeyCriteria.dateRange.start),
                    end: stringToDateInput(journeyCriteria.dateRange.end)
                }
            });
        }
        return _objectSpread({}, journeyCriteria.origin && {
            origin: journeyCriteria.origin
        }, journeyCriteria.destination && {
            destination: journeyCriteria.destination
        }, journeyCriteria.tripType && {
            tripType: journeyCriteria.tripType
        }, journeyCriteria.scheduleChangeStatus && {
            scheduleChangeStatus: journeyCriteria.scheduleChangeStatus
        }, journeyCriteria.scheduleChangeStatus && {
            scheduleChangeStatus: journeyCriteria.scheduleChangeStatus
        }, journeyCriteria.cabinClass && {
            cabinClass: journeyCriteria.cabinClass
        }, journeyCriteria.travelerDetail && {
            travelerDetail: journeyCriteria.travelerDetail
        }, journeyCriteria.filter && {
            filter: journeyCriteria.filter
        });
    }) : customJourneyCriterias;
};
var decorateOptionalContextWithJourneyCriterias = function(optionalContext) {
    return _objectSpreadProps(_objectSpread({}, optionalContext), {
        journeyCriterias: getJourneyCriterias(optionalContext.journeyCriterias)
    });
};
var getOptionalContextWithoutReferer = function(customOptionalContext) {
    var referer = customOptionalContext.referer, optionalContext = _objectWithoutProperties(customOptionalContext, [
        "referer"
    ]);
    return decorateOptionalContextWithJourneyCriterias(_objectSpread({}, optionalContext));
};
var selectOptionalContext = function(customOptionalContext, pageLocation, notificationLocation) {
    if (customOptionalContext) {
        return notificationLocation === "IN_PAGE" && pageLocation === "CHECKOUT" ? decorateOptionalContextWithJourneyCriterias(customOptionalContext) : getOptionalContextWithoutReferer(customOptionalContext);
    }
    return customOptionalContext;
};
// src/components/customer-notification/query/customer-notification-query.tsx
import { gql as gql3 } from "@apollo/client";
var NotificationQuery = gql3(_templateObject2());
// src/components/customer-notification/customer-notification.tsx
var CustomerNotification = function(param) {
    var _param_inputs = param.inputs, xPageId = _param_inputs.xPageId, notificationLocation = _param_inputs.notificationLocation, optionalContext = _param_inputs.optionalContext, actionCallback = param.actionCallback, _param_skipSsr = param.skipSsr, skipSsr = _param_skipSsr === void 0 ? false : _param_skipSsr, _param_isLoadingUI = param.isLoadingUI, isLoadingUI = _param_isLoadingUI === void 0 ? false : _param_isLoadingUI, switchHandler = param.switchHandler, useRewards = param.useRewards, dismissCallback = param.dismissCallback;
    var _data_notification;
    var context = useBexApi2().context;
    var identity = getIdentity(xPageId);
    var variables = {
        context: context,
        notificationLocation: notificationLocation,
        lineOfBusiness: identity.lineOfBusiness,
        pageLocation: identity.pageLocation,
        optionalPageId: identity.pageId.length > 0 ? identity.pageId : null,
        optionalContext: selectOptionalContext(optionalContext, identity.pageLocation, notificationLocation)
    };
    var _useQuery = useQuery(NotificationQuery, {
        variables: variables,
        ssr: !skipSsr
    }), error = _useQuery.error, data = _useQuery.data, loading = _useQuery.loading;
    var notification = data === null || data === void 0 ? void 0 : (_data_notification = data.notification) === null || _data_notification === void 0 ? void 0 : _data_notification.inlineNotification;
    var notificationType = notification === null || notification === void 0 ? void 0 : notification.type;
    var revealActions = notification === null || notification === void 0 ? void 0 : notification.revealActions;
    var customerNotificationActionsExecutor = useNotificationActionExecutor();
    if (skipSsr && isLoadingUI && loading) {
        return /* @__PURE__ */ React58.createElement(CustomerNotificationPlaceholder, null);
    }
    if (error || !data || !notification || !notificationType) {
        if (error) {
            actionCallback === null || actionCallback === void 0 ? void 0 : actionCallback({
                id: "notification-network-error",
                notificationLocation: notificationLocation,
                notificationType: "NONE" /* NONE */ 
            });
        }
        return null;
    }
    if (notificationType === "NONE" /* NONE */ ) {
        customerNotificationActionsExecutor(revealActions);
        actionCallback === null || actionCallback === void 0 ? void 0 : actionCallback({
            id: "notification-none-value",
            notificationLocation: notificationLocation,
            notificationType: "NONE" /* NONE */ 
        });
        return null;
    }
    var NotificationComponent = getCustomerNotificationComponent(notificationLocation, notificationType);
    if (!NotificationComponent) {
        actionCallback === null || actionCallback === void 0 ? void 0 : actionCallback({
            id: "notification-not-found-error",
            notificationLocation: notificationLocation,
            notificationType: notificationType
        });
        return null;
    }
    return /* @__PURE__ */ React58.createElement(CustomerNotificationWrapper, {
        notificationLocation: notificationLocation,
        notificationType: notificationType
    }, /* @__PURE__ */ React58.createElement(NotificationComponent, {
        data: notification,
        inputs: {
            xPageId: xPageId,
            notificationLocation: notificationLocation,
            optionalContext: optionalContext
        },
        actionCallback: actionCallback,
        switchHandler: switchHandler,
        useRewards: useRewards,
        dismissCallback: dismissCallback
    }));
};
CustomerNotification.displayName = "CustomerNotification";
// src/components/customer-notification/customer-notification-with-entitycontext.tsx
import React60 from "react";
import { useEntityContext } from "@shared-ui/entity-context";
// src/components/customer-notification/customer-notification-styling-wrapper.tsx
import React59 from "react";
import { UitkSpacing as UitkSpacing24 } from "uitk-react-spacing";
var CustomerNotificationStylingWrapper = function(param) {
    var spacing = param.spacing, children = param.children;
    return /* @__PURE__ */ React59.createElement(UitkSpacing24, _objectSpread({}, spacing), /* @__PURE__ */ React59.createElement("div", null, children));
};
CustomerNotificationStylingWrapper.displayName = "CustomerNotificationStylingWrapper";
// src/components/customer-notification/customer-notification-with-entitycontext.tsx
var CustomerNotificationWithEntityContext = function(_param) {
    var children = _param.children, wrapper = _param.wrapper, notificationLocation = _param.notificationLocation, props = _objectWithoutProperties(_param, [
        "children",
        "wrapper",
        "notificationLocation"
    ]);
    var entityContext = useEntityContext("customerNotification");
    var inputs = _objectSpreadProps(_objectSpread({}, entityContext), {
        notificationLocation: notificationLocation
    });
    return /* @__PURE__ */ React60.createElement(CustomerNotificationStylingWrapper, _objectSpread({}, wrapper), /* @__PURE__ */ React60.createElement(CustomerNotification, _objectSpreadProps(_objectSpread({}, props), {
        inputs: inputs
    }), children));
};
CustomerNotificationWithEntityContext.displayName = "CustomerNotificationWithEntityContext";
export { CustomerNotification, CustomerNotificationControlState, NotificationLocationOnPage as CustomerNotificationLocation, CustomerNotificationStateEvent, TripScheduleChangeStatus }; /* istanbul ignore next -- @preserve */ 
//# sourceMappingURL=index.js.map